export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "酒店知識庫",
    "tip": "管理目前酒店的常見問題和答案。",
    "created": "建立時間",
    "updated": "更新時間",
    "to": "至",
    "startDate": "開始日期",
    "endDate": "結束日期",
    "question": "問題",
    "answer": "答案",
    "tags": "標籤",
    "questionSearch": "輸入問題關鍵字",
    "tagSearch": "輸入標籤關鍵字",
    "search": "查詢",
    "reset": "重設",
    "create": "新增",
    "batchDelete": "批次刪除",
    "loadFailed": "載入失敗，請重試",
    "notFilled": "未填寫",
    "actions": "操作",
    "view": "查看全文",
    "edit": "編輯",
    "delete": "刪除",
    "details": "知識詳情",
    "missingTitle": "歷史內容缺失",
    "missingView": "目前記錄的問題或答案未填寫，編輯儲存前必須補全。",
    "missingForm": "問題或答案未填寫，儲存前必須補全。",
    "noDetails": "暫無詳情",
    "close": "關閉",
    "enterQuestion": "請輸入問題",
    "enterAnswer": "請輸入答案",
    "answerPlaceholder": "請輸入答案，支援多行文字",
    "tagPlaceholder": "輸入標籤後按 Enter 新增",
    "tagTip": "按 Enter 新增標籤，標籤不按逗號或空格拆分。標籤總長度最多 512 個字元。",
    "cancel": "取消",
    "save": "儲存",
    "chooseHotel": "請先選擇酒店",
    "empty": "暫無資料",
    "editTitle": "編輯知識",
    "createTitle": "新增知識",
    "tagRequired": "請至少新增一個標籤",
    "tagText": "標籤必須為文字，請刪除後重新新增",
    "tagBlank": "標籤不能為空白，請刪除後重新新增",
    "tagsTooLong": "標籤內容過長，請精簡標籤後重試",
    "questionTooLong": "問題不能超過 512 個字元",
    "answerTooLong": "答案不能超過 5000 個字元",
    "invalidRecord": "記錄資訊異常，請重新開啟編輯",
    "editSuccess": "編輯成功",
    "createSuccess": "新增成功",
    "deleteLimit": "單次最多刪除 100 筆",
    "confirmBatch": "確定刪除目前頁面選取的 {count} 筆知識嗎？刪除後無法復原。",
    "confirmOne": "確定刪除這筆知識嗎？刪除後無法復原。",
    "deleteConfirm": "確認刪除",
    "confirmDelete": "確認刪除",
    "deleteSuccess": "刪除成功",
    "dataChanged": "資料已變更，請重新整理列表後查看"
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "AI用量統計",
    "priceConfig": "房型定價配置",
    "dateRange": "日期範圍",
    "startDate": "開始日期",
    "endDate": "結束日期",
    "scene": "通知類型",
    "all": "全部",
    "callStatus": "調用狀態",
    "callStatusLabel": "調用狀態說明",
    "running": "執行中",
    "success": "成功",
    "failed": "失敗",
    "tokenStatus": "用量資料",
    "tokenStatusLabel": "用量資料說明",
    "known": "已獲取",
    "unknownUsage": "未獲取",
    "query": "查詢",
    "reset": "重設",
    "categoryError": "通知類型載入失敗",
    "retry": "重新載入",
    "chooseHotel": "請先選擇當前酒店",
    "dailyUsage": "每日 AI 用量",
    "noCallsFiltered": "所選條件下暫無調用記錄。",
    "statisticsError": "用量統計載入失敗",
    "loadingTrend": "正在載入趨勢…",
    "details": "調用明細",
    "detailsError": "調用明細載入失敗",
    "loading": "正在載入…",
    "noCalls": "暫無調用記錄",
    "waiting": "等待查詢",
    "callTime": "調用時間",
    "usage": "AI 用量",
    "requestInfo": "請求資訊",
    "requestId": "請求 ID：",
    "requestDetails": "請求詳情",
    "totalUsage": "AI 總用量",
    "callCount": "調用次數",
    "successCount": "調用成功次數",
    "unknownCount": "用量未知次數",
    "today": "今天",
    "last7": "近 7 天",
    "last30": "近 30 天",
    "thisMonth": "本月",
    "pending": "待統計",
    "unknown": "未知",
    "usageLabel": "用量：",
    "callCountLabel": "調用次數：",
    "unknownCountLabel": "用量未知次數：",
    "missingUsage": "存在未獲取統計的調用",
    "usageAxis": "用量",
    "description": "統計當前酒店已記錄的 AI 調用用量，不包含未關聯酒店的聊天記錄。日期按北京時間統計。",
    "callStatusHelp": "執行中、成功、失敗均指平台調用狀態；成功不表示通知已生成。",
    "usageHelp": "已獲取：已有具體用量，包含零用量。未獲取：有調用記錄但用量未知，未計入總用量；與調用成功或失敗無關。",
    "invalidDates": "請選擇有效日期範圍，開始日期不得晚於結束日期，且不能晚於北京時間今天"
  },
  navbar: {
    searchHotel: '搜索酒店名',
    nightAudit: '夜審',
    nightAuditWarning: '酒店正在執行夜審，請稍後重試',
    groupBooking: '團隊預訂',
  },
  common: {
    logo: 'Logo',
    bundleSale: '包棟',
    splitTax: '拆分稅金',
    taxIncluded: '價內稅',
    taxExcluded: '價外稅',
    businessFeeUnit: '業務單位',
    fixedAmount: '固定金額',
    percentage: '百分比',
    pleaseEnter: '請輸入',
    confirmCheckInOutTime: '您預訂的是 {checkIn} 入住的房間，離店時間為 {checkOut}，請確認入住及離店時間',
    tax: '稅',
    expenseWithTax: '消費（含稅）',
    totalProductPrice: '商品總價',
    expenseWithoutTax: '消費金額（不含稅）',
    roomFeeWithoutTax: '房費金額（不含稅）',
    salesAmountWithoutTax: '銷售金額（不含稅）',
    taxIncludedPrice: '稅價',
    title: '輕贏寶酒店管理系統',
    billingCycleType: '账期类型',
    weeklySettlement: '周结算',
    monthlySettlement: '月结算',
    accountReceivablePayment: 'AR賬支付',
    noResults: '沒有找到相關酒店資訊',
    shiftHandover: '交班',
    salesClerk: '營業員',
    currentShift: '當前班次',
    requestFailed: '請求失敗',
    confirmModify: '確認修改',
    operationSuccess: '操作成功！',
    individualBooking: '散客預訂',
    longBooking: '長包房預訂',
    cashPay: '現付',
    cashPayment: '現付帳',
    doorCard: '門卡',
    more: '更多',
    success: '成功',
    close: '關閉',
    loadingEllipsis: '載入中...',
    cancel: '取消',
    printReport: '列印報表',
    printTime: '列印時間',
    businessDay: '營業日',
    operationDate: '操作日期',
    subject: '科目',
    amount: '金額',
    save: '儲存',
    yuan: '元',
    confirm: '確認',
    nextStep: '下一步',
    all: '全部',
    immediateQuery: '立即查詢',
    action: '操作',
    pleaseSelect: '請選擇',
    pleaseInput: '請輸入',
    inputYuan: '請輸入(元)',
    yes: '是',
    no: '否',
    remark: '備註',
    delete: '刪除',
    oneHour: '一小時',
    twoHours: '二小時',
    threeHours: '三小時',
    fourHours: '四小時',
    fiveHours: '五小時',
    sixHours: '六小時',
    sevenHours: '七小時',
    eightHours: '八小時',
    saveSuccess: '儲存成功',
    notice: '提示',
    status: '狀態',
    cancelled: '已取消',
    booked: '已預訂',
    hardLoading: '拼命載入中',
    startDate: '開始日期',
    endDate: '結束日期',
    Deadline: '截止日期',
    name2: '姓名',
    roomNumber: '房間號',
    checkInDate3: '入住日期',
    checkOutDate3: '離店日期',
    unitPrice3: '單價',
    quantity: '數量',
    addBook: '新增帳套',
    bookName: '帳套名稱',
    accountOfConsumption: '消費科目',
    details3: '詳情',
    id: '編號',
    commodityDetail: '商品明細',
    externalDocumentNumber: '外部單據號',
    accountOfPayment2: '付款科目',
    strikeABalance: '沖帳',
    pleaseFillInRemarks2: '請填寫備註',
    search: '搜尋',
    nationality: '國籍',
    sex: '性別',
    male: '男',
    female: '女',
    nation: '民族',
    contactInformation2: '聯絡方式',
    dateOfBirth: '出生日期',
    documentType: '證件類型',
    address2: '住址',
    documentNumber: '證件號碼',
    validityOfVisa: '簽證效期',
    visaType: '簽證類型',
    visaNumber: '簽證號碼',
    pleaseEnterYourIdNumber: '請輸入證件號碼',
    pleaseEnterTheCorrectIdNumber4: '請輸入正確的證件號碼',
    pleaseFillInYourName2: '請填寫姓名',
    pleaseSelectDocumentType: '請選擇證件類型',
    dontWorryAboutGoldMembers2: '輕住黃金會員',
    goEasyOnThePlatinumMembers2: '輕住白金會員',
    lightOnDiamondMembers2: '輕住鑽石會員',
    unregisteredMember: '未註冊會員',
    ok2: '確定',
    issuingAuthority: '發證機關',
    idPhoto: '身分證頭像',
    qingzhuGroup: '輕住集團',
    mobilePhoneNumber: '手機號',
    view: '查看',
    activated: '已啟用',
    nonmember: '非會員',
    coupon: '優惠券',
    ranking5: '排名',
    hotelName4: '酒店名稱',
    isNotSet: '未設定',
    yu: '餘',
    noVacancy: '滿房',
    consumption: '消費',
    refund: '退款',
    iGotIt2: '知道了',
    startANightTrial: '開始夜審',
    operator: '操作員',
    handledBy: '操作人',
    to: '至',
    currentBusinessDay: '當前營業日',
    ok: '確 定',
    morningShift2: '早班',
    middleShift2: '中班',
    nightShift2: '晚班',
    pleaseEnterYourName: '請輸入姓名',
    selectAll: '全選',
    pleaseEnterContent: '請輸入內容',
    serialNumber: '序號',
    address: '地址',
    signatureOfAuthorizer: '批准人簽字',
    signature3: '簽名',
    roomType: '房型',
    dayRate: '當日房價',
    checkInTime: '入住時間',
    checkOutTime: '退房時間',
    settlementAmount: '結算金額',
    hotelAddress: '酒店地址',
    selectDate: '選擇日期',
    selectionTime: '選擇時間',
    cancelCard: '註銷卡',
    thisCardIsEmptyPleaseMakeABusinessCardFirst: '此卡為空卡，請先制卡',
    logoutSuccessful: '註銷成功',
    cardCancellationFailure: '註銷卡失敗',
    contactSupport: '請聯繫技術支援檢查硬體服務是否可用',
    submit: '提交',
    contactPerson6: '聯絡人',
    contactNumber2: '聯絡電話',
    merchant3: '商家',
    Submitsuccessfully: '提交成功',
    smallProgram: '小程序',
    technicalSupport: '技術支援',
    roomBillCheck: '房費帳單核對',
    financialAssistant: '財務助手',
    settlementCycle: '結算週期',
    refundSuccessful: '退款成功',
    beingRefunded: '退款中',
    refundFailure: '退款失敗',
    channel: '渠道',
    cloakroom: '關房',
    infiniteQuantity: '無限量',
    compute: '計算',
    dateOfSale: '銷售日期',
    originalPrice: '原價',
    pleaseEnterTheOriginalPrice: '請輸入原價',
    member: '會員',
    salesAmount: '銷售金額',
    amountOfConsumption: '消費金額',
    protocolUnit: '協議單位',
    subjectDesc: '科目描述',
    qzOrderNo: '輕住訂單號',
    checkInType: '入住類型',
    checkInOutDate: '入離日期',
    channelOrderNo: '渠道單號',
    pleaseEnterTheCorrectPhoneNumber3: '請輸入正確手機號',
    logs: '日誌',
    walkIn: '散客步入',
    businessCardPrintingSuccess: '制卡成功',
    exportSuccessfully2: '匯出成功',
    exportFailure: '匯出失敗',
    other: '其他',
    toBeProcessed: '待處理',
    completed: '已完成',
    commonProduct: '普通產品',
    freeRoomProducts: '免費房產品',
    makeACard: '制卡',
    day: '日',
    points2: '分',
    sunday: '週日',
    monday: '週一',
    tuesday: '週二',
    wednesday: '週三',
    thursday: '週四',
    friday: '週五',
    saturday: '週六',
    lose: '失敗',
    since: '起',
    amountTotal: '合計',
    total: '總計',
    tradeName: '商品名稱',
    itemType: '物品類型',
    orderStatus: '訂單狀態',
    orderNumber: '訂單號',
    anonymousUser: '匿名使用者',
    commentTime: '評論時間',
    merchantReply: '商家回覆',
    recoveryTime: '回覆時間',
    recover: '回覆',
    pleaseWriteAResponseOfAtLeast10Words: '請至少填寫10字以上的回覆',
    replyTextMinimum10Words: '回覆文字最少10個字',
    negativeComment: '差評',
    cancel2: '取 消',
    commentTemplateManagement: '評論模板管理',
    modifiedSuccessfully: '修改成功',
    hygiene: '衛生',
    service: '服務',
    facility: '設施',
    position: '位置',
    appeal: '申訴',
    successfullyDeleted: '刪除成功',
    replySuccessfully2: '回覆成功',
    theMobilePhoneNumberFormatIsIncorrect5: '手機號碼格式錯誤',
    none4: '暫無',
    thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen: '暫未開通此功能，如需開通請點擊開通',
    noCommentsYet: '暫無評論',
    picture: '圖片',
    guestName: '客人姓名',
    handle: '處理',
    edit: '修改',
    type: '類型',
    salesman: '銷售員',
    successfulOperation: '操作成功',
    pleaseEnterTheCompanyName2: '請輸入公司名稱',
    customerType: '客戶類型',
    effective: '有效',
    inVain: '無效',
    forbidden: '禁用',
    enable: '啟用',
    companyName2: '公司名稱',
    favorable2: '優惠',
    day2: '天',
    telephone: '電話',
    pleaseEnterThePhoneNumber: '請輸入電話號碼',
    mailbox: '信箱',
    accountName: '帳戶名稱',
    startTime: '開始時間',
    endTime: '結束時間',
    beingSubmitted: '提交中',
    pleaseSelectGender: '請選擇性別',
    confirmDeletion: '確認刪除',
    letMeThinkItOver: '我再想想',
    theSizeOfTheUploadedPictureCannotExceed: '上傳圖片大小不能超過',
    identificationCard2: '身分證',
    editor: '編輯',
    topLine: '上線',
    downline: '下線',
    validity: '有效期',
    fullDayRoom: '全日房',
    hourlyRoom: '鐘點房',
    append3: '新增',
    immediatelyReduce3: '立即減免',
    activityName2: '活動名稱',
    sort: '分類',
    on: '開啟',
    amountOfGift2: '贈送金額',
    pleaseFillIn2: '請填寫',
    pleaseSelectADate: '請選擇日期',
    roomFeeConsumption: '房費消費',
    selectFile: '選擇檔案',
    uploadFailure: '上傳失敗',
    uploadSuccessfully: '上傳成功',
    print: '列印',
    dateRange: '日期範圍',
    reupload: '重新上傳',
    printBill: '列印帳單',
    cardNumber: '卡號',
    paymentMethod: '付款方式',
    payMethod: '支付方式',
    balance: '餘額',
    membershipCardNumber: '會員卡號',
    birthday: '生日',
    tradingHours: '交易時間',
    enterAMaximumOf50Characters: '最多輸入50個字',
    membersMobileNumber: '會員手機號',
    time: '時間',
    modifyInformation: '修改資訊',
    lengthOfStay: '入住天數',
    roomListNumber: '房單號',
    roomTypeName: '房型名稱',
    settleAccounts: '結帳',
    accountNumber: '入帳帳號',
    paymentRecord: '付款紀錄',
    paymentAmount: '付款金額',
    paymentVerificationCode: '支付驗證碼',
    enterInAnAccount: '入帳',
    pleaseSelectACollectionSet: '請選擇應收帳套',
    pleaseSelectTheAccountNumber: '請選擇入帳帳號',
    pleaseSelectAPaymentMethod: '請選擇付款方式',
    vipSignature: '貴賓簽字',
    amountNotWrittenOff3: '未核銷金額',
    availableCredit3: '可用額度',
    maximumAmount4: '最高額度',
    whetherItIsValidOrNot: '是否有效',
    enabledSuccessfully: '啟用成功',
    disableSuccessfully: '禁用成功',
    roomNumberName: '房號-姓名',
    payment2: '付款',
    operatingTime: '操作時間',
    classes: '班次',
    transfer: '轉帳',
    accountOutstanding2: '未結帳',
    accountClosed: '已結帳',
    rolledOut: '已轉出',
    haveStruckOff: '已沖帳',
    noRoomChargeIsGenerated: '不產生房費',
    date3: '日期',
    itemName4: '物品名稱',
    pleaseEnterRemarks2: '請輸入備註',
    entryAndDepartureTime: '入離時間',
    roomRate: '房價',
    preAuthorizationAmount: '預授權金額',
    room: '房間',
    settlement: '結算',
    pleaseSelectMemberInformation: '請選擇會員資訊',
    pleaseFillInThePaymentVerificationCode: '請填寫支付驗證碼',
    accountNumber3: '帳號',
    successfulEntry: '入帳成功',
    externalOrderNumber: '外部單號',
    transferTo: '轉入',
    beAuthorized: '已授權',
    haveAlreadySettled: '已結算',
    authorizationMode: '授權方式',
    authorizedAmount: '授權金額',
    authorizationTime: '授權時間',
    productType: '產品類型',
    pleaseEnterTheChannelNumber: '請輸入渠道單號',
    derive: '匯出',
    unwritten: '未核銷',
    cancelled3: '已核銷',
    lehuiScanTheCode: '樂惠–掃碼',
    amountOnAccount3: '掛帳金額',
    billingTime5: '掛帳時間',
    nameOfGuest3: '入住人姓名',
    roomNumber3: '房號',
    people: '人數',
    nameOfExpenseItem: '費用項名稱',
    viewDetails: '查看詳情',
    bankOfDeposit: '開戶行',
    bankCardNumber4: '銀行卡號',
    toBeConfirmed2: '待確認',
    rejected: '已駁回',
    adjustmentAmount: '調整金額',
    meituan: '美團',
    totalOrderAmount: '訂單總金額',
    lightSettlementWithMerchants: '輕住與商家結算',
    membershipDistribution: '會員分潤',
    crossStoreRebate: '跨店返佣',
    avoidCommissionSubsidies: '輕住佣金補貼',
    membershipIncentiveSettlement: '會員激勵結算',
    theUnitedStatesGroupDirectlyConnected: '美團直連',
    flyingPigsConnectDirectly: '飛豬直連',
    fullNameOfTheBank4: '開戶行全稱',
    accountBankAbbreviation4: '開戶行簡稱',
    theLocationOfTheBank4: '開戶行所在地',
    pleaseEnterYourFullBankName2: '請輸入開戶行全稱',
    pleaseSelectBankAbbreviation2: '請選擇開戶行簡稱',
    pleaseSelectYourBankLocation2: '請選擇開戶行所在地',
    pleaseEnterYourBankCardNumber2: '請輸入銀行卡號',
    modificationTime2: '修改時間',
    bankExample: '舉例：中國工商銀行XX支行',
    companyNameNote: '註：如為對公帳戶請填寫公司名稱',
    causeOfFailure: '失敗原因',
    pleaseEnterYourPhoneNumber: '請輸入手機號',
    downloadStatement: '下載對帳單',
    operationLog: '操作日誌',
    ctripDirectConnection: '攜程直連',
    directConnectionInTheSameDirection: '同程直連',
    flyingPig: '飛豬',
    ctrip: '携程',
    roomNight: '間夜',
    pictureUpload: '圖片上傳',
    aSinglePictureMustNotBeLargerThan: '單張圖片不得大於',
    checkInRoomType2: '入住房型',
    checkInPerson: '入住人',
    hotelSellingPrice: '酒店售價',
    effectiveDate3: '生效日期',
    viewExamples: '查看示例',
    underReview: '審核中',
    billingType: '開票類型',
    invoiceTitle2: '發票抬頭',
    pleaseEnterTheInvoiceTitle2: '請輸入發票抬頭',
    invoiceHasBeenIssued: '已開票',
    haveBeenCancelled: '已作廢',
    paymentStatus: '支付狀態',
    preferentialPrice: '優惠價',
    gateRate: '門市價',
    availableRoom: '現空房',
    orderableNumber: '可訂數',
    numberOfRoomsReserved: '預訂間數',
    breakfast: '早餐',
    copyOf: '份',
    dailyRate: '每日房價',
    typeOfTouristSource3: '客源類型',
    namephoneNumbermembershipNumber: '姓名／手機號／會員號',
    selectTimePoint5: '選擇時間點',
    externalChannel3: '外部渠道',
    retentionTime3: '保留時間',
    contactName2: '聯絡人姓名',
    numberOfDays: '天數',
    pleaseSelectAProtocolUnit3: '請選擇協議單位',
    pleaseEnterTheNameOfTheExternalChannel2: '請輸入外部渠道名稱',
    pleaseFillInTheMembershipInformation3: '請輸入會員資訊',
    pleaseFillInTheReservationName2: '請輸入預訂人姓名',
    pleaseFillInTheReservationNumber2: '請輸入預訂人手機號',
    theAmountCanOnlyBeEnteredInNumbers2: '金額只能輸入數字',
    noMemberInformationFound: '未查詢到相關會員資訊',
    noProtocolUnitIsQueried2: '未查詢到相關協議單位資訊',
    bulkRepricing: '批量改價',
    totalRoomRate6: '總房價',
    trialCalculationOfHousePrice3: '房價試算',
    free: '免費',
    between: '間',
    upgradeRoomType: '升級房型',
    printOrNot: '是否列印',
    predepartureTime2: '預離時間',
    rooms: '間數',
    averageHousePrice: '平均房價',
    arrivalTime: '預抵時間',
    creationTime: '建立時間',
    advancedSearch: '進階搜尋',
    simpleSearch: '簡單搜尋',
    price: '價格',
    orderTaking: '接單',
    sellingPrice: '售價',
    floorPrice: '底價',
    channelName2: '渠道名稱',
    bookingSuccessful2: '預訂成功',
    checkedIn2: '已入住',
    cancelSuccessfully2: '取消成功',
    sorting: '排序',
    invoiceNumber2: '發票號',
    taxIdentificationNumber: '稅務識別號',
    emailAddress: '電子郵件',
    eTicket: '電子專票',
    eTicket2: '電子普票',
    paperTicket: '紙質專票',
    paperTicket2: '紙質普票',
    void: '作廢',
    teamType: '團隊類型',
    teamName: '團隊名稱',
    markUpAmount: '加價金額',
    productName: '產品名稱',
    lengthOfStay2: '入住時長',
    hours: '小時',
    checkIn: '辦理入住',
    changeRooms: '更換房間',
    rowHouse: '排房',
    printCheckInSlip: '列印入住單',
    proceedWith: '繼續辦理',
    rowHouseSuccess2: '排房成功',
    toCheckIn: '待入住',
    checkedOut: '已退房',
    onAccount: '已掛賬',
    basicInformation: '基礎資訊',
    prepayment: '預付',
    originalHouseType: '原房型',
    seeMore: '查看更多',
    thisRoomSupportsSmartDoorLocks: '該房間支援智慧門鎖',
    listingStatus: '房單狀態',
    checkin: '入住',
    preionization2: '預離',
    weekTitle: '星期',
    thePriceActuallyPaidByTheGuest: '客人實際支付價',
    late3: '晚',
    late4: '日離店',
    nonCancellable2: '不可取消',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    lightweightDistribution: '輕住分銷',
    liveAndTravelLightly: '輕住商旅',
    jingdongDirectLink: '京東直連',
    baiduMapDirectConnection: '百度地圖直連',
    tiktokDirectConnection: '抖音直連',
    ctripSingleStore: '攜程單店',
    agoda: 'Agoda',
    meituanHomestay: '美團民宿',
    tujiaHomestay: '途家民宿',
    booking: 'Booking',
    expedia: 'Expedia',
    preCancelable: '前可取消',
    partialWriteOff: '部分核銷',
    tookEffect: '已生效',
    loseEffectiveness: '失效',
    joinAHouse3: '加入聯房',
    bookingInformation: '預訂資訊',
    pleaseSelectARoom3: '請選擇房間',
    houseInformation: '聯房資訊',
    thereIsNoRowHouse: '間未排房',
    reasonsForChangingRooms3: '換房原因',
    numberOfRooms7: '房間總數',
    typeOfOperation3: '操作類型',
    exchangeAndUpgradeReport2: '換房及升級報表',
    noDataAvailable2: '暫無資料',
    pleaseSelectABusinessDayRange2: '請選擇營業日範圍',
    exportReport: '匯出報表',
    accountName3: '科目名稱',
    aMaximumOf31DaysCanBeQueried: '時間段最多支援31天查詢',
    naturalDay2: '自然日',
    otherConsumption3: '其他消費',
    aggregateConsumption3: '總消費',
    aggregateConsumptionTaxIncluded: '總消費（含稅）',
    materialType: '物品類型',
    materialName: '物品名稱',
    storageTypeSell: '售賣',
    materialCode: '物品編碼',
    materialUnit: '規格單位',
    inStorageNum: '入庫數量',
    outStorageNum: '出庫數量',
    selectTime: '請選擇時間',
    floor: '樓層',
    lumpSumPayment3: '總付款',
    ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay: '大於半日房價的不足全日房價的記全日',
    businessDate: '營業日期',
    calculationFormula: '計算公式',
    manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight: '人工加收房費間夜計算：半日房費0.5間夜，全日房費1間夜',
    halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate: '半日房費：加收金額小於等於房價一半',
    fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn: '全日房費：加收金額大於等於房價，金額超過房價2倍，記2間夜，以此類推',
    rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights: '出租間夜數：不包含免費房、自用房間夜數',
    subtotal: '小計',
    totalOccupancy3: '總房數',
    lettingRate: '出租率',
    inResidenceDate: '在住日期',
    bookingDate: '預訂日期',
    exposureNumber2: '曝光人數',
    numberOfVisitors3: '瀏覽人數',
    onlineChannel3: '線上渠道',
    reasonForDeactivation: '停用原因',
    downTime: '停用時間',
    enterAMaximumOf20Characters: '最多輸入20個字',
    checkInInformation: '入住資訊',
    numberOfRooms6: '房間數',
    totalPrice: '總價',
    paymentInformation2: '付款資訊',
    pleaseSelectAProduct: '請選擇產品',
    viewOrderDetails: '查看訂單詳情',
    automaticallyJumpToOrderDetails: '自動跳轉至訂單詳情',
    addHoming3: '新增同住',
    getVerificationCode: '取得驗證碼',
    pleaseSelectTheNumberOfRoomsFirst: '請先選擇預訂間數',
    theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms: '預訂間數不能大於可訂數',
    pleaseEnterAmount: '請輸入金額',
    makeAReservation: '辦理預訂',
    increaseRoomType: '增加房型',
    deleteRoomType: '刪除房型',
    store: '門店',
    meituanDirectNew: '美團直連新',
    outOfService: '停用',
    smokeFreeOrNot: '是否無菸',
    roomOrientation: '房間朝向',
    windowCondition: '窗戶情況',
    windowed: '有窗',
    windowless: '無窗',
    innerFenestra: '內窗',
    roomCharacteristics: '房間特徵',
    airAndClean: '空淨',
    airViscus: '空髒',
    dendrojing: '住淨',
    astriction: '住髒',
    continuousStaySpecial: '連住特惠',
    orderEarlyAndReduceMore: '早訂多減',
    discountValue: '折',
    select: '選擇',
    becameInvalid: '已失效',
    dateOfOperation: '操作日期',
    promotionalAllocation: '促銷配置',
    promotionManagement: '促銷管理',
    operationContent2: '操作內容',
    turnOnAutomaticDeferral: '開啟自動延價',
    productSetup: '產品設定',
    thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan99998Yuan: '價格不得低於20元，不得高於99998000元',
    iKnow: '我知道了',
    dataSpecification: '資料說明',
    settings: '設定',
    restrictSales: '限售',
    pleaseEnterPrice: '請輸入價格',
    modificationFailure: '修改失敗',
    deletionFailure: '刪除失敗',
    product: '產品',
    pleaseSelectChannel: '請選擇渠道',
    standardProduct: '標準產品',
    bindingSuccessful: '綁定成功',
    lobby: '大廳',
    inventoryQuantity: '庫存數量',
    uploadPictures: '上傳圖片',
    currentlyLimitedTo10Images: '目前限制 10 張圖片',
    pictureSizeMustBeLargerThan: '圖片尺寸需大於',
    warn3: '警告',
    theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck: '當前頁面輸入內容不符合規範，請檢查',
    layer: '層',
    untie: '解綁',
    cipher5: '密碼',
    pleaseEnterYourAccountNumber: '請輸入帳號',
    pleaseEnterPassword4: '請輸入密碼',
    obtainTheSmsVerificationCode: '取得簡訊驗證碼',
    disposition: '配置',
    passwordType: '密碼類型',
    setANewPassword: '設定新密碼',
    pleaseEnterYourNewPassword: '請輸入新密碼',
    confirmPassword: '確認密碼',
    pleaseEnterYourPasswordAgain: '請再次輸入密碼',
    electronicPriceBoard: '電子房價牌',
    operationInstruction: '操作說明',
    cardholder: '持卡人',
    contact: '聯絡人',
    pleaseEnterTheCardholderName: '請輸入持卡人姓名',
    cardholderNameIsRequired: '持卡人姓名必填',
    theCardholderNameMustBe2To5CharactersLong: '持卡人姓名必須為2到5個字',
    remarksRequired: '備註必填',
    selectCardType: '選擇卡類型',
    windowType2: '窗型',
    suspensionOfSale: '停售',
    enterMaterialName: '輸入物品名稱',
    modifyTarget: '修改目標',
    theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth: '建議目標值根據去年同期資料變化趨勢結合上月實際資料進行預估',
    dayUnit: '{day}天',
    checkInOperator: '入住操作員',
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    week: {
      mon: '星期一',
      tue: '星期二',
      wed: '星期三',
      thu: '星期四',
      fri: '星期五',
      sat: '星期六',
      sun: '星期日',
    },
  },
  language: {
    zh: '中文',
    en: 'EN',
    zhHk: '繁体',
    id: 'Indonesian',
    es: 'Español',
    vi: 'Tiếng Việt',
  },
  activitySign: {
    eventDate: '活動日期',
    alreadyRegistered: '已報名',
    signUpActivity: '可報名活動',
    noRegistrationIsAvailable: '暫無可報名活動',
    registeredActivity: '已報名活動',
    thereAreNoRegisteredActivities: '暫無已報名活動',
    thereAreNoCanceledEvents: '暫無已取消活動',
    signUp: '報名',
  },
  componentsCostprint8cmprint: {
    dateOfConsumption: '消費日期',
  },
  componentsCostprinta4template: {
    totalConsumption: '消費合計',
    dateOfConsumption: '消費日期',
    feeName: '費用名稱',
  },
  componentsCounter: {
    theGoodsAreOnlyInStock: '該商品庫存僅剩',
    thereIsNotEnoughStockOfThisCommodity: '該商品庫存不足',
  },
  componentsNowpayaccounthandle: {
    modifyTheBookSuccessfully: '修改賬套成功',
    bookModification: '修改賬套',
    pleaseEnterABookName: '請輸入賬套名稱',
    pleaseSelectTheConsumerCategory: '請選擇消費類目',
    newAccountSuccessfully: '新增賬套成功',
  },
  componentsRecorddetail: {
    memberInfo: '會員姓名/卡號',
  },
  componentsRushbalance: {
    successfulWriteOff: '沖賬成功',
  },
  componentsShoppinggoods: {
    onlyAvailable: '僅顯示有貨',
    commodityCategory: '商品類別',
    pleaseEnterTheProductName: '請輸入商品名稱',
    noDataIsQueried: '未查詢到數據',
    name3: '名稱',
    purchaseQuantity: '購買數量',
    vendibility: '可售',
    allGoods: '全部商品',
  },
  componentsAddroomer: {
    addLabel: '新增標籤',
    noCustomerProfile: '該入住人暫無客戶檔案',
    guestSaveFailedRetry: '入住人儲存失敗，請重試',
    changeOccupancy: '修改入住人',
    increaseOccupancy: '增加入住人',
    addGuest: '新增住客',
    atLeastOneGuest: '至少保留一位住客',
    guest: '住客',
    enterGuestName: '請輸入{name}的姓名',
    enterValidPhone: '請輸入住客{name}的正確手機號',
    selectDocumentType: '請選擇{name}的證件類型',
    enterDocumentNumber: '請輸入{name}的證件號碼',
  },
  componentsAnnouncement: {
    noticeBoard: '公告欄',
  },
  componentsIdentifyMembers: {
    memberInformation: '會員信息',
    pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation: '請填寫客人手機號，快速識別身份信息',
    guestsCanUpgradeToAHigherLevelMembership: '客人可升級更高級別的會員',
    l: '升',
    unnamed: '未實名',
    inRealName: '已實名',
    points: '積分',
    memberRightsAndInterests: '會員權益',
    patron: '客人',
    unfold: '展開',
    unactivated: '未激活',
    membershipSalesCopy: '會員銷售文案',
    bookingDiscount: '訂房折扣',
    costPerformance: '購卡性價比',
    memberPoints: '會員積分',
    lateCheckOut: '延遲退房',
    copywritingType: '文案類型',
    afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers: '客人在“輕住酒店預訂”小程序實名認證後，可領取18元無門檻生日禮券或參與專享優惠活動',
    afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits: '客人在“輕住酒店預訂”小程序首次登錄即可激活會員身份並享受專屬會員權益',
    lightStayMemberLevelNonMember: '轻住会员等级：非会员',
    lightStayMembershipLevel: '輕住會員等級',
  },
  componentsSellcard: {
    employeeLastWeeksCardSalesList: '員工·上週售卡排行榜',
    dragLeftAndRightToViewTheTable: '左右拖動查看表格',
    hotelLastWeeksCardSalesList: '酒店·上週售卡排行榜',
    cardSalesRanking: '售卡排行榜',
    employee2: '員工',
    numberOfCardsSold: '售卡數量',
    amountOfCommission: '提成金額',
  },
  componentsoneCardDialog: {
    waitingForTheCustomerToSwipeTheirCard: '等待客人刷卡',
    processingPayment: '支付中',
    customerPaymentSuccessful: '客人支付成功',
    customerPaymentFailed: '客人支付失敗，請重新發起收款',
  },
  customerPSearch: {
    singleStoreMembershipLevel: '單店會員等級',
    enterYourNamePhoneNumberAndCardNumber: '輸入姓名、手機號、卡號查詢',
  },
  customerPTable: {
    topUp: '儲值',
    gift: '贈送',
    viewMembers2: '查看會員',
    modifyMembership2: '修改會員',
    storedValueDeduction: '儲值扣減',
    integralChange2: '積分變更',
    integralQuery2: '積分查詢',
    storedValueQuery2: '儲值查詢',
    rechargeAllAccumulatedRechargeAmounts: '充值：所有充值累計金額',
    giftAllAccumulatedGiftAmounts: '赠送：所有赠送累计金额',
    consumptionAllAccumulatedConsumptionAmounts: '消費：所有消費累計金額',
    refundAllAccumulatedRefundAmounts: '退款：所有退款累计金额',
    distributionSettings: '分销設定',
  },
  componentsNightaudit: {
    theCurrentBusinessDayIs: '當前營業日為',
    startTheNightTrial: '開始執行夜審',
    theNightTrialIsInProgressAndCannotBeClosed: '夜審正在進行中不可以關閉',
    immediateFeedback: '立即反饋',
    nightAuditCompleted: '夜審完成',
    nightTrialInProgress: '夜審中',
    nightTrialNewsNotice2: '夜審消息通知',
    nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport: '夜審失敗,請您按照提示處理後再執行夜審。如遇問題可反饋給技術支持',
  },
  componentsNightauditGrayEnv: {
    nightTrialNewsNotice2: '夜審消息通知',
    procedure: '步驟',
    mistake: '錯誤',
    carryOut: '執行',
    nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve: '夜審失敗遇到問題可以在早上8點後，盡快聯繫技術支持協助解決',
    whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully: '時發生錯誤，夜審停止，請仔細確認後',
  },
  componentsOpenPageLayout: {
    backToHomePage: '返回首頁',
  },
  componentsShiftchoose: {
    pleaseSelectFlightSchedule: '请选择班次',
  },
  baseBasemultipleselect: {
    thisOptionWasNotFound: '沒有找到該選項',
  },
  printsettingHalfprint: {
    test: '測試',
    print: '列印',
    trisection: '三等分',
    printInThirds: '三等分打印',
    printInHalf: '二等分打印',
  },
  printsettingPrint: {
    print: '列印',
  },
  printsettingSmallprint: {
    feeName: '費用名稱',
    totalConsumption: '消費合計',
  },
  hardwareIdcardbtn: {
    readIdentityCard: '讀取身份證',
  },
  hardwareReaddoorcard: {
    pleasePlaceYourKeyCardOnTheCardReader: '請將門卡放置於讀卡器上',
    effectiveTime: '生效時間',
    failureTime: '失效時間',
    readCard: '讀卡',
    failedToObtainTheLockInformationProcedure: '獲取門鎖信息失敗',
    thisCardIsNotAGuestCardPleaseReBusinessCardPrinting: '該卡不是賓客卡，請重新制卡',
    wheatDoorLockPlugInReadCard: '麥田門鎖插件讀卡',
    the: '的',
    wheatDoorLockPlugInCancellationCard: '麥田門鎖插件註銷卡',
    cardReadingFailure: '讀卡失敗',
  },
  componentsFeedback: {
    selectAttachment: '選擇附件',
    viewFeedbackLog: '查看反饋記錄',
    commitFailure: '提交失敗',
    problemFeedback3: '問題反饋',
    pleaseEnterTheContactName4: '請輸入聯繫人姓名',
    pleaseEnterAContactNumber3: '請輸入聯繫電話',
    uploadAttachment2: '上傳附件',
    pleaseEnterADetailedDescriptionOfTheProblem2: '請輸入問題詳細描述',
    theUploadedFilesCannotExceed: '上傳文件不能超過',
    aMaximumOfFiveFilesCanBeUploaded2: '最多支持上傳5個文件',
    submitSuccessfully4: '提交成功',
    aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb: '最多支持上傳5個文件，單個文件大小不超過20M,支持格式',
    pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact: '請說明問題並輸入QQ號方便聯繫',
  },
  componentsFeedjump: {
    lightWinTreasureSmallProgram: '輕贏寶小程序',
    scanCodeUsingASmallProgram: '掃碼使用小程序',
    realTimeControlOfRoomStatus: '房態實時管控',
    onlineOneClickPriceAdjustment: '在線一鍵調價',
    memberDevelopmentTools: '會員發展工具',
    moreFeaturesComingOnline: '更多功能上線中',
    hotelOperationCarefulAssistant: '酒店經營·貼心管家',
  },
  componentsGethelp: {
    getHelp: '獲取幫助',
  },
  componentsGoappshop: {
    applicationMarket: '應用市場',
  },
  componentsJointrain: {
    attendTraining: '參加培訓',
  },
  componentsJumph5: {
    smallProgram8: '小程序',
  },
  componentsLeftcontent: {
    hotelOperationsManager: '酒店運營經理',
    cityOperationsManager: '城市運營經理',
    customerServiceHotline: '客服熱線',
  },
  componentsTrain: {
    trainingCoursesAreInFullSwing: '培訓課程火爆開講',
    getDetailedTrainingNoticesAndMaterials: '獲取詳細培訓通知和材料',
    followThelightStaySystemServicePublicAccount: '關注「輕住系統服務」公眾號',
    basicCourseIntroductorySeries: '基礎課：入門串講',
    mondayAndWednesday1430Start: '每週一、週三14:30開始',
    advancedCourseComplexScenesCommonQuestionsRecentNewFeatures: '進階課：複雜場景+常見問題+近期新功能',
    friday1430Start: '每週五14:30開始',
  },
  merchantPCtxTab: {
    oldFinancialReconciliationSystem: '財務對賬老系統',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill: '輕住佣金補貼已經移至會員激勵，請到會員激勵下進行賬單的確認',
  },
  merchantPCtxTab1: {
    oldFinancialReconciliationSystem: '財務對賬老系統',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill: '輕住佣金補貼已經移至會員激勵，請到會員激勵下進行賬單的確認',
  },
  merchantPSearchqu: {
    enterHotelName: '输入酒店名称',
  },
  payIndex: {
    toBePaid: '待支付',
    pleaseScanQrCodeToCompletePayment: '請掃二維碼完成支付',
    canBeClosedAfter: '後可以關閉',
    paymentSuccess: '支付成功',
    automaticShutdownInSeconds: '秒後自動關閉',
    automaticPageRefresh: '自動刷新頁面',
    duringThePayment: '支付中',
    paymentAnomaly: '支付異常',
    ifThePaymentIsAbnormalContactTechnicalSupport: '支付異常，請聯繫技術支持處理',
    paymentFailure: '支付失敗',
    payOff: '支付關閉',
    waitForTheUserToScanTheCode: '等待用戶掃碼',
    currentStatusOfLehuiPayment: '當前樂惠支付的狀態',
    theGunScannedTheCodeSuccessfully: '掃槍掃碼成功',
    theUserHasPaidSuccessfully: '用戶已支付成功',
    ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage: '用戶未支付，可在財務頁面中重新入帳',
  },
  sellCalctable: {
    maximumPromotion: '最大幅度促銷',
    nonMemberSellingPricebrestimatedSettlementPrice: '非會員賣價<br>/預估結算價',
    ordinaryMemberSellingPricebrestimatedSettlementPrice: '普通會員賣價<br>/預估結算價',
    goldMemberSellingPricebrestimatedSettlementPrice: '黃金會員賣價<br>/預估結算價',
    platinumMemberSellingPricebrestimatedSettlementPrice: '白金會員賣價<br>/預估結算價',
    diamondMemberSellingPricebrestimatedSettlementPrice: '鑽石會員賣價<br>/預估結算價',
  },
  sellPTableTdNew: {
    noData: '無數據',
  },
  sellPricecalc: {
    channelSellingPriceCalculator: '渠道售價計算器',
    selectRoomType: '選擇房型',
    pleaseSelectRoomType: '請選擇房型',
    selectProduct: '選擇產品',
    pleaseSelectAProductName: '請選擇產品名稱',
    selectSaleDate: '選擇售賣日期',
    originalPrice2: '原價',
    distributionChannel: '分銷渠道',
    pleaseSelectTheDistributionChannelNamenotRequired: '請選擇分銷渠道名稱(非必選)',
    canNotExceed: '最大不能超過',
    pleaseSelectASaleDate2: '請選擇售賣日期',
    figure: '數字',
  },
  filtersIndex: {
    all: '全',
    sinceThe: '自',
    free: '免',
    group: '團',
    association: '協',
    theClock: '鐘',
    long: '長',
    inapplicability: '不適用',
    haveProcessed: '已辦理',
    notProcessed: '未辦理',
    averageSalesRate: '銷售平均房價',
    consumptionNight: '消費間夜',
    averageHousePriceOfConsumption: '消費平均房價',
    onlinePermeability: '線上滲透率',
    cancelNight: '取消間夜',
    rejectionNight: '拒絕間夜',
    channelProvision: '渠道提供',
    theHotelProvides: '酒店提供',
  },
  jsonBookertypeoptions: {
    singleStoreMember: '單店會員',
    lightLivingMember: '輕住會員',
  },
  layoutIndex: {
    collapseMenuBar: '折疊菜單欄',
  },
  componentsNavbar: {
    shiftManagement: '換班管理',
    helpCenter: '幫助中心',
    logout: '退出登錄',
    reportTitle: '交班彙總統計報表',
    headers: {
      income: '收入',
      expend: '支出',
      total: '合計金額',
    },
  },
  componentsSidemessage: {
    orderNotice: '訂單通知',
    orderMessageReceivedNotification: '訂單消息收到通知了',
    youDoNotHaveOrderManagementPermission: '你還未開通訂單管理權限',
    ignore: '忽略消息',
    order: '訂單消息',
    noData: '暫無新消息',
    system: '系統消息',
    settlement: '結算消息',
    dynamic: '動態消息',
    serviceManagement: '服務工單管理',
    roomService: '客房服務',
    itemBorrow: '物品借用',
    extendStay: '續住服務',
    manualEntry: '手工錄單',
    confirmOrder: '確認接單',
    viewOrder: '查看訂單',
    youDoNotHaveAccessToEbkOrderManagement: '你還未開通EBK訂單管理權限',
    youReceive: '您收到',
    aNewMessage: '條新消息',
    have: '有',
    orderMessage: '條訂單消息',
    aNewSystemMessage: '條新系統消息',
    aNewSettlementMessage: '條新結算消息',
  },
  componentsSoundnotice: {
    playOut: '播放完畢',
    theVoicePromptsThatAMessageIsReceived: '語音提示收到消息',
  },
  nightcheckNightStart: {
    nightTrialSequence: '夜審順序',
    nightAuditInstructions2: '夜審說明',
  },
  nightcheckNightTip: {
    theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible: '酒店尚未夜審，為了避免影響酒店營收數據，請盡快開始夜審',
    nightAuditInstructions2: '夜審說明',
    beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue: '夜審前請務必提前核對酒店賬務數據是否正確，以免影響酒店營收',
    pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed: '請確認當前營業日需要辦理入住及離店的訂單已經處理完畢',
    youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived: '您已設置夜審時自動取消預抵未到的門店訂單',
    preArrivalAutoCheckIn: '您已設置夜審時自動為預抵訂單辦理入住',
    preArrivalAutoNoshow: '您已設置夜審時自動將預抵訂單標記為noshow',
    preDepartureAutoCheckOut: '您已設置夜審時自動為預離訂單辦理退房',
    preDepartureAutoExtendStay: '您已設置夜審時自動為預離訂單辦理續住',
    theEarliestTimeForManualNightAuditIs: '手工夜審最早時間為',
    nightAuditProcess: '夜審流程',
    hotelBusinessDaysAreNowGreaterThanNaturalDays: '當前酒店營業日已經大於自然日',
    nightAuditReminder: '夜審提醒',
    hotelBusinessDay: '酒店營業日',
    currentNaturalDay: '當前自然日',
    viewLogs: '查看日誌',
    theNightTrialWasCompleted: '已夜審完成',
    nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh: '夜審開始時間不能早於21點，無法執行夜審操作哦',
    thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure: '有正在進行的夜審，請勿重複操作',
  },
  nightcheckNightTipGrayEnv: {
    theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation: '當前酒店營業日已經大於自然日，或者夜審開始時間不能早於21點，無法執行夜審操作哦',
    theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible: '尚未完成夜審，請盡快執行夜審',
  },
  localesZhCn: {
    modifiedSuccessfully2: '修改成功',
    save4: '保存',
    pleaseSelectADate4: '請選擇日期',
    sellingPrice2: '賣價',
    floorPrice2: '底價',
    checkIn2: '入住',
    smallProgram8: '小程序',
    goWhereTheDirectConnection4: '去哪直连',
    jingdongDirectLink4: '京東直連',
    baiduMapDirectConnection2: '百度地圖直連',
    submitSuccessfully4: '提交成功',
  },
  globalMethodsmixin: {
    hotelChangeAlert: '酒店變更提醒',
    theHotelIsCurrentlyFrom: '當前酒店已從',
    switchTo: '切換至',
  },
  regularIndex: {
    pleaseEnterTheCorrectEmailAddress: '請輸入正確郵箱',
    pleaseEnterTheCorrectIdNumber: '請輸入正確的身份證號',
    pleaseEnterTheCorrectIdNumber2: '請輸入正確的證件號',
  },
  sidebarLogo: {
    helpCenter2: '幫助中心',
  },
  modulesMember: {
    drench: '輕住',
  },
  modulesUser: {
    client: '客戶',
    membershipManagement: '會員管理',
    singleStoreMemberManagement: '單店會員管理',
    storeValueManagement: '單店儲值管理',
    singleStorePointsSetting: '單店積分設置',
    storeValueReport: '單店儲值報表',
    failedToObtainOperationInformationProcedure: '獲取運營信息失敗',
    billReconciliation: '賬單核對',
    paymentRecord: '打款記錄',
    expenseStatement: '費用流水',
  },
  utilsAddroute: {
    initializesTheReceivableFinancialMenu: '初始化應收賬財務菜單',
  },
  utilsDoorcard: {
    initializationFailure: '初始化失敗',
    noKeyCardReaderPlugInFound: '未找到門卡讀卡器插件',
    cardReadingError: '讀卡錯誤',
    plugIn: '插件',
    cardReadingResult: '讀卡結果',
    cardReadingFailure: '讀卡失敗',
    businessCardWriteData: '制卡寫入數據',
    businessCardPrintingResult: '制卡結果',
    businessCardFailure: '制卡失敗',
    logoutStatusCode: '註銷狀態碼',
    logoutFailure: '註銷失敗',
  },
  utilsDoorcardmaitian: {
    noKeyCardReaderPlugInFound: '未找到門卡讀卡器插件',
    cancelTheCardSuccessfully: '註銷卡成功',
    readTheCardSuccessfully: '讀卡成功',
  },
  utilsEnum: {
    roomInNeedOfRepair: '房間需維修',
    guestRequest: '賓客要求',
    hotelRowRoomDemand: '酒店排房需求',
    inProcess: '處理中',
    alreadyEnded: '已結束',
    storeOrderPreArrivalHasNotBeenChecked: '門店訂單預抵未到檢查',
    leaveTheRoomForInspectionToday: '今日預離房間檢查',
    generateRoomChargesInTheRoom: '在住房間生成房費',
    cleanRoomToDirtyRoom: '住淨客房轉住臟',
    switchingDay: '轉換營業日',
    preArrivalNoShowRoomListPending: '預抵達未到，房單待入住',
    preSeparationIsNotSeparated: '預離未離',
    allRoomChargesAreGeneratedAndRecordedInTheAccount: '全部在住生成房費，併入賬',
    roomChange: '房態變更',
    generateCureReport: '生成固化報表',
    shopHourRoom: '門店鐘點房',
    onlineHourRoom: '線上鐘點房',
    presaleFullDayRoomProduct: '預售全日房產品',
    presaleClockRoomProduct: '預售鐘點房產品',
  },
  utilsFreego: {
    theCardReaderIsNotConnectedToTheComputer: '讀卡器未連接到電腦上',
    checkValueError: '校驗值錯誤',
    passwordError: '密碼錯誤',
    readCard: '讀卡',
    cardReaderCommunicationIsNormal: '讀卡器通訊正常',
    businessCardPrintingSoftwareIsNotOpened: '制卡軟件未打開',
    theReaderIsNotConnectedOrTheSoftwareIsNotOpen: '讀卡器未連接或是軟件未打開',
    sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome: '對不起，你的瀏覽器不支持讀卡器功能，請使用chrome瀏覽器。',
  },
  utilsIdcard: {
    idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage: '身份證讀卡器連接. 如需掃描身份證,請將身份證掃描儀連接到電腦上.並刷新頁面',
    toScanDocumentsInstallTheIdCardReaderControl: '如需掃描證件,請安裝身份證讀卡器控件',
    abnormalReadingIdCardPleaseRefreshAndTryAgain: '讀取身份證異常，請刷新重試',
    noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition: '未讀取到證件信息，請檢查是否放置身份證或放置位置是否正確',
  },
  utilsIndex: {
    justNow: '剛剛',
    aMinuteAgo: '分鐘前',
    hoursAgo: '小時前',
    month: '月',
    when: '時',
    connectionSuccessful: '連接成功',
    theGlobalConnectionIsClosed: '全局連接已關閉',
    yourBrowserDoesNotSupportIt: '您的瀏覽器不支持',
  },
  utilsLinktopage: {
    contactTheAdministratorToEnableIt: '請聯繫管理員開通',
    noCorrespondingLedgerFound: '未找到對應的賬套',
    accountReceivable: '應收賬',
    administrativeAuthority: '管理權限',
  },
  utilsRequest: {
    doNotRepeatRequests: '請勿重複請求',
    noFlightFoundPleaseSelectAgain: '未查詢到班次，請重新選擇',
    systemErrorPleaseContactTechnicalSupport: '系統錯誤，請聯繫技術支持',
    networkException: '網絡異常',
    requestTimedOutPleaseRefreshThePage: '請求超時,請刷新頁面',
    requestTimeout: '請求超時',
    requestFailed: '請求失敗',
  },
  utilsSharestorage: {
    putInTheInitialMarker: '放進去初次標記',
  },
  vendorVLoading: {
    hardLoading2: '拼命加載中',
  },
  appdetailIndex: {
    specification: '規格',
    contactBusinessManager: '聯繫業務經理',
    buyNow: '立即購買',
    applicationIntroduction: '應用介紹',
    workingHours: '工作時間',
    pleaseSelectProductSpecifications: '請選擇產品規格',
  },
  applistIndex: {
    fullApplication: '全部應用',
    haveOpened: '已開通',
    haveNotOpened: '未開通',
    inService: '開通中',
    contactBusinessManager: '聯繫業務經理',
    workingHours: '工作時間',
    openImmediately: '立即開通',
    immediateRenewal: '立即續費',
    expiredDays: '已過期{days}天',
    daysLeftToExpire: '還有{days}天到期',
  },
  createorderIndex: {
    goToPay: '去支付',
    remaining: '剩餘',
    orderProduct2: '訂購產品',
    purchaser2: '購買人',
    specification: '規格',
    successfulCustomsOrder2: '關單成功',
  },
  createorderPay: {
    amountPaid: '支付金額',
    paymentCountdown: '付款倒計時',
    qrCodeHasExpired: '二维码已过期',
    updateNow: '立即更新',
    payment3: '支付',
    scanQRCode: '請使用微信/支付寶掃描二維碼支付',
  },
  orderlistIndex: {
    orderDate: '訂購日期',
    product: '商品',
    toBePaid: '待支付',
    paymentSuccess: '支付成功',
    paymentFailure: '支付失敗',
    refunded: '已退款',
    partialRefund: '部分退款',
    goToPay: '去支付',
    orderTime: '訂購時間',
    orderProduct2: '訂購產品',
    orderSpecification: '訂購規格',
    refundAmount: '退款金額',
    orderEffectiveTime: '訂單生效時間',
    purchaser2: '購買人',
    orderOperation: '訂單操作',
    successfulCustomsOrder2: '關單成功',
  },
  commentChannelComment: {
    modifyReply: '修改回复',
    setAsTemplate: '設為模板',
    selectRecommendedTemplate: '選擇推薦模板',
    inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words: '輸入回复內容，字數在10以上500字以內',
    theMaximumResponseTextIs500Characters: '回复文字最大允許500字',
    areYouSureYouWantToDeleteReplies: '確認要刪除回复嗎',
  },
  commentCommentTempManage: {
    newTemplate: '新建模板',
    goodReputation: '好評',
    delete2: '刪 除',
    templateName: '模板名稱',
    replyClassification: '回複分類',
    replyContent2: '回复內容',
    pleaseEnterAtLeast10Characters: '請輸入至少10個字符',
    keyword: '關鍵字',
    pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas: '請輸入要匹配評論的關鍵字以逗號分隔',
    pleaseEnterATemplateName: '请输入模板名称',
    theValueCanContainNoMoreThan15Characters: '長度在15個字符以內',
    pleaseSelectAReplyCategory: '請選擇回複分類',
    pleaseEnterTheReplyContent: '請輸入回复內容',
    '10To500CharactersInLength': '長度在 10 到 500 個字符',
    theValueContainsAMaximumOf50Characters: '長度在50個字符以內',
    definitiveDeletion: '確定刪除',
    deletingATemplateSucceeded: '刪除模板成功',
    creatingATemplateSucceeded: '新建模板成功',
    modifiedSuccessfully2: '修改成功',
  },
  commentComment: {
    reasonForNotPassing: '未通過原因',
    setAsTemplate: '設為模板',
    replyAgain: '再次回复',
    reappeal: '再次申訴',
    inComplaint: '申訴中',
    typeOfAppeal: '申訴類型',
    statementOfAppeal: '申訴說明',
    selectRecommendedTemplate: '選擇推薦模板',
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words: '輸入回复內容，字數在10以上300字以內',
    theMaximumResponseTextIs500Characters: '回复文字最大允許500字',
    areYouSureYouWantToDeleteReplies: '確認要刪除回复嗎',
  },
  commentComplain: {
    onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted: '您的申訴通過審核後，系統將自動刪除該評論',
    youCanUploadUpToFivePictures: '最多可上傳五張圖片',
    launchAComplaint: '發起申訴',
    typeOfAppeal: '申訴類型',
    statementOfAppeal: '申訴說明',
    uploadCredentials: '上傳憑證',
    pleaseFillInTheContact: '請填寫聯繫人',
    pleaseEnterTheCorrectName: '請輸入正確的姓名',
    pleaseSelectTheAppealType: '請選擇申訴類型',
    theCauseOfTheComplaintMustBeAtLeast10Words: '申訴原因至少為10個文字',
    theMaximumCauseOfAppealIs300Words: '申訴原因最大允許300字',
    underAppeal: '提交申訴中',
    addAppealSuccess: '添加申訴成功',
  },
  commentIndex: {
    totalEvaluation: '全部評價',
    waitForReply: '待回复',
    appealed: '已申訴',
    allRoomTypes: '全部房型',
    noReplyYet: '未回复',
    toBeReviewed: '待審核',
    notPass: '未通過',
    alreadyPassed: '已通過',
  },
  commentMain: {
    deleteReplySucceeded: '刪除回復成功',
    modifiedReplySucceeded: '修改回復成功',
  },
  commentPreview: {
    viewPicture: '查看圖片',
  },
  commentReplyList: {
    replyDate: '日期',
    commentChannel: '評論渠道',
    review2: '評論',
    replyContent2: '回复內容',
    commentReply: '評論回复',
    modifyReply: '修改回复',
    deleteReply: '刪除回复',
    meituanReview: '美團評論',
    ctripReview: '攜程評論',
    whereToComment: '去哪兒評論',
    sameTripReview: '同程旅行評論',
    dianpingReviews: '大眾點評評論',
    flyingPigReview: '飛豬評論',
    parallelComment: '同程評論',
  },
  commentScore: {
    renewal: '更新',
    guestImpression: '客人印象',
    overallGuestRating: '客人綜合評分',
  },
  complainDetail: {
    issueDetails: '問題詳情',
    processingDetails: '處理詳情',
    serviceProblem: '服務問題',
    healthProblem: '衛生問題',
    processor: '處理人',
    processingTime: '處理時間',
    communicationSituation: '溝通情況',
  },
  complainHandle: {
    successfulProcessing: '處理成功',
    problemHandling: '問題處理',
    roomInformation: '房間信息',
    guestInformation: '客人信息',
    communicationSituation: '溝通情況',
    enterAMaximumOf300Characters: '最多輸入300個字',
    pleaseEnterTheProcessingResult: '請輸入處理結果',
  },
  complainIndex: {
    submissionDate: '日期',
    processed: '已處理',
    submissionTime: '提交時間',
    feedbackProblem: '反饋問題',
    untreated: '未處理',
    viewTheResults: '查看結果',
  },
  ebkComment: {
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words: '輸入回复內容，字數在10以上300字以內',
    theMaximumResponseTextIs300Characters: '回复文字最大允許300字',
    modifiedReplySucceeded: '修改回復成功',
  },
  ebkGrade: {
    guestImpression: '客人印象',
  },
  ebkIndex: {
    totalEvaluation: '全部評價',
    waitForReply: '待回复',
  },
  customerCompany: {
    new: '新增',
    whetherToAllowHangingAccounts2: '是否允許掛賬',
    loginListHidesRates: '登錄單隱藏房價',
    confirmAction: '確定{action}公司客戶“{name}”嗎？',
  },
  customerDialog: {
    whetherToAllowHangingAccounts2: '是否允許掛賬',
    theRegistrationFormHidesTheRoomRate: '登記單隱藏房價',
    addACorporateClient: '添加公司客戶',
    changeCorporateAccount: '修改公司客戶',
    companyInformation: '公司信息',
    forShort: '簡稱',
    pleaseEnterCompanyAbbreviation: '請輸入公司簡稱',
    code: '代碼',
    pleaseEnterTheCode: '請輸入代碼',
    legalPerson: '法人',
    pleaseEnterTheLegalPersonName: '請輸入法人姓名',
    fax: '傳真',
    pleaseEnterTheFaxNumber: '請輸入傳真號碼',
    city: '城市',
    postcode: '郵編',
    pleaseEnterPostalCode: '請輸入郵編',
    pleaseEnterDiscountRatio: '請輸入優惠比例',
    enterAMaximumOf100Characters: '最多輸入100個字',
    contactInformation: '联系人信息',
    pleaseEnterTheContactNumber: '請輸入聯繫人電話',
    pleaseEnterEmail: '請輸入郵箱',
    setUp: '掛賬設置',
    pleaseEnterYourAccountName: '請輸入賬戶名稱',
    accountType: '賬戶類型',
    maximumAmount: '最大額度',
    pleaseEnterDiscount: '請輸入折扣',
    pleaseEnterAnIntegerBetween0And100: '請輸入0 - 100整數',
    pleaseEnterTheCorrect11DigitMobileNumber: '請輸入正確的11位手機號碼',
    pleaseEnterName: '請輸入名稱',
    pleaseEnterTheContactName3: '請輸入聯繫人名字',
    creditAccount: '信用賬戶',
    theCreditLimitCannotBeExceeded: '信用額度不能超過',
    enterRange: '請輸範圍1～365數字',
  },
  customerIndex: {
    protocolUnitToBeDeveloped: '協議單位,待開發',
  },
  heavenlyEyeCallThePolice: {
    alarmEvent: '報警事件',
    shootingTime: '拍攝時間',
    theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto: '以下住客暫未加入白名單，選擇與照片匹配的住客',
    stranger: '陌生人',
    whiteAdded: '已加白',
    ignored: '已忽略',
    whitelist: '加入白名單',
    environmentalPhotograph: '環境照片',
    facePhoto: '人臉照片',
    pleaseSelectUser: '請選擇用戶',
  },
  heavenlyEyeWhiteList: {
    personnelType: '人員類型',
    addStaff: '新增',
    pleaseEnterTheRoomNumber: '請輸入房間號',
    employee2: '員工',
    dweller: '住客',
    avatar: '頭像',
    photograph: '照片',
    pleaseSelectEnterName: '請選輸入姓名',
    pleaseCompleteTheFormBeforeSubmitting: '請填寫完成再進行提交',
    inputLabelDuplication: '輸入標籤重複',
    pleaseEnterTheLabelContent: '請輸入標籤內容',
    doNotEnterLabelsInMoreThan10Words: '输入标签不要超过10个字',
    whetherToDeleteTheWhitelist: '是否確認刪除該員工白名單',
    uploadImageFormat: '上傳圖片只能是JPG或者PNG格式!',
  },
  hicList: {
    dateOfPresentation: '提報日期',
    dataExport: '数据导出',
    bookingChannel: '預訂渠道',
    bodyTemperature: '體溫',
    healthStatus: '健康狀況',
    theHealthInformationCollectionReportIsSuccessfullyExportedProcedure: '健康信息收集報表導出成功',
    failedToExportTheHealthInformationCollectionReportProcedure: '健康信息收集報表導出失敗',
  },
  hicQrCode: {
    downloadPicture: '下載圖片',
  },
  marketActivity: {
    couponType: '優惠券類型',
    couponName: '優惠券名稱',
    beOffline: '已下線',
    terminated: '已終止',
    full: '滿',
    reduction: '減',
    fromTheDateOfReceipt: '從獲得券之日起',
    withinDays: '天內有效',
    thisParameterIsValidWithinAFixedPeriod: '固定時間段內有效',
    restrictedRoomNight: '限制間夜',
    unlimited: '不限',
    oneNight: '一間夜',
    discountType: '優惠類型',
    validForTimePeriod: '時間段內有效',
    instructionsForUse: '使用須知',
    selectionOfParticipatingGoods: '選擇參與商品',
    allGoods: '全部商品',
    platform: '平台',
    theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully: '優惠券名稱會展示給用戶，請認真填寫',
    denomination: '面額',
    fillInTheCouponAmountdiscountAmount: '填寫優惠券金額（優惠金額）',
    pleaseSelectTheYearMonthAndDay2: '請選擇年月日',
    instructionsWillBeDisplayedToTheUserPleaseFillInCarefully: '使用須知會展示給用戶，請認真填寫',
    save4: '保存',
    viewActivity: '查看活动',
    maxOut: '满减',
    availableForBooking1Room1NightOnly: '僅限預訂1間1晚可用',
    events: '活动',
    orderNeedsToBeFull: '订单需满',
    issued: '已发放',
    haveBeenUsed: '已使用',
    expired2: '已过期',
    editCoupon: '編輯優惠券',
    addCoupon: '添加優惠券',
    pleaseSelectTheOfferType: '请选择优惠类型',
    pleaseEnterExpiryDate2: '請輸入有效期',
    pleaseSelectExpirationDate: '請選擇有效期',
    pleaseEnterTheCouponName2: '請輸入優惠券名稱',
    amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter: '金額只可輸入正整數，請重新輸入',
    successfulActivation: '激活成功',
    deactivated: '已取消激活',
    pleaseConfirmWhetherYouWantToTerminate: '請確認是否要終止',
    terminationSuccess: '終止成功',
    cancelledTermination: '已取消終止',
    pleaseEnterTheValidityPeriod: '請輸入有效期對應內容',
    createACoupon: '創建優惠券',
    unedited: '已取消編輯',
    discountTemplate: '立減{ money }元',
    fullReductionTemplate: '滿減{ minAmount }元',
    validityDaysTemplate: '從獲得券之日起 { day } 天內有效',
    activationConfirmation: '當券被激活後便不能再修改，請確認是否要激活？',
    importValidationWarning: '部分導入酒店校驗存在異常, 是否繼續?',
  },
  marketActivitydata: {
    classificationSpecification: '分類說明',
    data: '數據',
    marketingRevenue: '營銷收入',
    marketingExpenses: '營銷費用',
    numberOfContacts: '觸達人數',
    numberOfVisitors: '訪問人數',
    numberOfTransactions: '成交人數',
    revenueDescription: '30天內觸達用戶產生收入（元）',
    costDescription: '30天內營銷所產生的成本（元）',
    reachCountDescription: '30天內營銷活動觸達用戶數（個）',
    visitCountDescription: '30天內觸達用戶訪問本門店用戶數（個）',
    orderCountDescription: '30天內觸達後下單用戶數（個）',
  },
  marketCrowddata: {
    subdivide: '細分',
    classificationSpecification: '分類說明',
    numberOfPeople: '人數',
    membersWhoHaveStayedAtThisStore: '入住過本店的會員',
    allMembers: '全部會員',
    usersWhoHaveStayedInThisStoreInThePast1Year: '近1年入住過本門店的用戶',
    lowFrequencyMember: '低頻會員',
    usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months: '近1年入住過，但近3個月沒有入住的用戶',
    loyalUser: '忠实用户',
    usersWhoHaveStayedAtLeast3TimesInTheLast1Year: '近1年入住過3次以上的用戶',
    lostUsers: '流失用戶',
    usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year: '近2年入住過，近1年沒用入住的用戶',
    interestedMember: '興趣會員',
    interestedUserGroupsOfThisStore: '本店興趣用戶群體',
    inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder: '近7天該用戶進入過本酒店小程序首頁，未下單',
    localInterestUserGroups: '同城興趣用戶群體',
    inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated: '近7天進入搜索過本酒店所在城市、酒店',
    orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder: '或進入過本城市其他酒店，但未下單',
    intraCityUserGroup: '同城用戶群體',
    usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore: '近30天入住過本城市非本門店用戶',
    createActivity: '創建活動',
    lowFrequencyUser: '低頻用戶',
    marketingSuggestion: '建議：及時創建營銷活動，留住用戶，增加上單！',
  },
  marketDatakb: {
    crowdDataBulletinBoard: '人群數據看板',
    activityDataKanban: '活動數據看板',
  },
  marketDistribution: {
    releaseTime: '發放時間',
    events: '活動',
    releaseMode: '發放方式',
    smsSending: '短信發送',
    publicAccount: '公眾號',
    stopSmsPlatformPush: '輕住短信平台推送',
    stopThePublicAccountPush: '輕住公眾號推送',
    iHaveReadAndAgree: '我已閱讀並同意',
    precisionMarketingRules: '精準營銷規則',
    pleaseReadAndAgree: '請閱讀並同意',
    warmReminder: '溫馨提示',
    issue: '發放',
    couponName: '優惠券名稱',
    pleaseEnterTheCouponName2: '請輸入優惠券名稱',
    sendingCrowd: '發送人群',
    pleaseSelectTheSender: '請選擇發送人群',
    quantityIssued: '發放數量',
    pleaseFillInTheNumberOfIssuedCards: '請填寫發放張數',
    sendingMode: '發送方式',
    notificationTemplate: '通知模板',
    pleaseSelectANotificationTemplate: '請選擇通知模板',
    projectedCost: '預計費用',
    allUsers: '全部用戶',
    interestedUsersOfThisStore: '本店興趣用戶',
    lostUsers: '流失用户',
    loyalUser: '忠實用戶',
    lowFrequencyUser: '低頻用戶',
    interestedUsersInTheSameCity: '同城興趣用戶',
    localUser: '同城用戶',
    unactivated: '未激活',
    terminated: '已終止',
    voucherInformation: '發放券信息',
    issuer: '發放人',
    pleaseEnterTheReleaseQuantity: '請輸入發放數量',
    couponIssuedSuccessfully: '發放優惠券成功',
    pleaseEnterCoupon: '請輸入優惠券',
    sendBatch: '發送批次',
    pleaseEnterTheCorrectCoupon: '請輸入正確的優惠券',
    perPersonUnit: '張/人',
    rule1: '1、營銷活動的創建不宜過於頻繁。輕住在用戶端有防疲勞機制，在一定時間內用戶只能收到有限數量的營銷推送/短信。',
    rule2: '2、為防止酒店過度使用營銷推送/短信，對用戶產生不必要的騷擾，降低酒店品牌形象，該功能限制不同推送渠道用戶7天僅可收到1次推送。',
    rule3: '3、營銷推送/短信不保證全部發送成功，以實際觸達效果為準。',
    rule4: '4、未發送成功的營銷推送/短信，營銷費用將退回，發送記錄需列明成功或失敗。',
  },
  marketRules: {
    rulesRulesRules: '規則規則規則',
  },
  memberActivityManage: {
    longTerm: '長期',
    customInterval: '自定義區間',
    activeTime: '活動時間',
    addActivity: '添加活動',
    editingActivity: '編輯活動',
    editGear: '編輯檔位',
    addGear: '添加檔位',
    unlimited: '不限',
    rechargeAmount2: '充值金額',
    enabledState: '啟用狀態',
    activeState: '活動狀態',
    pleaseSelectADate4: '請選擇日期',
    pleaseEditTheAddedGears: '請編輯已添加的檔位',
  },
  memberIntegralSetting: {
    integralRatioSetting: '積分比例設置',
    points: '積分',
    automaticCumulativePointSetting: '自動累計積分設置',
    storedValueConsumption: '儲值消費',
    nonCumulativeIntegral: '不累計積分',
    pleaseFillInThePointsRatioSetting: '請填寫積分比例設置',
    save4: '保存',
    pleaseSelectTheAutomaticAccumulationPointSetting: '請選擇自動累計積分設置',
    roomAndStoredConsumption: '房費消費 + 儲值消費',
    integralRatioLimit: '積分比例只能限定在0.01~1000之間',
  },
  memberMemberManage: {
    pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate: '請按照模版中的要求整理會員信息',
    downloadTemplate: '下載模板',
    freeCommissionPolicyTips: '免佣政策提示',
    downloadFailureData: '下载失败数据',
    normal: '正常',
    registrationTime: '註冊時間',
    entryTime: '錄入時間',
    augment: '增加',
    decrease: '減少',
    singleStoreStoredValueBillPrinting: '單店儲值賬單打印',
    theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores: '会员储值金额仅该门店可用，其他门店不可使用',
    currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable: '當前會員有未使用的餘額或者積分，請確認是否要禁用',
    lightLivingMember: '輕住會員',
    startOfEntryDate: '錄入日期始',
    dateOfEntry: '錄入日期止',
    membershipIntroduction: '會員導入',
    memberExport: '會員導出',
    newMember: '新增會員',
    viewGrade: '查看等級',
    viewMembers2: '查看會員',
    storedValueQuery2: '儲值查詢',
    transactionType: '交易類型',
    registered: '已註冊',
    unregistered: '未註冊',
    theAmountOfThisStoredValue: '本次儲值金額',
    storedValueActivity: '儲值活動',
    eventGiftAmount: '活動贈送金額',
    currentStoredValueBalance: '當前儲值餘額',
    storageTime: '儲值時間',
    currentBalance: '當前餘額',
    topUpTheTotalAmount: '充值總金額',
    totalGiftAmount: '贈送總金額',
    totalPayment: '支付總金額',
    totalRefundAmount: '退款總金額',
    singleStoreMembershipLevel: '單店會員等級',
    storePoints: '單店積分',
    storedValueAccumulation: '儲值累計',
    incorrectEmailFormat: '郵箱格式不對',
    membershipLevel: '會員等級',
    occupation: '職業',
    pleaseEnterOccupation: '請輸入職業',
    salespersonName: '銷售員名稱',
    salespersonId: '銷售員 ID',
    pleaseEnterSalespersonId: '請輸入銷售員 ID',
    pleaseEnterTheSalespersonsName: '請輸入銷售員姓名',
    pleaseSelectTheYearMonthAndDay2: '請選擇年月日',
    detailedAddress: '詳細地址',
    lv: '等級',
    gradeName: '等級名稱',
    variableIntegral: '變動積分',
    pointBalance: '積分餘額',
    transactionAmount: '交易金額',
    changeType: '變更類型',
    changeOfAmount: '变更数额',
    pleaseEnterAnInteger: '請輸入整數',
    topUpActivity: '充值活動',
    pleaseSelectAnActivity: '請選擇活動',
    activeGear: '活動檔位',
    rechargeAmount2: '充值金額',
    pleaseEnterTheRechargeAmount: '請輸入充值金額',
    amountReceivable: '應收金額',
    printDocuments: '打印單據',
    deductionAmount: '扣減金額',
    pleaseEnterTheAmountOfDeduction: '請輸入扣減金額',
    increaseTheIntegral: '增加積分',
    reduceIntegral: '減少積分',
    filling: '充',
    send: '送',
    pleaseEnterTheCorrectIdNumber: '請輸入正確的身份證號',
    pleaseEnterTheCorrectIdNumber2: '請輸入正確的證件號',
    pleaseFillInTheIdNumber: '請填寫證件號',
    operationFailure: '操作失敗',
    youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions: '你沒有訪問權限,請聯繫輕住運營添加權限',
    currentLimitSelect1FilePleaseRemoveAndAdd: '當前限制選擇 1 個文件,請移除再添加',
    memberDataIsExportedSuccessfullyProcedure: '會員數據導出成功',
    memberDataFailedToBeExportedProcedure: '會員數據導出失敗',
    noDataAvailableAtThisTime: '目前暫無數據',
    memberImportTemplateDownloadedSuccessfully: '會員導入模版下載成功',
    failedToDownloadTheMemberImportTemplate: '會員導入模版下載失敗',
    modifyMembership2: '修改會員',
    addAMemberSuccessfully: '新增會員成功',
    renewMemberSuccessfully: '更新會員成功',
    integralChange2: '積分變更',
    memberRecharge: '會員充值',
    deductionOfStoredValue: '儲值減扣',
    scoreChangeSuccess: '積分變更成功',
    memberRechargeSuccessfully: '會員充值成功',
    theDeductionOfStoredValueIsSuccessful: '儲值減扣成功',
    integralQuery2: '積分查詢',
    pleaseEnterSalesman: '請輸入銷售員',
    definitiveRemoval: '確定移除',
    derivedInformation: '導出信息',
    memberDataExportInformation: '會員數據導出信息',
    memberImportTemplate: '會員導入模板',
    totalMembers: '共有{memberTotal}個會員',
    xlsFormatOnly: '僅支持XLS格式文件',
    commissionRefundNotice: '自21年2月1日起，首次使用“會員導入”功能導入的會員，在輕住小程序預訂本酒店併入住後產生的佣金全額返還！',
    idTypeAndNumber: '證件類型/證件號',
    distributionSettings: '分销設定',
    setAsAPromotionalUser: '設為推廣用戶',
    enabled: '已啟用',
    disabled: '未啟用',
  },
  memberMemberReport: {
    ordinaryMember: '普通會員',
    goldMember: '黃金會員',
    platinumMember: '白金會員',
    diamondMember: '鑽石會員',
    enterYourNamePhoneNumberAndIdNumber: '輸入姓名、手機號、證件號',
    membership: '會員身份',
    activateStore: '激活門店',
    ourStore: '本門店',
    otherStores: '其他門店',
    sourceOfDevelopment: '發展來源',
    activationDate: '激活日期',
    dateOfPurchase: '購買日期',
    purchaseTime: '購買時間',
    memberNickname: '會員暱稱',
    memberName: '會員姓名',
    membershipIdNumber: '會員證件號',
    activationTime: '激活時間',
    currentLevelDevelopmentSource: '當前等級發展來源',
    currentLevelPurchaseTime: '當前等級購買時間',
  },
  memberSaveReport: {
    downloadReport: '下載報表',
    totalAmountOfStoredValue: '儲值金額合計',
    totalGiftAmount: '贈送金額合計',
    totalConsumptionAmount: '消費金額合計',
    totalAmountOfRefund: '消費退款金額合計',
    user: '用戶',
    transactionType: '交易類型',
    storedValue: '儲值',
    consumptionRefund: '消費退款',
    membershipLevel: '會員等級',
    storedValueAmount: '儲值金額',
    amountOfRefund: '消費退款金額',
    memberStoredValueReport: '會員儲值報表',
    theMemberStoredValueReportIsSuccessfullyExported: '會員儲值報表導出成功',
    failedToExportTheMemberStoredValueReport: '會員儲值報表導出失敗',
    searchPlaceholder: '手機號/證件/姓名',
  },
  clientClient: {
    guestTag: '客人標籤',
    pleaseEnterYourContactInformation: '請輸入聯繫方式',
    pleaseEnterYourNationality: '請輸入國籍',
    pleaseEnterNationality: '請輸入民族',
    pleaseEnterAddress: '請輸入住址',
    age: '年齡',
    customerLabel: '客戶標籤',
    modifyGuestInformation: '修改客人信息',
    inputLabelDuplication: '輸入標籤重複',
    pleaseEnterTheLabelContent: '請輸入標籤內容',
    doNotEnterLabelsInMoreThan10Words: '輸入標籤不要超過10個字',
  },
  financeIndex: {
    pleaseCancelRenewFirst: '請先取消續住，再操作退房',
    addAnotherItem: '添加另一細目',
    checkInOrderNumber: '入住單號',
    adjustFinance: '調整財務',
    batchTransfer: '批量轉帳',
    checkOut: '掛賬退房',
    pleaseEnterTheRoomNumber: '請輸入房間號',
    pleaseEnterRoomTypeName: '請輸入房型名稱',
    pleaseEnterChannel: '請輸入渠道',
    pleaseEnterCheckInTime: '請輸入入住時間',
    pleaseEnterYourDepartureTime: '請輸入離店時間',
    pleaseEnterAccount: '請輸入科目',
    entryTime2: '入賬時間',
    pleaseEnterTheCreditDate: '請輸入入賬時間',
    consumptionAmountyuan: '消費金額（元）',
    pleaseEnterTheAmountSpent: '請輸入消費金額',
    paymentAmountyuan: '付款金額（元）',
    pleaseEnterThePaymentAmount: '請輸入付款金額',
    editBill: '編輯賬單',
    checkOut2: '結賬退房',
    cancelAccount: '撤銷結賬',
    partialClosing: '部分結賬',
    accountAdjustment: '調賬',
    smallGoodsAreAccountedFor: '小商品入賬',
    pleaseSelectAPaymentHistory: '請選擇付款記錄',
    pleaseFillInTheAmountOfPayment: '請填寫付款金額',
    yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting: '您的賬務信息為空，請入賬後再操作打印',
    theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect: '房單號不能為空,請檢查頁面路徑是否正確',
    smallwares: '小商品',
    creditOrdersDoNotSupportPartialCheckout: '信用住訂單不支持部分結賬',
    pleaseSelectTheOrderYouWantToCheckOut: '請選擇要結賬的訂單',
    creditBookingIsNotSupportedPleaseCheckOutDirectly: '信用住訂單不支持掛賬，請您直接結賬退房',
    pleaseSelectACover: '請選擇賬套',
    unionpayScanCode: '銀聯-掃碼',
    checkOutSuccessfully: '退房成功',
    securityDeposit: '押金',
    warmReminder: '溫馨提示',
    signOut: '注销',
    cancelled: '已註銷',
    the: '的',
    wheatDoorLockPlugInCancellationCard: '麥田門鎖插件註銷卡',
    whetherTheKeyCardHasBeenCancelled: '門卡是否已註銷',
    selectUnsettledAccountsWarning: '請選擇“未結賬”的賬務',
    feizhuRoomFeeValidation: '飛豬房費金額必須≥0，當前結賬房費:{roomRateFees}',
    feizhuNonRoomFeeValidation: '飛豬"非房費"金額必須≥0，當前"非房費"結賬房費:{fees}',
    pleaseSelectUnsettledAccounts: '請選擇未結帳的帳務',
    additionalChargeAmountEmpty: '加收金額為空，請再次操作',
  },
  financeMangementOld: {
    accountType: '賬戶類型',
    creditAccount: '信用賬號',
    prepaidAccount: '預付賬號',
    settlementPeriod: '結算賬期',
    maximumAmount: '最大額度',
    theMaximumMustBeGreaterThanZero: '最大額度必須大於零',
    theMaximumAmountCannotBeGreaterThan100Million: '最大額度不能大於一個億',
    theStartTimeCannotBeEqualToTheEndTime: '开始时间不能等于结束时间',
    theStartTimeCannotBeLaterThanTheEndTime: '開始時間不能大於結束時間',
    pleaseSelectAnEndTime: '請選擇結束時間',
    theEndTimeCannotBeEqualToTheStartTime: '結束時間不能等於開始時間',
    theEndTimeCannotBeLaterThanTheStartTime: '結束時間不能小於開始時間',
    pleaseEnterTheBillingPeriod: '請輸入結算週期',
    settlementPeriodCanOnlyBeEnteredInNumbers: '結算週期只能輸入數字',
    newAccount: '新增賬戶',
    pleaseFillInTheAccountName: '請填寫賬戶名稱',
    pleaseFillInTheCompanyName: '請填寫公司名稱',
    pleaseSelectAnAccountType: '請選擇賬戶類型',
    pleaseSelectAChannelName: '請選擇渠道名稱',
  },
  financeMangement: {
    creditAccount: '信用賬號',
    prepaidAccount: '預付賬號',
    enableConfirmation: '啟用成功後，該協議單位將支持掛賬，是否啟用？',
    disableConfirmation: '禁用成功後，該協議單位將不再支持掛賬，是否禁用？',
  },
  foodRoomAccountFinance: {
    foodSource: '餐飲來源',
    foodRoomAccountLabel: '餐飲掛房賬',
    foodOrderNo: 'Food訂單號',
    fmisAccountSerialNo: 'FMIS賬務流水號',
    chargedAmount: '掛賬金額',
    notAllowedSplit: '餐飲掛房賬不允許拆賬',
    notAllowedRush: '餐飲掛房賬不允許沖賬',
    notAllowedTransfer: '餐飲掛房賬不允許轉賬',
    notAllowedPartialSettlement: '餐飲掛房賬不允許部分結賬',
  },
  financeMixin: {
    onlinePaymentAccountsAreNotAllowedToOpen: '在線支付科目不允許拆賬',
    smallCommodityAccountsCanNotBeDismantled: '小商品科目不能拆賬',
    negativeDebtCannotBeBroken: '負賬不能拆賬',
    accountsReceivableAreNotAllowedToBeDebunked: '應收賬科目不允許拆賬',
    debitsAreNotAllowedInThisAccount: '該科目不允許拆賬',
    onlinePaymentRefundAccountDoesNotAllowForChargebacks: '在線支付退款賬務不允許做沖賬',
    theAccountHasBeenRefundedAndCannotBeCharged: '該賬務已退款，不允許沖賬',
    refundedAccountsCannotBeCharged: '已退款的賬務無法沖賬',
    thisAccountIsNotAllowedToBeCharged: '该科目不允许冲账',
    businessDayHasBeenSwitchedNoChargeIsAllowed: '營業日已切換，不允許沖賬',
    splitBill: '拆賬',
    refund: '退押',
  },
  detailcomponentsAccountlisttable: {
    onAccount: '已掛賬',
  },
  detailcomponentsAddjudge: {
    theRoomChargeIsExcessive: '加收房費過大',
    chargeJudgment: '加收判斷',
    addOnOption: '加收選項',
    generatedRoomCharge: '生成房費',
    pleaseFillInTheAdditionalRoomCharge: '請填寫加收房費',
    theAdditionalAmountCannotBe0: '加收金額不能為0',
  },
  detailcomponentsAdjustaccounts: {
    reconciliationSuccess: '调账成功',
    accountAdjustment: '調賬',
    accountOfReconciliation: '調賬科目',
    incorrectTransferAmountFormatupToTwoDecimalPlaces: '調賬金額格式不正確（最多兩位小數）',
    theTransferAmountCannotBe: '調賬金額不能為',
    theTransferAmountCannotBeGreaterThan100Million: '調賬金額不能大於一個億',
  },
  detailcomponentsArsuitselect: {
    receivableSet: '應收賬套',
    creditOrderCheckoutTip: '信用住訂單需在退房時掛賬',
    nonProtocolOrderArTip: '非協議單位訂單無法掛賬',
  },
  detailcomponentsBackout: {
    closedSuccessfully: '撤銷結賬成功',
    cancelAccount: '撤銷結賬',
    confirmationRevocation: '確認撤銷',
    pleaseSelectTheBillYouWantToCancel: '請選擇要撤銷的賬單',
  },
  detailcomponentsBorrow: {
    return: '歸還',
    itemBorrowingReminder: '物品借用提醒',
    borrowARoom: '借用房間',
    quantityBorrowed: '借用數量',
    returnQuantity: '歸還數量',
    loanDate2: '借用日期',
    returnOrNot: '是否歸還',
    whetherToReturnAll: '是否全部歸還',
    amountOfCompensation: '賠償金額',
    onlyNumbersGreaterThan0CanBeEntered: '只能輸入大於0的數字',
    partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed: '部分歸還只能小於借用數量',
    returned: '已歸還',
    noReturn: '未歸還',
    returnSuccessfully: '歸還成功',
  },
  detailcomponentsColorblock: {
    financialType: '財務類型',
    accountingType: '帳務類型',
    orderForGoods: '訂單',
  },
  detailcomponentsCommon: {
    unionpayScanCode: '银联-扫码',
    insufficientMemberBalance: '會員餘額為{balance}元，請選擇其他收款方',
  },
  detailcomponentsCreditsettletip: {
    creditSettleAlert: '提示：飛豬信用住訂單，實際結算房費{roomRate}元，結算非房費{nonRoomRate}元，請核實金額無誤後提交結賬退房',
  },
  detailcomponentsDivideaccounts: {
    additionalDebits: '添加拆賬',
    totalAmount: '總金額',
    totalDebitsTaken: '已拆賬合計',
    totalUndismantledLoans: '未拆賬合計',
    successfulDismantling: '拆賬成功',
    borrowMoney: '拆賬',
    loanAmount: '拆賬金額',
    upTo150Words: '最多150字',
    closedAccount: '已拆賬',
    tenAtMost: '拆賬最多十條',
    theAmountOfDebitsIsNotEqualToTheTotalAmount: '拆賬金額不等於總金額',
    theDebitAmountMustBeFilledInAndGreaterThan: '拆賬金額必填且大於',
  },
  detailcomponentsEnteraccount: {
    cashCnyReceipt: '人民幣現金收款',
    accountEntry: '入賬科目',
    amountRecorded: '入賬金額',
    pleaseFillInTheAmountOfPayment: '請填寫入帳金額',
    pleaseSelectAPaymentMethod: '請選擇支付方式',
    entriesCannotBeEmpty: '入帳科目不能為空',
    theAmountRecordedCannotBe: '入帳金額不能為0',
    pleaseFillInUnitPrice: '請填寫單價',
    unitPriceCannotBeZero: '單價不能為0',
    pleaseFillInServings: '請填寫份數',
    servingsCannotBeZero: '份數不能為0',
    pleaseSelectMealDate: '請選擇用餐日期',
    ArRefundCannotExceedBalance: 'Ar退款金額不能大於Ar餘額',
  },
  detailcomponentsExpandcolumn: {
    memberName: '會員姓名',
    receivableSet: '應收賬套',
    from: '從',
    orderForGoods: '訂單',
    rollOutTo: '轉出至',
    refundedAmount: '已退：{amount}元',
  },
  detailcomponentsHangaccounts: {
    checkOut: '掛賬退房',
    reasonForPayment: '掛賬原因',
  },
  detailcomponentsHourroomfeeconfirm: {
    roomRateConfirmation: '房費確認',
    roomRate2: '房費金額',
  },
  detailcomponentsPartsettle: {
    partialClosing: '部分結賬',
    pleaseFillInTheAmountOfPayment: '請填寫付款金額',
    pleaseSelectAPaymentHistory: '請選擇付款記錄',
  },
  detailcomponentsPreauthcheck: {
    authorizedSettlement: '授權結算',
  },
  detailcomponentsPreauthtemplate: {
    cancelAuthorizationPleaseWait: '取消授權中請稍後',
    succeededInCancelingAuthorization: '取消授權成功',
    thereIsAnOutstandingPreAuthorizationRecordInTheRoom: '房間中存在未結算的預授權記錄',
    confirmThatYouWantToCancelAuthorization: '確認要取消授權',
    roomPaymentRequired: '客房需{action}金額：',
    orderCanceledWarning: '订单已取消，无法{action}',
    roomCheckedInWarning: '房間已入住，無法{action}',
    roomCheckedOutWarning: '房間狀態為"已退房"，無法{action}',
  },
  detailcomponentsRefundtip: {
    refundReminder: '退款提示',
    whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid: '使用在線退款時，金額會退到客人付款的賬戶',
    whenUsingAOneCardRefundSystem: '使用一卡通退款時，金額會退到客人付款的賬戶',
  },
  detailcomponentsSmallwarecost: {
    smallwares: '小商品',
    smallGoodsEnteredTheAccountSuccessfully: '小商品入賬成功',
    smallGoodsAreAccountedFor: '小商品入賬',
    payOrNot: '是否支付',
    pleaseEnterTheExternalOrderNumber: '請輸入外部單號',
    pleaseSelectASmallItem: '請選擇小商品',
    insufficientMemberBalance: '會員餘額為{balance}元，請選擇其他收款方',
  },
  detailcomponentsTransferaccounts: {
    transferMoney: '转账 ',
    transferToAccount: '轉入賬號',
    pleaseSelectValidTransferAccount: '請選擇有效的轉入帳號',
    transferSuccess: '轉帳成功',
    batchTransferSuccess: '批量轉帳成功',
    originalStayWillBeCancelled: '原單續住將自動取消',
    notice: '提示',
    yes: '是',
    no: '否',
  },
  mangementMember: {
    orderType: '訂單類型',
    receivableOrders: '訂單應收賬',
    totalAmountNotApproved: '未核總金額',
    approvedTotalAmount: '已核總金額',
    amountAvailable: '可用金額',
    amountSpent: '已用金額',
    whetherToWriteOffAllTheReceivables: '是否要將應收賬全部核銷',
    whetherToReverseWriteOffAllTheReceivables: '是否要將應收賬全部反核銷',
    cancelAfterVerification: '核銷',
    reverseWriteOff: '反核銷',
    depositInAdvance: '預存款',
    dateOfPosting: '掛賬日期',
    pleaseEnterTheOrderNumber: '請輸入訂單號',
    completeWriteOff: '全部核銷',
    completeReverseWriteOff: '全部反核銷',
    batchWriteOff: '批量核銷',
    batchReverseWriteOff: '批量反核銷',
    records: '記錄',
    advanceCredit: '預付入賬',
    thePrepaidAmountMustBeGreaterThanZero: '預付金額必須大於零',
    theAmountInAdvanceCannotBeGreaterThan100Million: '預付金額不能大於一個億',
    checkTheDepartureDateUpToOneMonth: '離店日期最多查詢一個月',
    noAccountPleaseCreateANewOne: '沒有賬套，請新建',
    allWereSuccessfullyWrittenOff: '全部核銷成功',
    allWriteOffsFailed: '全部核銷失敗',
    noWriteOffIsAllowedOnTheDayReceivableIsGenerated: '應收賬生成當日不允許核銷',
    pleaseSelectTheItemsYouWantToWriteOff: '請選擇要核銷的項目',
    prepaymentAmountRequired: '請填寫預付金額',
    prepaymentAmountFormatError: '預付金額格式不正確（最多兩位小數）',
  },
  mangementTablerow: {
    paidInAmount: '實收金額',
  },
  mangementVerificatemodal: {
    successfulWriteOff: '核銷成功',
    cancelAfterVerification: '核銷',
    reverseWriteOff: '反核銷',
    generationTime: '生成時間',
    amountWrittenOff2: '核销金额',
    pleaseFillInTheWriteOffAmount: '請填寫核銷金額',
    theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff: '核銷金額不能大於可核銷金額',
  },
  mangementVerifyrecordsmodal: {
    records: '記錄',
    lot: '批次',
  },
  merchantChargeList: {
    accumulatedUncreditedNightsInArrearsDuringTheContractPeriod: '合同期內累計未抵扣欠間夜',
    hideZeroAmounts: '不顯示全部0元',
  },
  merchantCheckBill: {
    confirmationCheck: '確認核對',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill: '確認後將按照本賬單進行結算',
    appealChannel: '申訴渠道',
    causeOfAppeal: '申訴理由',
    youCanEnterUpTo150Words: '最多可輸入150字',
    accountName: '開戶名',
    roomBillCheck: '房單賬單核對',
    memberIncentiveCheck: '會員激勵核對',
    confirmed: '已確認',
    reasonForAdjustment: '調整原因',
    deductibleTarget: '抵扣目標',
    currentDeduction: '本期抵扣',
    deductible: '已抵扣',
    confirmationTime: '確認時間',
    rejectionTime: '駁回時間',
    liveLightlyInTheDirectCamp: '輕住直營',
    new: '新增',
    appealSuccessfully: '申訴成功',
    checkSuccessfully: '核對成功',
    currDeductionDesc: '1. 本期抵扣為正數，代表輕住抵扣商家金額2. 本期抵扣為負數，代表返還商家金額',
    qzMerchantSettleDesc: '輕住與商家結算=訂單總金額-本期抵扣',
  },
  merchantInfoManage: {
    changeLetter: '變更函',
    note: '注',
    paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount: '修改收款賬號需要通過審核後才能打款，如果當前有待支付結算款，仍將按照原賬戶打款',
    groundsForRejection: '駁回理由',
    downloadTheAttachmentTemplate2: '下載附件模板',
    viewingModificationLogs2: '查看修改日誌',
    save4: '保存',
    thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution: '該結算信息用於房費結算，僅限酒店老闆修改，請謹慎添加',
    thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired: '该收款账号用于房费结算，仅限酒店老板修改，请谨慎修改，按要求上传变更函并加盖公章',
    modifyLog2: '修改日誌',
    beforeModification3: '修改前',
    receivablesAccountManagement2: '收款賬號管理',
    bankAccountName4: '銀行開戶姓名',
    letterOfRequestForChange2: '申請變更函',
    pleaseEnterYourBankName2: '請輸入銀行開戶姓名',
    pleaseUploadTheRequestForChange2: '請上傳申請變更函',
    afterModification2: '修改後',
    afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile: '申請變更函，下載後需要打印出來簽字蓋章，再上傳圖片或者PDF文件',
    onlyJpgPngAndPdfFilesCanBeUploaded: '僅支持上傳jpg，png，pdf格式文件',
  },
  merchantMerchantHelper: {
    smallProgramSettlementRules: '小程序結算規則問題',
    settlementOfPaymentProblems: '結算打款問題',
    smallProgramSettlementRulesCommonProblems: '小程序結算規則常見問題',
    frequentlyAskedQuestionsAboutSettlementPayments: '結算打款常見問題',
    q1SettlementCriteria: 'Q1：什麼樣的賬單可以結算？',
    a1SettlementCriteria: '我们结算的口径是订单状态已完成，且已离店状态。',
    q2PmsCancellation: 'Q2：PMS賬單取消怎麼辦？',
    a2PmsCancellation: 'PMS是取消狀態，我們的結算標準是：客人要求取消後，退款給客人的，需要聯繫客服團隊，走退款流程。',
    q1AuditTime: 'Q1：結算審核的時間是什麼時候？',
    a1AuditTime: '每週五之前會將下週的直連結算賬單上傳結算系統，商家只需要在下個週四申請打款的時候確認賬單即可打款。',
    q2PaymentTime: 'Q2：商家已经确认账单了，什么时候打款？',
    a2PaymentTime: '已經確認賬單的商家，會在周四打款。往期打款失敗的商家同樣也會再週四--週五補打款打款。',
    q3CheckPayment: 'Q3：怎麼查看是否已經給商家打款了？',
    a3CheckPayment: '商家在打款記錄界面，可以查看是否已經打款。',
    q4RejectedStatement: 'Q4：對賬單被駁回了怎麼辦？啥時候打款？',
    a4RejectedStatement: '商家駁回的賬單，總部會再次進行審核，如總部調整完畢之後，商家趕在周四能夠確認賬單，則在周四打款，沒有確認的賬單會在下個週四申請打款。',
  },
  merchantRemitRecord: {
    roomChargePaymentRecords: '房費打款記錄',
    memberIncentiveRecord: '会员激励记录',
    fundsToBeRemitted: '待打款',
    remitting: '打款中',
    remittedMoney: '已打款',
    paymentFailure2: '打款失败',
    collectionAccount: '收款賬戶',
    payee: '收款人',
    statusUpdateTime: '状态更新时间',
    paymentTime: '打款時間',
    timeToInitiateAPayment: '發起打款時間',
  },
  merchantSettleInfo: {
    pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard: '請掃描雲賬戶二維碼 綁定銀行卡',
    save4: '保存',
    bindBankCard: '绑定银行卡',
    completeInformation: '補齊信息',
    bankAccountName4: '銀行開戶姓名',
    idNumber: '身份證號',
    pleaseEnterYourBankName2: '请输入银行开户姓名',
    pleaseEnterYourIdNumber2: '請輸入身份證號',
    idNumberFormatIsIncorrectPleaseReEnter: '身份證號格式錯誤，請重新輸入',
    phoneNumberFormatIsIncorrectPleaseReEnter: '手機號格式錯誤，請重新輸入',
    pleaseUpload: '請上傳',
    internalUserHidden: '內部用戶不可見',
    amountPendingPayment: '金額{amount}，會在稍後打款',
  },
  billCheckBillDetails: {
    channelDetails: '渠道詳情',
    whereToConnectDirectly: '去哪兒直連',
    drench: '輕住',
    cityWide: '同城',
    whereToGo: '去哪兒',
    distribution: '分銷',
    tradeCaravan: '商旅',
    statementOfAccount: '對賬單',
    qzSettleFormula: '輕住與商家結算=訂單結算金額+商家承擔退款+商家承擔優惠+商家公益金額',
    merchantDiscountNote: '當本期訂單發生退款時，商家承擔優惠金額為0',
  },
  billCheckBill: {
    turnDown: '駁回',
    ticketReceived: '已收票',
    forThePublic: '對公',
    forPrivacy: '對私',
    expenseDetail: '費用明細',
    confirmationCheck: '確認核對',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill: '確認後將按照本賬單進行結算',
    perfectInformation: '完善信息',
    causeOfAppeal: '申訴理由',
    youCanEnterUpTo150Words: '最多可輸入150字',
    creditDetails: '抵扣詳情',
    roomNightCreditDetails: '間夜抵扣詳情',
    invoiceManagement: '發票管理',
    sellersName: '销售方名称',
    invoiceNumber: '發票票號',
    invoiceDate: '發票日期',
    invoiceAmount2: '發票金額',
    electronicInvoiceOrNot: '是否電子發票',
    invoiceFile: '發票文件',
    save4: '保存',
    reasonForRejectingInvoice: '發票駁回原因',
    theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0: '订单总金额已包含上期账单轻住与商家结算金额小于0的金额',
    quantityDueForTheCurrentPeriod: '本期應抵數量',
    actualAmountOfDeductionForTheCurrentPeriod: '本期實際抵扣數量',
    amountDeductedForTheNightOfThePeriod: '本期間夜抵扣金額',
    uncreditedQuantityForTheCurrentPeriod: '本期未抵扣數量',
    pleaseEnter150WordsOrLess: '請輸入150字以內',
    pleaseEnterTheInvoiceHoldersInformation: '請輸入發票人信息',
    pleaseEnterTheInvoiceNumber: '請輸入發票票號',
    pleaseEnterExpiryDate2: '請輸入有效期',
    pleaseSelectTheInvoiceType: '請選擇發票類型',
    pleaseSelectWhetherToEInvoice: '請選擇是否電子發票',
    pleaseUploadTheInvoicePhoto: '請上傳發票照片',
    pleaseFillInTheAmount: '請填寫金額',
    specialTicket: '專票',
    ordinaryTicket: '普票',
    expenseItem: '費用項',
    amountIncurred: '發生金額',
    source: '來源',
    instructions: '說明',
    confirmationTime: '確認時間',
    groupReceiptStatus: '集團收票狀態',
    rejectionTime: '駁回時間',
    whetherTheInvoiceHasBeenEntered: '發票是否已錄入',
    feeDetails: '費用詳情',
    fileUpload: '文件上傳',
    uploadAMaximumOf5Images: '圖片最多上傳5張',
    appealSuccessfully: '申訴成功',
    checkSuccessfully: '核對成功',
    theSizeOfTheUploadedCompressedPackageCannotExceed: '上傳壓縮包大小不能超過',
    onlyTheUploadFormatIsSupported: '上傳格式只支持',
    theCompressedPackageFileCannotBeLargerThan: '压缩包文件不能大于',
    amountOfDeductionForTheCurrentPeriod: '本期抵扣金額',
    theMerchantNeedsToInvoiceTheAmount: '商家需開票金額',
    billingDetails: '账单详情',
    currentAdrAmount: '本期ADR金額',
    settlementSystemUpgrade: '為了滿足銀行對資金結算的要求，提高結算效率，完善結算資質信息，現集團對結算系統進行升級，現需要補充銀行要求的資質信息！',
    confirmPreviousBills: '請先確認往期賬單，否則新賬期賬單無法展示',
    paperInvoiceInstructions: '紙質發票，快遞為寄付，到付件一律駁回，發票收件人為：輕住分銷電子發票；電話：15901580289，若發票為紙質發票，則輕住收到票後審核發票',
    uploadFormatRestrictions: '注：支持pdf、圖片、word、壓縮包、ofd5種格式其中一種上傳。pdf和ofd最大支持5個，單個最大3M；圖片最大支持5張，單個最大3M，圖片格式包含jpg、jpeg、png；word最大支持1個，最大20M，壓縮包最大支持1個，最大20M，壓縮包支持rar、zip、7z',
    cumulativeUndeductedNights: '合同期內累計未抵扣欠間夜（本賬期抵扣前）',
    invoiceDuplicate: '發票票號重複，請檢查票號是否正確，若票號正確，請在備註中填寫重複使用相同發票的原因。',
    pdfSizeExceeded: '上傳pdf大小不能超過 3MB!',
    ofdSizeExceeded: '上傳ofd大小不能超過 3MB!',
    wordSizeExceeded: '上傳word大小不能超過 20MB!',
    singleFormatOnly: '僅支持1種格式!',
  },
  billCheckMemberDetails: {
    memberIncentiveDetails: '會員激勵詳情',
    memberIncentiveStatement: '會員激勵對賬單',
  },
  billDeductionDetails: {
    feeDetails: '費用詳情',
    statementDetailsSheet: '對賬單詳情單',
  },
  billRemitRecord: {
    collectionAccount: '收款賬戶',
    payee: '收款人',
    statusUpdateTime: '狀態更新時間',
    timeToInitiateAPayment: '發起打款時間',
    paymentTime: '打款時間',
  },
  billCheckDetails: {
    channelOrderDetails: '渠道訂單詳情',
    merchantRefunds: '商家承擔退款',
    merchantConcession: '商家承担优惠',
    channelOrderNumber: '渠道訂單號',
    reasonForAdjustment3: '調整理由',
    adjustmentType: '調整類型',
    originalOrderPrice: '訂單原價',
    memberDiscount: '會員折扣',
    skimpingOnCommission: '輕住佣金',
    payChannelCommission: '支付渠道佣金',
    amountOfMerchantWelfare: '商家公益金額',
    refundNight: '退款間夜',
    totalRefundAmount: '退款總金額',
    stayEasyAndRefundCommission: '輕住退款佣金',
    subsidy: '補貼',
    saleCardOrderNumber: '售卡訂單號',
    membershipLevel: '會員級別',
    dateOfRegistration: '註冊日期',
    referrer: '推薦人',
    amountPaid: '支付金額',
    merchantsShareTheAmount: '商家分潤金額',
    employeeShareAmount: '員工分潤金額',
    shareAmount: '分潤金額',
    rebateRatio: '返佣比例',
    commissionRebate: '返佣金額',
    distributionSubchannel: '分銷子渠道',
    channelCost: '渠道原價',
    lightSettlementWithMerchantsOrder: '輕住與商家結算（訂單）',
    lightUndertakeDiscounts: '輕住承擔優惠',
  },
  billDedetails: {
    currentAmountReceivable: '本期應收金額',
    amountOfDeductionForTheCurrentPeriod: '本期抵扣金額',
    remainingAmountOfDeduction: '剩餘抵扣金額',
    pleasureManagementFee: '悅享管理費',
    brandManagementFee: '品牌管理費',
    mastersCommission: '店長費用',
    otherExpenses: '其他費用',
    openingDate: '開業日期',
    preferentialPolicy: '優惠政策',
    managementFeeStartDate: '开始收取管理费日期',
    thisPeriodOfBusinessSelfPromotion: '本期商家自促',
    enjoyCommissionRate: '悅享佣金率',
    enjoyManagementFeeForThisPeriod: '本期悅享管理費',
    currentAdjustmentExpense: '本期調整費用',
    reasonsForAdjustingExpensesInTheCurrentPeriod: '本期調整費用原因',
    notPaidInThePreviousPeriod: '上期未繳',
    currentReceivable: '本期應收',
    currentPaid: '本期已繳',
    balanceDue: '剩餘應繳',
    brandCommissionRate: '品牌佣金率',
    currentBrandManagementFee: '本期品牌管理費',
    monthlyRate: '月收費標準',
    currentObjective: '本期目標',
    totalPmsRevenueForThePeriod: '本期PMS總營收',
    totalPmsReceivableForThePeriod: '本期PMS總應收',
  },
  chargeIndex: {
    expenseItem: '費用項',
    totalAmountPayable: '應付總金額',
    cashPayable: '現金應付',
    creditPayable: '抵扣應付',
    deductionAdjustment: '抵扣調整',
    deductible: '已抵扣',
    residualCredit: '剩餘抵扣',
    managementFeeStartDate: '開始收取管理費日期',
    currentObjective: '本期目標',
    currentPeriodAdjustment: '本期調整',
    notPaidInThePreviousPeriod: '上期未繳',
    currentReceivable: '本期應收',
    currentPaid: '本期已繳',
    balanceDue: '剩餘應繳',
  },
  commonIndex: {
    accountName: '開戶名',
    collectionAccountType: '收款賬號類型',
    distributionRoomBillReconciliation: '分銷房費賬單核對',
    memberIncentiveCheck: '會員激勵核對',
    directSellingRoomFeePaymentRecords: '直銷房費打款記錄',
    distributeRoomChargePaymentRecords: '分銷房費打款記錄',
    memberIncentiveRecord: '會員激勵記錄',
    confirmed: '已確認',
    reasonForAdjustment: '調整原因',
    settlementGrounds: '結算理由',
    operationDetails: '操作詳情',
    merchantRefunds: '商家承擔退款',
    merchantConcession: '商家承擔優惠',
    amountOfMerchantWelfare: '商家公益金額',
    americanOrder: '美團訂單',
    flyingPigOrder: '飛豬訂單',
    lightLiveMiniProgramOrder: '輕住小程序訂單',
    memberShareAmount: '會員分潤金額',
    theAmountOfCrossStoreRefund: '跨店返佣金額',
    lightlyAdjustTheAmount: '輕住調整金額',
    reasonForAdjustment3: '調整理由',
    fundsToBeRemitted: '待打款',
    remitting: '打款中',
    remittedMoney: '已打款',
    paymentFailure2: '打款失敗',
    lightSettlementWithMerchantsOrder: '輕住與商家結算（訂單）',
  },
  infoInfoManage: {
    note: '注',
    theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture: '申請變更函，下載後需要打印出來簽字蓋公章，如打印為2頁，請加蓋騎縫章，再上傳圖片',
    submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade: '提交修改收款賬戶審核流程，審核通過後才能打款，駁回的賬戶，不予打款',
    beforeModification3: '修改前',
    pleaseBePatientWhileTheInformationIsBeingReviewed: '信息審核中，請耐心等待',
    groundsForRejection: '駁回理由',
    downloadTheAttachmentTemplate2: '下載附件模板',
    forPrivacy: '对私',
    forThePublic: '對公',
    auditStatus: '審核狀態',
    viewingModificationLogs2: '查看修改日誌',
    save4: '保存',
    pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress: '請盡快上傳銀行卡信息，以免影響您的結算進度',
    modifyLog2: '修改日誌',
    receivablesAccountManagement2: '收款账号管理',
    collectionAccountType: '收款賬號類型',
    pleaseSelectACollectionAccountType: '請選擇收款賬號類型',
    bankAccountName5: '銀行開戶名稱',
    recipientsCellPhoneNumber: '收款人手機號',
    pleaseEnterTheRecipientsMobilePhoneNumber: '請輸入收款人手機號',
    payeeIdNumber: '收款人身份證號',
    pleaseEnterThePayeeIdNumber: '請輸入收款人身份證號',
    payeeIdCardFront: '收款人身份證正面',
    reverseOfPayeeIdCard: '收款人身份證反面',
    uploadContractAttachment: '上傳合同附件',
    letterOfRequestForChange2: '申請變更函',
    pleaseEnterTheBankAccountName: '請輸入銀行開戶名稱',
    pleaseEnterTheLegalPersonName: '請輸入法人姓名',
    legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter: '法人姓名只能输入汉字，请重新输入',
    phoneNumberFormatIsIncorrectPleaseReEnter: '手機號格式錯誤，請重新輸入',
    pleaseEnterYourIdNumber2: '請輸入身份證號',
    idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter: '身份證號格式錯誤，只能輸入數字和大寫字母，請重新輸入',
    pleaseEnterAUnifiedSocialCreditCode: '請輸入統一社會信用代碼',
    onlyNumbersAndLettersAreSupportedPleaseReEnter: '僅支持數字和字母，請重新輸入',
    pleaseUploadTheRequestForChange2: '請上傳申請變更函',
    frontOfIdentityCard: '身份證正面',
    reverseOfIdCard: '身份證反面',
    businessLicense: '營業執照',
    pleaseUploadTheContractAttachment: '請上傳合同附件',
    afterModification2: '修改後',
    corporateName: '法人姓名',
    unifyTheSocialCreditCode: '統一社會信用代碼',
    legalPersonMobilePhoneNumber: '法人手機號',
    pleaseEnterTheFrenchPhoneNumber: '請輸入法人手機號',
    legalPersonIdNumber: '法人身份證號',
    pleaseEnterTheCorporateIdNumber: '請輸入法人身份證號',
    corporateIdentityCardFront: '法人身份證正面',
    reverseOfCorporateIdentityCard: '法人身份證反面',
    pleaseUpload: '請上傳',
    fileUpload: '文件上傳',
    uploadAMaximumOf2Images: '最多上傳2張圖片',
    theSizeOfTheUploadedProfilePictureCannotExceed: '上傳頭像圖片大小不能超過',
    uploadPictureFormatOnlySupported: '上傳圖片格式只支持',
    onlyJpgJpegAndPngFilesCanBeUploaded: '僅支持上傳jpg，jpeg，png格式文件',
    onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto: '僅支持上傳jpg，jpeg，png格式文件,請將變更函拍成一張照片上傳',
    pleaseWaitFileUploadIsNotComplete: '請等待，文件上傳尚未完成',
    contractStampPageRequired: '合同盖章页面（必选）',
    otherPagesOptional: '其他頁（選填，最多上傳2張）',
    contractStampInstructions: '2、合同蓋章頁：需有乙方收款賬戶信息頁面，並蓋公章，上傳符合要求的合同蓋公章頁面；',
    individualMobileNote: '注：如個體工商戶則填寫經營者手機號',
    individualNameNote: '注：如個體工商戶則填寫經營者姓名',
    individualIdNote: '注：如個體工商戶則填寫經營者身份證號',
    individualRegNumberNote: '注：如個體工商戶則填寫註冊號',
    maxTwoImages: '最多上傳2張圖片',
    recipientLegalMobile: '收款人/法人手機號',
    recipientLegalIdNumber: '收款人/法人身份證號',
  },
  invoicingAddInvoicingApplication: {
    billingApplication: '開票申請',
    expenseType: '費用類型:',
    totalAmountApplied: '申請金額合計',
    theApplicationAmountIsIncorrect: '申請金額填寫有誤',
    status: '狀態:',
    causeOfRejection: '駁回原因:',
    billingInformation: '開票信息:',
    pleaseEnterPhoneNumber: '請輸入電話',
    dutyNumber: '稅號',
    pleaseEnterYourTaxId: '請輸入稅號',
    pleaseEnterYourAccountBank: '請輸入開戶行',
    pleaseEnterTheAddress: '請輸入地址',
    openABankAccount: '開戶行賬號',
    pleaseEnterYourBankAccountNumber: '請輸入銀行賬號',
    pleaseEnterEmail: '請輸入郵箱',
    pickUpTelephone: '收件電話',
    pleaseEnterTheReceivingPhoneNumber: '請輸入收件電話',
    mailingAddress: '郵寄地址',
    pleaseEnterYourMailingAddress: '請輸入郵寄地址',
    addressee: '收件人',
    pleaseEnterTheRecipient: '請輸入收件人',
    repudiationPeriod: '駁回賬期:',
    claimPeriod: '申請賬期:',
    pleaseEnterTheAmountRequested: '請輸入申請金額',
    theNumberCannotExceed15Digits: '號碼不能超過15位',
    pleaseEnterTheCorrectNumber: '請輸入正確的號碼',
    paymentPeriod: '賬期',
    availableAmount: '可開金額',
    amountApplied2: '申請金額',
    pleaseSelectTheBillingType5: '請選擇開票類型',
    receipt: '收據',
    pleaseEnterTitle: '請輸入抬頭',
    theCurrentlySelectedFeeTypeDoesNotHaveBillingDataPleaseSelectAgain: '當前所選費用類型無開票數據，請重新選擇',
    theTotalApplicationAmountNeedsToBeGreaterThan: '申請金額合計需要大於',
    invoicingTypeAndFeeTypeDoNotCorrespondTheReceiptCanOnlyMatchTheDepositAndQualityDeposit: '開票類型和費用類型不對應,收據只能匹配保證金和品質保證金',
    thePageIsAutomaticallyClosed5SecondsAfterSubmission: '提交成功 5s後自動關閉頁面',
    generalInvoice: '普票(電子發票)',
    specialInvoice: '專票(電子發票)',
  },
  invoicingInvoicingApplication: {
    applicationDate: '申請日期',
    billingApplication: '開票申請',
    expenseType: '费用类型',
    amountApplied2: '申請金額',
    expressNumber: '快遞號',
    alreadyRequested: '已申請',
  },
  preauthorizationIndex: {
    turn: '轉',
    increaseAuthorization: '增加授權',
    authorizationFailure: '授權失敗',
    settlementTime: '結算時間',
    preAuthorizationDetailsLightWinTreasureHotelManagementSystem: '預授權明細 - 輕贏寶酒店管理系統',
    declined: '已拒絕',
    flyingPigCreditDoesNotSupportPreAuthorization: '飛豬信用住暫未支持預授權',
    newAuthorization: '新增授權',
    cancelAuthorizationPleaseWait: '取消授權中請稍後',
    succeededInCancelingAuthorization: '取消授權成功',
    pleaseWaitForTheSettlementAuthorization: '結算授權中請稍後',
    confirmThatYouWantToCancelAuthorization: '確認要取消授權',
    orderStatusWarning: '訂單{status}，無法{action}',
    roomStatusWarning: '房間已入住，無法{action}',
    roomCheckoutWarning: "房間狀態為'已退房'，無法{action}",
  },
  componentsAuthsettle: {
    payment3: '支付',
    paidInAmount: '實收金額',
    settlementSuccess: '結算成功',
    authorizedSettlement: '授權結算',
    accountEntry: '入賬科目',
    pleaseFillInTheAuthorizedAmount: '請填寫授權金額',
    theActualAmountReceivedMustBeGreaterThan0: '實收金額必須大於0',
    theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount: '實收金額不能大於授權金額',
  },
  componentsBanklist: {
    bankOfChina: '中國銀行',
    industrialAndCommercialBankOfChina: '中國工商銀行',
    industrialAndCommercialBankOfChina3: '工商銀行',
    agriculturalBankOfChina: '中國農業銀行',
    agriculturalBankOfChina3: '農業銀行',
    chinaConstructionBank: '中國建設銀行',
    chinaConstructionBank3: '建設銀行',
    postalSavingsBankOfChina: '中國郵政儲蓄銀行',
    postalSavingsBank: '郵儲銀行',
    bankOfCommunications: '交通銀行',
    chinaMerchantsBank: '招商銀行',
    shanghaiPudongDevelopmentBank: '上海浦東發展銀行',
    shanghaiPudongDevelopmentBank3: '浦發銀行',
    chinaCiticBank: '中信銀行',
    everbrightBank: '光大銀行',
    chinaMinshengBank: '中國民生銀行',
    minshengBank: '民生銀行',
    guangdongDevelopmentBank: '廣東發展銀行',
    guangfaBank: '廣發銀行',
    pingAnBank: '平安銀行',
    industrialBank: '興業銀行',
    huaxiaBank: '華夏銀行',
    bankOfShanghai: '上海銀行',
    bankOfBeijing: '北京銀行',
    bohaiBank: '渤海銀行',
    zheshangBank: '浙商銀行',
    huishangBank: '徽商银行',
    hsbc: '匯豐銀行',
    hangSengBank: '恆生銀行',
    hengfengBank: '恆豐銀行',
  },
  componentsExpandcolumn: {
    bankName: '銀行名稱',
    authorizationCode: '授權碼',
    from: '從',
    rollOutTo: '轉出至',
  },
  componentsTransferaccounts: {
    transferMoney: '轉賬',
    transferToAccount: '轉入賬號',
    authorizationFailure: '授權失敗',
  },
  componentsUpdateauthorization: {
    automaticSettlementAfterExpiration: '有效期到期後自動結算',
    authorizationCode: '授權碼',
    bankName: '銀行名稱',
    pleaseFillInTheAuthorizedAmount: '請填寫授權金額',
    newAuthorization: '新增授權',
    modifyAuthorization: '修改授權',
    renewal: '更新',
  },
  componentsCancelorder: {
    reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation: '提示：該訂單為EB單，取消前請核實OTA訂單狀態',
    orderCancelledSuccessfully: '訂單取消成功',
    cancelAnOrder2: '取消訂單',
    cancellationReason: '取消原因',
    remarks5100Words: '備註（5-100文字）',
    replyTextMinimum5Words: '回复文字最少5個字',
    pleaseSelectACancellationReason: '請選擇取消原因',
    originalStayWillBeCancelled: '原單續住將自動取消',
    cancellationRules: '取消規則',
    channelDescription: '渠道說明',
    refundScore: '是否退還積分',
    refundCoupon: '是否退還優惠券',
    orderMessage: '訂單留言',
    pleaseEnterOrderMessage: '請輸入訂單留言',
    directCancelSuccessComment: '訂單取消成功',
  },
  componentsEditcontactinfo: {
    modifiedSuccessfully2: '修改成功',
    modifyAContact: '修改聯繫人',
    pleaseEnterThe11DigitPhoneNumber: '請輸入11位手機號',
  },
  componentsEditorder: {
    modifyTheOrder2: '修改訂單',
    selectDate1: '選擇日期1',
    selectDate2: '選擇日期2',
    contactNumber4: '聯繫人電話',
    theRetentionTimeMustNotBeLessThanTheCurrentTime: '保留時間不得小於當前時間',
    theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime: '保留時間不得小於預抵時間',
    theRetentionTimeMustNotBeLongerThanThePreDepartureTime: '保留時間不得大於預離時間',
    doNotRepeatThisOperationWhileSubmittingChanges: '正在提交修改請不要重複操作',
    orderModificationSuccessful: '訂單修改成功',
  },
  componentsEditOrderV2: {
    addedRoomsOverAvailability: '新增房間數不能大於可訂數',
    arrivalBeforeToday: '新增房單入住日期不能早於當前日期',
    assignedRoom: '已排房 {room}',
    availabilityLoading: '正在載入當前房型可訂數，請稍後再試',
    availableCount: '可訂數：{count}',
    checkedInRoom: '已入住 {room}',
    checkedOutRoom: '已退房 {room}',
    chooseArrivalTime: '選擇入住時間',
    chooseDepartureTime: '選擇離店時間',
    detailLoadFailed: '新版修改訂單資料載入失敗',
    detailLoadRetry: '新版修改訂單資料載入失敗，請重試',
    discountLabel: '門市價{discount}%優惠',
    invalidStay: '請選擇正確的入住時間和離店時間',
    keepOneRoom: '修改後訂單至少保留一個有效房單',
    latestPriceFailed: '最新房價載入失敗，請調整抵離時間後重試',
    latestPriceLoading: '正在載入最新房價，請稍後提交',
    longStayAtLeastTenDays: '長包房的抵離時間間隔至少為10天',
    longStayAtMostOneYear: '長包房的抵離時間間隔最多為一年',
    longStayNoMorning: '長包房不允許凌晨房',
    markedCancelled: '已標記取消',
    newRoomOrder: '新增房單',
    newRoomPriceLoading: '正在載入新增房單住期和房價，請稍後提交',
    noReducibleRoom: '當前房型沒有可減少的臨時房單或待入住房單',
    otherStatus: '其他狀態',
    phonePlaceholder: '請輸入手機號碼',
    productPriceFailed: '門店產品和房價載入失敗，請重試',
    roomNumberValue: '房間號 {room}',
    roomOrderDetails: '明細',
    roomTypeInfo: '房型資訊',
    roomTypeNoProduct: '當前房型沒有可用門店產品',
    stayChangedClearRoom: '住期已變更，原排房已清空，請重新排房',
    stayPriceRefreshFailed: '抵離時間變更後的房價載入失敗，請重試',
    stayProductPriceFailed: '所選住期的門店產品和房價載入失敗，請重試',
    stayProductUnavailable: '當前房型在所選住期沒有可用門店產品',
    storeProductMissing: '未查詢到門店產品',
    temporaryRoomOrder: '臨時房單',
    unassignedSummary: '待排房 {count} 間',
  },
  componentsEditroomorder: {
    modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder: '修改協議單位信息會重新計算訂單中所有房間的房價',
    modifyRoomList: '修改房單',
  },
  componentsEditroomprice: {
    modifyTheHousePrice: '修改房價',
    theCurrentPriceCalendarCannotBeModified: '當前價格日曆不可修改',
    updatePriceCalendarSuccessfully: '更新价格日历成功',
  },
  componentsLevelup: {
    payTheBill: '付費',
    partUpgrade: '份 升級',
    confirmTheUpgrade: '確認升級',
    currentRoomType: '當前房型',
    reselection: '重選',
    chargeOrNot: '是否收費',
    currentTotalHousePrice: '當前總房價',
    totalRateAfterUpgrade: '升級後總房價',
    priceDifference: '差價',
    upgradeCause: '升級原因',
    enterAMaximumOf150Words: '最多輸入150字',
    pleaseChooseWhetherToCharge: '請選擇是否收費',
    pleaseEnterTheUpgradeReason: '請填寫升級原因',
    inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0: '付費情況下 差價不能小於等於0',
    reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference: '提示：夜審後至06:00間升級房型，請手工處理房型差價',
  },
  componentsSeeroomprice: {
    viewRoomRates: '查看房價',
  },
  componentsStay: {
    theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate: '當前房型已售完，請選擇其他日期',
    existingRoomSingleChargeCheckOut: '現房單掛賬退房',
    theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill: '現房單賬務轉至新房單後退房',
    promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms: '提示：當前房間為聯房單，續住後需手工將新房單加入聯房',
    nonStoreSingleCanNotSustain: '非門店單不支持續住',
    youCannotRenewYourStayUntilTheCheckOutDate: '未到離店日期,不可辦理續住',
    extendStayadvance: '續住/提前',
    originalOrder2: '原訂單',
    continuationPrice: '續住價格',
    changeTheCheckOutTime: '變更離店時間',
    selectDateTime: '選擇日期時間',
    continuationPriceRule: '續住價格規則',
    swapOrder: '換訂單',
    nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation: '預訂人姓名、手機號',
    subscriber: '預訂人',
    roomAccountProcessing: '房賬處理',
    pleaseSelectTheRenewalPriceRule: '請選擇續住價格規則',
    checkOutTimeCannotBeLessThanTheCurrentTime: '離店時間不能小於當前時間',
    theRenewalOfStayIsSuccessful: '辦理續住成功',
    pleaseSelectANewOrder: '請選擇新訂單',
    theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder: '換單續住不支持飛豬信用住訂單',
    extendStayadvanceSuccess: '續住/提前離店成功',
    roomNumber: '房號',
    checkInPerson: '入住人',
    checkOutTime: '離店時間',
    makeCard: '製卡',
    booked: '入賬',
    close: '關閉',
  },
  componentsTools: {
    pendingClosing: '待申請結賬',
    closingSuccessful: '申請結賬成功',
    failedToApplyForClosing: '申請結賬失敗',
    firstNightRate: '首晚房價',
    lateNightRate: '末晚房價',
    maximumHousePrice: '最高房價',
    minimumRoomRate: '最低房價',
  },
  ebkorderIndex: {
    priceDescription: '價格說明',
    merchantPromotionTotalAmountBorneByTheMerchant: '商家促銷=商家承擔的金額合計',
    totalSellingPriceTotalOrderAmountMerchantPromotion: '賣價總額=訂單總額-商家促銷',
    totalCommissionTotalSellingPriceCommissionRate: '佣金總額=賣價總額*佣金率',
    totalBasePriceTotalSellingPriceTotalCommission: '底價總額=賣價總額-佣金總額',
    userPaymentAmountActuallyPaidByTheUser: '用戶支付=用戶實際支付的金額',
    totalOrder: '訂單總額',
    totalSellingPrice: '賣價總額',
    userPayment: '用戶支付',
    totalCommission: '佣金總額',
    totalFloorPrice: '底價總額',
    merchantPromotion: '商家促銷',
    viewOrder: '查看訂單',
    orderTransferMethod: '搬單方式',
    removalOfOrder: '搬單',
    contactAndMobilePhoneNumber: '聯繫人、手機號',
    channelOrderStatus: '渠道訂單狀態',
    orderStatus: '搬單狀態',
    channelOrderNumber: '渠道訂單號',
    sellingPrice2: '賣價',
    floorPrice2: '底價',
    channelType: '渠道房型',
    expectedArrivalexpectedDeparture: '預抵/預離',
    bookingType: '預訂類型',
    estimatedTimeOfArrival: '預計到店時間',
    orderCreationTime: '訂單創建時間',
    inBooking: '預訂中',
    bookingFailed: '預訂失敗',
    bookingException: '預訂異常',
    initialRejection: '初次拒絕',
    canceling: '取消中',
    otherStates: '其他狀態',
    movedOrder: '已搬單',
    unmovedOrder: '未搬單',
    ebkOrderCheckMsg: '暫無資料，點擊補錄',
  },
  ebkorderUnbindtip: {
    youDoNotHaveAMeituanAccount: '您還未綁定美團賬戶',
    pleaseSetItInmoresystemSettingsebAccountAuthorization: '請在【更多】-【系統設置】-【EB賬號授權】中設置',
    clickToGo: '点击前往',
  },
  invoiceInvoiceDetail: {
    personage: '个人',
    firm: '企业',
    headerType: '抬头类型',
    invoiceAmount2: '发票金额',
    pleaseEnterTheInvoiceAmount: '请输入发票金额',
    pleaseEnterTheInvoiceNumber2: '請輸入發票號',
    invoiceGroup: '開票組單',
    selectRoomList: '選擇房單',
    orderAmount: '訂單金額',
    pleaseEnterTheInvoiceTitleToSearch: '請輸入發票抬頭進行搜索',
    pleaseEnterYourTaxIdentificationNumber: '請輸入納稅識別號',
    unitAddress: '單位地址',
    pleaseEnterTheAddressOfTheUnit: '請輸入單位地址',
    telephoneNumber: '電話號碼',
    bankOfDeposit2: '開戶銀行',
    pleaseEnterYourBank: '請輸入開戶銀行',
    bankAccount: '銀行賬戶',
    pleaseEnterYourBankAccount: '請輸入銀行賬戶',
    pleaseEnterYourEmailAddress: '請輸入電子郵箱',
    invoiceMailingAddress: '發票郵寄地址',
    pleaseEnterTheInvoiceMailingAddress: '請輸入發票郵寄地址',
    billingNote: '開票備註',
    pleaseEnterYourBillingRemarks: '請輸入開票備註',
    pleaseSelectTheBillingType5: '請選擇開票類型',
    pleaseSelectAHeaderType: '請選擇抬頭類型',
    fillInAtLeastOneEMailAndMailingAddress: '電子郵箱和郵寄地址至少填寫一個',
  },
  invoiceInvoiceList: {
    toBeInvoiced: '待開票',
    pleaseEnterYourTaxIdentificationNumber: '請輸入納稅識別號',
    pleaseEnterTheInvoiceNumber2: '請輸入發票號',
    newInvoice: '新增發票',
    invoiceType: '發票類型',
    invoiceAmount: '開票金額',
    billingTime: '開票時間',
  },
  invoiceRoomInvoiceAssociationSearch: {
    roomListInvoiceList2: '房单发票列表',
    namePhoneNumberRoomNumber: '入住人姓名，手機號，房間號',
  },
  invoiceRoomInvoiceList: {
    roomListInvoiceList2: '房單發票列表',
    accumulatedInvoiceAmount: '累計發票金額',
    toBeInvoiced: '待開票',
    newInvoice: '新增發票',
    invoiceType: '發票類型',
    invoiceAmount: '開票金額',
    billingTime: '開票時間',
  },
  orderListBaseinfo: {
    getThePhoneNumber: '獲取手機號',
    preSaleVoucherNumber: '預售券單號',
    contractNumber: '合同編號',
    invoice: '發票',
    promotionalActivity: '促銷活動',
    estimatedSettlementAmount: '預估結算金額',
    pack: '禮包',
    save4: '保存',
    selfServiceReservation: '自助機預訂',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2: '該訂單由銷售渠道向客人提供發票',
    thisOrderIsInvoicedByYourHotelToTheGuest: '該訂單由您的酒店向客人提供發票',
    theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill: '該金額僅供參考，具體結算金額請以賬單為準',
    systemRemark: '系統備註',
    sellerRemark: '商家備註',
  },
  orderListCheckIn: {
    handleSuccessfully: '辦理成功',
    viewCheckInInformation: '查看入住信息',
    handleAgain: '重新辦理',
    handlingFailure: '辦理失敗',
    theNameCannotBeBlank2: '姓名不能為空',
    theIdTypeCannotBeEmpty: '證件類型不能為空',
    theIdNumberCannotBeEmpty: '證件號碼不能為空',
    pleaseArrangeTheRoomFirst: '請先排房',
    checkInData: '入住登記單數據',
  },
  orderListDetail: {
    checkInStatus: '入住情況',
    total: '共',
    chargedToAccount: '已掛帳',
    natureTraffic: '自然流量',
    natureOrderTip: '該訂單為輕住直銷渠道帶來的自然流量訂單',
    preCheckInForm: '預入住單',
    continuationOrder: '續住訂單',
    liveOnCredit: '信用住',
    preSaleVoucherReservationForm: '預售券預約單',
    meituanEbOrder: '美團EB單',
    ctripEbOrder: '攜程EB單',
    flash: '閃住',
    fullGuarantee: '全額擔保',
    roomListInformation: '房單信息',
    automaticRowHouse: '自動排房',
    bulkCheckIn: '批量入住',
    unterracedHouse: '未排房',
    upgrades: '升級',
    checkIn2: '入住',
    prefabricatedKeyCard: '預製門卡',
    modifyTheOrder2: '修改訂單',
    cancelAnOrder2: '取消訂單',
    rejectAnOrder: '拒單',
    pleaseArrangeTheRoomBeforePreformingTheKeyCard: '請先排房後再預製門卡',
    theListingHasBeenCancelled: '該房單已被取消',
    noRoomingAllowedAfterThePreDepartureTime: '超過預離時間不允許排房',
    allListingsAreAlreadyFurnished: '所有房單均已排房',
    theAutomaticPlatoonSucceeded: '自動排房成功',
    someRowhousesAreSuccessful: '部分排房成功',
    smartCheckInBusinessHasNotOpenedTheFunction: '智慧入住商家暫未開通該功能',
    thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal: '該訂單為續住訂單，辦理入住可能影響原房間續住',
    thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom: '該訂單為續住訂單，繼續辦理可能影響原房間續住',
    exceedDepartureDate: '已超過預離日期，不允許升級房型',
    theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom: '當前時間已超過離店時間，不支持升級改房間',
    cancelingTheCurrentRowSucceededProcedure: '取消當前排房成功',
    orderAcceptedSuccessfully: '接單成功',
    successfulRejection: '拒單成功',
    thisActionWillCancelTheListingWhetherToContinue: '此操作將取消房單, 是否繼續',
  },
  orderListGiftinfodetail: {
    packageName: '禮包名稱',
    packageValue: '禮包價值',
    wayOfGiving: '贈送方式',
    dateOfPresentation2: '贈送日期',
    packageDetails: '禮包詳情',
    oneDeliveryPerRoom: '每間房送一次',
    complimentaryOnceADayPerRoom: '每間房每日贈送一次',
  },
  orderListOrderDetail: {
    orderDetails: '訂單詳情',
    finance3: '財務',
    preAuthorizationDetail: '預授權明細',
  },
  orderListOrderList: {
    durationOfResidence: '在住時間',
    bookingTime: '预订时间',
    preCheckInForm: '預入住單',
    housePig: '房小豬',
    presaleTicket: '預售券',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery: '姓名、手機號、訂單號、渠道單號查詢',
    multipleSearch: '综合查詢',
    selfServiceReservation: '自助機預訂',
    rejectAnOrder: '拒單',
    individualTraveler: '散客',
    team2: '團隊',
    estimate: '預抵',
    firstDayPrice: '首日價',
    areYouSureYouWantToTakeTheOrder: '您確定要接單嗎',
    orderAcceptedSuccessfully: '接單成功',
    booked: '已預訂',
    refused: '已拒絕',
    extendStayCheckInImpact: '該訂單為續住訂單，辦理入住可能影響原房間續住',
    exceededDepartureCannotUpgrade: '已超過預離日期6點，不允許升級房型',
    exceededCheckoutCannotUpgrade: '當前時間已超過離店時間，不支援升級改房間',
    exceededDepartureCannotArrangeRoom: '超過預離時間不允許排房',
    preArrivalNotArrived: '預抵未到',
    noshow: '預抵未到',
  },
  orderListNoShow: {
    title: 'NoShow',
    noshowReason: 'NoShow原因',
    remarkPlaceholder: '備註（5-100文字）',
    remarkMinLength: '回覆文字最少5個字',
    pleaseSelectNoshowReason: '請選擇NoShow原因',
  },
  orderListPricedetail: {
    channelCost: '渠道原價',
    eventDiscount: '活動優惠',
    guestActivityDiscount: '客人活動優惠',
    memberDiscount: '會員折扣',
    guestMembershipDiscount: '客人會員折扣',
    sameTripExclusiveOffer: '同程專享優惠',
    guestTongchengExclusiveDiscount: '客人同程專享優惠',
    guestPurchasePrice: '客人购买价格',
    activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests: '活動優惠、酒店賣價說明：該渠道客人與結算賬單會存在差異，可點擊“價格提示”查看客人實際金額',
    priceDetails: '價格詳情',
    sellingPrice2: '賣價',
    floorPrice2: '底價',
    memberBenefits: '會員優惠',
    jointMemberBenefits: '聯合會員優惠',
  },
  orderListPromotiondetail: {
    eventDetails2: '活動詳情',
    preferentialRules: '優惠規則',
  },
  orderListPromotiondetailnew: {
    eventDetails2: '活動詳情',
    dateCondition: '日期條件',
    bookingConditions: '預訂條件',
    preferentialRules: '优惠规则',
    participationDate: '參與日期',
  },
  orderListRefuse: {
    areYouSureYouWantToDeclineThisOrder: '您確認要拒絕此訂單嗎',
    confirmationRejection: '確認拒單',
    successfulRejection: '拒單成功',
    theOrderWillBeClosedAtTheSameTime: '拒單後同時會關閉',
    overbookingSetup: '超售設置',
  },
  orderListTip: {
    useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage: '使用微信掃一掃前台“入住二維碼”，打開訂單查詢頁',
    fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm: '填寫預訂人姓名、手機號、入住日期查詢預訂單',
    selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation: '選擇需要辦理入住的預訂單，並選擇要增加入住人的房間填寫信息',
    atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests: '此時，您可以在預訂單詳情中，查看到該房間預警填寫入住人完畢，點擊“入住”按鈕為客人辦理入住',
    atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully: '此時，您可以在房單詳情中看到該入住人已經添加成功',
    off: '關 閉',
    theUserHasCompletedTheProcedure: '用戶已辦理完成',
    pleaseGuideTheGuestsTocheckInInTheFollowingWay: '請引導賓客按照如下方式“辦理入住”',
    afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification: '賓客填寫並提交後，頁面顯示“請攜帶證件前往前台核驗”',
    pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows: '請引導賓客按照如下方式“增加入住人”',
  },
  groupOrderAddroomer: {
    validityPeriod: '有效期限',
    addmodifyCheckInGuests: '添加/修改入住人',
    pleaseEnterAddress: '請輸入住址',
    startDate: '起始日期',
    currentSubscript: '當前下標',
  },
  groupOrderIndex: {
    bulkCheckIn: '批量入住',
    automaticRowHouse: '自動排房',
    checkInAddition: '添加入住人',
    pleaseSelectTheRoomYouWantToCheckIn: '請選擇要辦理入住的房間',
    theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn: '您選擇的有空臟的房間，是否確認辦理入住',
    checkInSuccessful: '辦理入住成功',
    roomNoLongerAvailablePleaseChangeToAnotherRoomNumber: '房間已停用，請更換其他房間號',
    theRoomIsOccupiedPleaseChangeToAnotherRoomNumber: '房間為在住狀態，請更換其他房間號',
    pleaseArrangeTheRoomBeforeChoosing: '請排房後再選擇',
    allListingsAreAlreadyFurnished: '所有房單均已排房',
    theAutomaticPlatoonSucceeded: '自動排房成功',
    pleaseListTheRoomFirstAndThenAddTheGuest: '請您先排房後再添加入住人',
    succeededInCancelingTheRowHouse: '取消排房成功',
  },
  presalecouponsPredetail: {
    ticketName: '預售券名稱',
    presaleTicket: '預售券',
    saleOrderNumber: '售賣單號',
    purchaseTime: '購買時間',
    advanceOrder: '預約訂單',
    availableProduct: '可用產品',
    commodityContent: '商品內容',
    ruleInformation: '規則信息',
    availableTime: '可預約時間',
    checkInTime2: '可入住時間',
    markUpRule: '加價規則',
    cancellationRules: '取消預約規則',
    paymentInformation: '支付信息',
    crossedPrice: '劃線價',
    chineseFood: '中餐',
    dinner2: '晚餐',
    smallProgram8: '小程序',
    jingdongDirectLink4: '京東直連',
    baiduMapDirectConnection2: '百度地圖直連',
    bookedBedtotalBedHours: '已預約間夜/總間夜(小時)',
    raiseAPrice: '加價',
    meituanDirectNew: '美團直連(新)',
    officialWebsiteDirect: '官網直營',
    ctripSingleStore: '攜程單店',
    agoda: 'Agoda',
    meituanHomestay: '美團民宿',
    tujiaHomestay: '途家民宿',
    booking: 'Booking',
    expedia: 'Expedia',
  },
  presalecouponsPrelist: {
    dateOfPayment: '支付日期',
    productId: '商品ID',
    sellOrderNumber: '售賣訂單號',
    noAppointment: '未預約',
    completeWriteOff: '全部核銷',
    completeReverseWriteOff: '全部反核銷',
    refunded: '已退款',
    orderNumber2: '訂單編號',
    timeOfPayment: '支付時間',
    bookedBedtotalBedHours: '已預約間夜/總間夜(小時)',
  },
  hardwareParking: {
    parkingLotManagement: '停車場管理',
    parkingLotDescription: '支持自動識別車牌號，自動入場出場',
    settings: '設置',
    parkingLotConfig: '停車場配置',
    currentDevice: '當前設備',
    unboundDeviceTip: '當前酒店未綁定停車場設備',
    sidPlaceholder: '請輸入 SID',
    secretKeyPlaceholder: '請輸入 SecretKey',
    enableStatus: '啟用狀態',
    hotelNotBoundWarning: '當前酒店未綁定停車場設備',
    enterSidAndSecretKey: '請輸入 SID 和 SecretKey',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    configFailed: '配置失敗',
    parkingDeviceEnabled: '停車場設備已開啟',
    parkingDeviceDisabled: '停車場設備已關閉',
    fetchHardwareRelationFailed: '獲取硬件綁定關係失敗',
    fetchConfigFailed: '獲取停車場配置失敗',
  },
  roomOrderListVehicleDialog: {
    title: '車牌號',
    platePlaceholder: '請輸入車牌號',
    add: '添加',
    plateNo: '車牌號',
    enterPlateWarning: '請輸入車牌號',
    enterPlateFormatWarning: '車牌格式不正確',
    addSuccess: '添加成功',
    deleteConfirm: '確認刪除該車牌號嗎？',
    deleteSuccess: '刪除成功',
  },
  roomOrderListDetail: {
    vehiclePlateNo: '車牌號',
    saveFailed: '保存失敗',
    cancelStay: '取消续住',
    systemRemark: '系统备注',
    merchantRemark: '商家备注',
    downloadIdPhoto: '下载证件照',
    uploadedToPolice: '已上传公安系统',
    reuploadToPolice: '重新上传公安系统',
    cancelStaySuccess: '取消续住成功',
    enterNumber: '请输入数量',
    enterRemarkContent: '请输入备注内容',
    uploaded: '已上传',
    notUploaded: '未上传',
    originalStayOrder: '续住原单',
    newStayOrder: '续住新单',
    continued: '续',
    extendStayReminder: '续住提醒：显示的房价为续住第一天的价格',
    roomChangeReminder: '友情提示：请核对房间信息后签名确认',
    extendStayFirstDayTip: '续住房显示首日价格',
    reminderDoubleCheck: '请仔细核对所有信息后再签字确认',
    liveOnCredit: '信用住',
    duration: '時長',
    save4: '保存',
    invoice: '發票',
    roomInformation2: '客房信息',
    numberOfGuests: '入住人數',
    doorLockCode: '門鎖密碼',
    generatePassword: '生成密碼',
    resetPassword: '重置密碼',
    passwordInvalidation: '密碼置失效',
    idNumber2: '證件號',
    guestAddress: '客人地址',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2: '該訂單由銷售渠道向客人提供發票',
    thisOrderIsInvoicedByYourHotelToTheGuest: '該訂單由您的酒店向客人提供發票',
    originalOrder2: '原訂單',
    swapOrder: '换订单',
    faceCollection: '人臉採集',
    invoice2: '開發票',
    sendPassword: '發送密碼',
    upgradeTheRoom: '升級房間',
    extendStayadvance: '續住/提前',
    transferToFullDayRoom: '轉全日房',
    decamping: '減少同住',
    increaseCohabitation: '增加同住',
    checkInSlip4: '入住登記單',
    reinstatement: '恢復入住',
    renewalOrder2: '續住單',
    roomChangeConfirmationForm3: '換房確認單',
    conferenceCorps: '會議團',
    tourParty: '旅行團',
    confirmNeedToResumeCheckIn: '確定需要恢復入住',
    operationReminder: '操作提醒',
    reinstatedCheckInSuccessful: '恢復入住成功',
    fullDayRoomTransfersAreNotSupportedForOnlineOrders: '線上訂單不支持轉全日房',
    whetherToCancelTheRowRoomAndTransferToTheFullDay: '是否取消排房並轉全日',
    areYouSureYouWantToChangeToAFullDayRoom: '確認要轉全日房嗎',
    checkOutTimeWillBeChangedTo2: '轉全日房後離店時間將調整為',
    theRoomIsIn: '房間在',
    existingRowHouse: '已有排房',
    conversionToFullDayRoomSuccessful: '轉為全日房成功',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2: '飛豬信用住訂單不支持聯房',
    generatePassword2: '生成密碼中',
    passwordGeneratedSuccessfully: '生成密碼成功',
    areYouSureYouWantToResetYourCurrentPassword: '確認要重置當前密碼嗎',
    resetPassword2: '重置密碼中',
    resetPasswordSuccessfully: '重置密碼成功',
    areYouSureYouWantToInvalidateYourCurrentPassword: '确认要将当前密码置失效吗',
    thePasswordIsInvalid: '密碼置失效中',
    thePasswordIsInvalidProcedure: '密碼置失效成功',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2: '當前時間已超過離店時間，不支持更換房間',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2: '當前時間已超過離店時間，不支持升級房間',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2: '當前時間已超過離店日期六點，不支持升級房間',
    theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder: '客人已申請在線續住，繼續辦理可能無法進行換單續住辦理',
    flyingPigCreditOrdersCanNotBeSustained2: '飛豬信用住訂單無法支持續住',
    itHasPassedTheCheckOutDateAndCannotBeExtended2: '已超過離店日期，無法續住',
    successfulRoomExchange2: '換房成功',
    upgradedRoomTypeData: '升級的房型數據',
    theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified: '訂單中的其他房間已退房，無法進行“客源類型”修改',
    theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms: '客人已申請在線續住，確認需要繼續更換房間?',
  },
  roomOrderListGroupRoomDetail: {
    contactNumber4: '聯繫人電話',
    aTotalOf: '共',
    occupancyStatus: '入住情況',
    onAccount2: '已掛帳',
    rollOut: '轉出',
    setAsMaster: '設為主單',
    rescission: '解除聯房',
    teamRegistrationSheet: '團隊登記單',
    numberOfRooms: '房間數量',
    confirmToCancelTheHouseRelationship: '確認解除聯房關係',
    successfullyDisconnectingTheHouse: '解除聯房成功',
    rollOutSuccess: '轉出成功',
    setTheMasterOrderToSucceed: '設為主單成功',
  },
  roomOrderListMinusroomer: {
    residentGuest: '在住客人',
    reduceRoommateSuccess: '減少同住人成功',
    decamping: '減少同住',
    pleaseSelectTheNumberOfPeopleYouWantToReduce: '請選擇要減少的入住人',
    keepAtLeastOneOccupantInTheRoom: '房間中至少保留一個入住人',
  },
  roomOrderListRelativeRoom: {
    roomOrder: '房單',
    reservationOrder: '預訂單',
    pendingCheckIn: '待入住',
    pleaseSelectARoomOrder: '請選擇房單',
    linkRoomNumber: '聯房號',
    inTheRoom: '在住房間',
    residentialTeam: '在住團隊',
    flyingPigCreditDoesNotSupportHousing: '飛豬信用住不支持聯房',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels: '直連渠道不支持與門店渠道建立聯房及團隊',
    guestsNameMobilePhoneNumberAndRoomNumber: '入住人姓名、手機號、房號',
    teamNameBookingPersonNameMobilePhoneNumber: '團隊名稱、預訂人姓名、手機號',
    pleaseSelectATeam: '請選擇團隊',
    joinTheTeamSuccessfully: '加入團隊成功',
    joinTheRoomSuccessfully: '加入房間成功',
  },
  roomOrderListRollin: {
    flyingPigCreditDoesNotSupportHousing: '飛豬信用住不支持聯房',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels: '直連渠道不支持與門店渠道建立聯房及團隊',
    transferIn: '轉入聯房',
    namePhoneNumberRoomNumber2: '入住人姓名，手機號，房號',
    succeededInJoiningTheHouse: '加入聯房成功',
  },
  roomOrderListRoomOrderDetail: {
    twinRooms: '聯房',
    roomList: '房單列表',
    noRoomListingInformationAvailable: '暫無房單信息',
    manage: '管理',
    fullState: '全部狀態',
    finance3: '財務',
    preAuthorizationDetail: '預授權明細',
    houseDetails: '聯房詳情',
    listingDetails: '房單詳情',
    thereAreNoOccupants: '暫無入住人',
  },
  roomOrderListRoomOrderList: {
    durationOfResidence: '在住時間',
    bookingTime: '預訂時間',
    room2: '房',
    doNotGift: '不贈送',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery: '姓名、手机号、订单号、渠道单号查询',
    multipleSearch: '多條件查詢',
    bonusPoints: '贈送積分',
    subscriber: '預訂人',
    subscriberNumber: '預訂人電話',
    areYouSureYouWantToGiveAwayPoints: '確定要贈送積分嗎',
    rewardPointsSuccessfully: '積分贈送成功',
    guestphone: '入住人/電話',
    actualCheckoutTime: '實際離店時間',
  },
  faceFacedialog: {
    faceCollection: '人臉採集',
    faceCollectionSuccess: '人脸采集成功',
    faceCollectionFailure: '人臉採集失敗',
    takeAPicture: '拍照',
    upload: '上傳',
    upCross: '上傳中',
    uploadingPhotosPleaseCloseLater: '正在上傳照片，請稍後關閉',
    pleaseTakeAPictureFirst: '請先拍照',
    collectionSuccess: '採集成功',
    collectionFailedPleaseTryAgain: '採集失敗，請重試!',
  },
  printtemplateChangeroom: {
    theOriginal: '原',
    changeDate: '換房日期',
    roomRateUpgrade: '房價升級:',
    roomRate: '房價:',
  },
  printtemplateChangeroomprintsmall: {
    changeDate: '換房日期',
    checkOutTime: '退房時間',
    theOriginal: '原',
  },
  printtemplateGroupordertableprint: {
    position: '站位',
  },
  printtemplateStayinprint: {
    confidentiality: '保密',
  },
  printtemplateStaymore: {
    departureDate: '預離日期',
    newDepartureDate: '新預離日期',
  },
  printtemplateStaymoreprint: {
    departureDate: '預離日期',
    newDepartureDate: '新預離日期',
  },
  helpFeedbackList: {
    submitSuccessfully4: '提交成功',
  },
  helpFeedback: {
    submitSuccessfully4: '提交成功',
  },
  noticeOrdernotice: {
    messageCenter: '消息中心',
    orderInformation: '訂單信息',
    dynamic: '動態消息',
    settlement: '結算消息',
    system: '系統消息',
    noData: '暫無新消息',
    dynamicInformation: '動態信息',
    systemInformation: '系統信息',
    nightTrialFailTitle: '夜審失敗',
    nightTrialFailContent: '夜審失敗，請及時處理。',
  },
  noticeServicemanage: {
    serviceManagement: '服務工單管理',
    roomService: '客房服務',
    itemBorrow: '物品借用',
    extendStay: '續住服務',
  },
  operatelogLog: {
    nightAuditLog: '夜審日誌',
    downloadLog: '下載日誌',
    downloadSuccessfully: '下載成功',
  },
  operatelogNightauditlog: {
    nightTrialMethod: '夜审方式',
    nightTrialResult: '夜審結果',
    manualNightAudit: '手動夜審',
    automaticNightAudit: '自動夜審',
    nightAuditFailure: '夜審失敗',
    successfulNightAudit: '夜審成功',
    nightTrialDate: '夜審日期',
    nightAuditRecord: '夜審記錄',
  },
  operatelogWorkingday: {
    variableMode: '變動方式',
  },
  financeAccountsreceivableaging: {
    bookName: '帳套名稱',
    totalAmountReceivable: '應收賬總額',
    amountPayable030Days: '應收賬金額（0-30天）',
    amountPayable3160Days: '應收賬金額（31-60天）',
    amountPayable6190Days: '应收账金额（61-90天）',
    amountToBeCollected91DaysOrMore: '應收賬金額（91天以上）',
    typeOfExchange: '換房類型',
    originalRoomNumber: '原房號',
    existingRoomNumber: '現房號',
    currentHouseType: '現房型',
    roomChangeTime: '換房時間',
    changeRoomsAfterCheckIn: '入住後換房',
    originalRoomRate: '原房價',
    spotRate: '現房價',
  },
  financeAdjustmentCash: {
    financialStatement: '財務流水',
    occurrenceTime: '發生時間',
    reconciliationStatement: '調賬報表',
  },
  financeAr: {
    channelReconciliationReport: '渠道對賬報表',
    writeOffStatus: '核銷狀態',
    amountOnCredit: '掛帳金額',
    estimatedSettlementPrice: '預估結算價',
    unapprovedAmount: '未核金額',
    guestInvoiceRequirement: '客人發票要求',
    roomNumbername: '房號/姓名',
  },
  financeBreakfastStatistic: {
    flatBreakfast: '房包早',
    advancePurchase: '購早',
    availableBreakfasts: '可用早餐數',
    verifiedBreakfasts: '已核銷早餐數',
    breakfastAmount: '早餐金額',
    breakfastStatisticsReport: '早餐統計報表',
    breakfastStatisticsReportxls: '早餐統計報表.xls',
  },
  financeInventoryInOut: {
    inOutDate: '出入庫日期',
    storageType: '出入庫方式',
    storageTypeOut: '出庫',
    fileName: '出入庫報表',
    columns: {
      inStoragePrice: '入庫金額',
      outStoragePrice: '出庫金額',
    },
  },
  financeHousekeeping: {
    cleaningDate: '打掃日期',
    cleanType: '打掃類型',
    cleaner: '保潔員',
    status: '工單狀態',
    dailyCleaningAndLinen: '日常清掃+更換床品',
    dailyCleaning: '日常清掃',
    dispatchTime: '派單時間',
    cleanTime: '打掃時間',
    checkRoomTime: '查房時間',
    recleaningReason: '重新打掃原因',
    checkerName: '查房主管',
    statuses: {
      toBeCleared: '待清掃',
      finishCleaning: '完成清掃',
      noCleaning: '無需清掃',
      cancelOrder: '取消派單',
      unauditedRoom: '待查房',
      wardRoundRejection: '查房駁回',
    },
  },
  settingHousekeeping: {
    cleaners: '保潔員',
    selectCleaners: '請選擇保潔員',
    onDutyConfig: '保潔員在崗時間配置',
    roomAssign: '房間分配',
    assignMode: {
      free: '自由分配',
      byFloor: '按樓層分配',
      byRoom: '按房間分配',
    },
    viewAssign: '查看分配',
    cleanerPrefix: '保潔:',
    autoDispatchConfig: '客房打掃自動派單配置',
    autoDispatch: {
      off: '關閉自動派單',
      on: '開啟自動派單',
    },
    autoDispatchRoomType: '自動派單房間類型',
    leaveRoom: '離店房',
    stayRoom: '在住房',
    dispatchRule: '保潔分配規則',
    rules: {
      byTotal: '每人處理工單總數平均分配',
      byPending: '每人待處理工單平均分配',
    },
    leaveCleanType: '離店房自動派單打掃類型',
    stayCleanType: '在住房自動派單打掃類型',
    dispatchTimeForStay: '在住房派單時間',
    afterCleanCheck: '客房打掃後是否需要查房',
    needCheck: {
      no: '不需要',
      yes: '需要',
    },
    dialog: {
      assignRelation: '分配關係',
      selectFloor: '請選擇樓層',
    },
    messages: {
      selectCleaners: '請選擇保潔人員',
      dutyTimeInvalid: '保潔員在崗時間配置結束時間不能小於開始時間',
    },
  },
  financeBreakfastDetails: {
    mealDate: '用餐日期',
    includeWaitingForCheckIn: '是否統計待入住房',
    title: '早餐明細報表',
    columns: {
      guestNum: '人數',
      roomContainsBreakfastNum: '房包含早',
      buyBreakfastNum: '購早',
      useBreakfastNum: '核銷數',
    },
  },
  financeChannelConsume: {
    typeOfCompany: '公司類型',
    roomNights: '間夜數',
  },
  financeCheckout: {
    checkOutBusinessDay: '離店營業日',
    helpOneself: '自用',
    team2: '團隊',
    checkOutStatement: '結賬退房報表',
  },
  financeCreatedCompanyAccountOfAge: {
    scale: '比例',
    aged180DaysOrMore: '賬齡180天以上',
    agingStatementOfCreditCompany: '信用公司賬齡報表',
    accountAge030Days: '賬齡0~30天',
    accountAge3160Days: '賬齡31~60天',
    accountAge6190Days: '賬齡61~90天',
    accountAge91180Days: '賬齡91~180天',
  },
  financeDemandAccount: {
    collectTheRoomChargeInAdvance: '預收房費',
    estimatedArrears: '預計欠款',
    collectionStatement: '催賬報表',
  },
  financeHangAccount: {
    accountStatus: '賬務狀態',
    businessDayOfHangingAccount: '掛賬營業日',
    hangTheAccountOperator: '掛賬操作人',
    currentBalance: '當前餘額',
    closingTime: '結賬時間',
    noteOfHangingAccount: '掛賬備註',
    temporaryDebitStatement: '臨時掛賬報表',
    membercompany: '會員/公司',
  },
  breakfastVerification: {
    checkedInRoomList: '在住房間列表',
    roomNo: '房號',
    breakfastCount: '早餐數',
    verified: '已核銷',
    buyBreakfast: '購早',
    verificationRecord: '核銷記錄',
    verificationTime: '核銷時間',
    cardReading: '讀卡中',
    swipeCardVerification: '刷卡核銷',
    breakfastVerification: '早餐核銷',
    pendingBreakfast: '待核銷早餐',
    verificationCount: '核銷數量',
    confirmVerification: '確認核銷',
    noRoomRead: '未讀取到房間資訊',
    cardReadFailed: '讀卡失敗，請檢查房卡或讀卡器',
    noPendingBreakfast: '該房間暫無待核銷早餐',
    verificationCountPositive: '核銷數量必須大於0',
    verificationCountExceedsPending: '核銷數量不能大於待核銷早餐數量',
    verificationSuccess: '核銷成功',
  },
  buyBreakfastDialog: {
    title: '購早',
    entryAccount: '入帳帳號',
    count: '份數',
    totalAmount: '總金額',
    payVerificationCode: '支付驗證碼',
    positiveMoney: '請輸入大於0的金額，最多兩位小數',
    positiveInteger: '請輸入大於0的整數',
    priceRequired: '請輸入單價',
    countRequired: '請輸入份數',
    roomOrderNoMissing: '未獲取到房單號，不能購早',
    selectAccountSet: '請選擇帳套',
    onlinePaymentFailed: '線上收款失敗',
    paymentIncomplete: '支付未完成，未生成購早帳務',
    buySuccess: '購早成功',
  },
  financeBreakfastVerificateDetail: {
    title: '早餐核銷明細報表',
  },
  readDoorCardRoom: {
    lockNotConfigured: '未配置門鎖或門鎖未啟用',
    getLockInfoFailed: '獲取門鎖資訊失敗',
    readCardTimeout: '讀卡逾時，請檢查讀卡器',
    emptyCard: '此卡為空卡，請先製卡',
    notGuestCard: '該卡不是賓客卡，請重新製卡',
    readCardServiceFailed: '讀卡失敗，請聯絡技術支援檢查硬體服務是否可用',
    readCardFailed: '讀卡失敗，請檢查房卡或讀卡器',
    noRoomInfo: '未讀取到房間資訊',
    unsupportedLockReadMode: '暫不支援目前門鎖讀卡方式',
  },
  financePreauth: {
    authorizationStatus: '授權狀態',
    authorizationDate: '授權日期',
    settlementDate: '結算日期',
    expirationDate: '有效日期',
    preAuthorizationStatement: '預授權報表',
    settlementTime: '結算時間',
  },
  financeRedeemDetail: {
    dateType: '日期類型',
    writeOffDate: '核銷日期',
    dateOfPosting: '掛賬日期',
    dateOfEntry2: '入賬日期',
    bookType: '賬套類型',
    businessDayOfHangingAccount: '掛賬營業日',
    hangTheAccountOperator: '掛賬操作人',
    theRoomNumberIsCharged: '掛賬房間號',
    writeOffTheAmountCredited: '核銷入賬金額',
    writeOffTheEntryTime: '核銷入賬時間',
    writeOffTheAccountOperator: '核銷入賬操作人',
    amountWrittenOff2: '核銷金額',
    writeOffTime: '核銷時間',
    writeOffTheOperator: '核銷操作人',
    channelWriteOffDetailReport: '渠道核銷明細報表',
  },
  financeRushCash: {
    financialStatement: '財務流水',
    occurrenceTime: '發生時間',
    debitStatement: '沖賬報表',
  },
  financeSellRank: {
    agreementUnitConsumptionRankingTable: '協議單位消費排名表',
  },
  financeTodayGuestBalance: {
    roomFee3: '房費',
    balanceSheetForGuestsInResidence: '在住客人餘額表',
  },
  financeTransferCash: {
    turnOutOfRoom: '轉出房間',
    bookkeepingTime: '記賬時間',
    turnIntoARoom: '轉入房間',
    transferTime: '轉賬時間',
    transferStatement: '轉賬報表',
  },
  financeZeroRoomFee: {
    zeroRoomRateReport: '零房費報表',
  },
  incomeBaseprice: {
    totalRevenue: '總營收',
    roomNight: '總間夜',
    storeRevenue: '門店營收',
    interstoreNight: '門店間夜',
    directRevenuebasePrice: '直連營收（底價）',
    straightInternight: '直連間夜',
    miniProgramRevenuebasePrice: '小程序營收（底價）',
    smallProgramNight: '小程序間夜',
    xinmeituanDirectRevenuebasePrice: '新美團直連營收（底價）',
    newUnitedStatesGroupStraightInternight: '新美团直连间夜',
    ctripDirectRevenuebasePrice: '攜程直連營收（底價）',
    ctripDirectConnectionBetweenNight: '攜程直連間夜',
    directRevenuebasePrice2: '同程直連營收（底價）',
    theSameJourneyDirectlyConnectedToTheNight: '同程直連間夜',
    qunarDirectRevenuebasePrice: '去哪兒直連營收（底價）',
    whereToGoStraightToTheNight: '去哪兒直連間夜',
    tiktokDirectRevenuebasePrice: '抖音直連營收（底價）',
    tiktokStraightBetweenNight: '抖音直連間夜',
    flyingPigDirectRevenuebasePrice: '飛豬直連營收（底價）',
    flyingPigsStraightInternight: '飛豬直連間夜',
    baiduMapRevenuebasePrice: '百度地圖營收（底價）',
    baiduMapNight: '百度地圖間夜',
    jingdongDirectRevenuebasePrice: '京東直連營收（底價）',
    jingdongDirectConnectionBetweenNight: '京東直連間夜',
    lightResidentialAndCommercialTravelRevenuebasePrice: '輕住商旅營收（底價）',
    lightStayBusinessNights: '輕住商旅間夜',
    lightHomeDistributionRevenuebasePrice: '輕住分銷營收（底價）',
    lightNightInTheDistributionRoom: '輕住分銷間夜',
    storeAdr: '門店ADR',
    usGroupEbRevenue: '美團EB營收',
    usGroupEbNight: '美團EB間夜',
    meituanEbadr: '美團EB ADR',
    ctripEbRevenue: '攜程EB營收',
    ctripEbNight: '攜程EB間夜',
    ctripEbadr: '攜程EB ADR',
    flyingPigEbRevenue: '飛豬EB營收',
    flyingPigEbNight: '飛豬EB間夜',
    ebadrTheFlyingPig: '飛豬EB ADR',
    douyinGroupPurchaseEbRevenue: '抖音團購EB營收',
    douyinGroupPurchaseEbNight: '抖音團購EB間夜',
    douyinGroupPurchaseEbadr: '抖音團購EB ADR',
    directAdrbasePrice: '直連ADR（底價）',
    miniProgramAdrbasePrice: '小程序ADR（底價）',
    newMeituanDirectAdrbasePrice: '新美團直連ADR（底價）',
    directRouteAdrbasePrice: '攜程直連ADR（底價）',
    sameRouteDirectAdrbasePrice: '同程直連ADR（底價）',
    whereToDirectAdrbasePrice: '去哪兒直連ADR（底價）',
    tiktokDirectAdrbasePrice: '抖音直連ADR（底價）',
    flyingPigDirectAdrbasePrice: '飛豬直連ADR（底價）',
    baiduMapAdrbasePrice: '百度地圖ADR（底價）',
    jingdongDirectLinkAdrbasePrice: '京東直連ADR（底價）',
    lightResidentialAndBusinessAdrbasePrice: '輕住商旅ADR（底價）',
    lightLiveDistributionAdrbasePrice: '輕住分銷ADR（底價）',
  },
  incomeExpense: {
    consumptionAccountStatisticsReport: '消費科目統計報表',
    accountId: '賬號ID',
    roomNumbername: '房號/姓名',
  },
  incomeGuestSourceDetail: {
    selfUseRoom: '自用房',
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics: '間夜數據是根據查詢的營業日統計',
    calculationMode: '計算方式',
    guestCheckInDetailsReport: '客源入住明細報表',
    freeRoom: '免費房',
    teamRoom: '團隊房',
    singleRoom: '長包房',
    roomRate2: '房費金額',
  },
  incomeHandleover: {
    shiftSummaryStatisticsReport: '交班匯總統計報表',
    income: '收入',
    disburse: '支出',
    totalAmount: '合計金額',
    shiftSummaryReport: '交班匯總報表',
  },
  incomeManageSingle: {
    category: '類別',
    today: '本日',
    baiduMapDirectConnection2: '百度地圖直連',
    accumulatedThisMonth: '本月累计',
    lastMonthCumulative: '上月同期累計',
    monthlyGrowthRate: '月增長率',
    currentYearAccumulation: '本年累計',
    accumulatedInTheSamePeriodOfLastYear: '上年同期累計',
    annualGrowthRate: '年增長率',
    operatingStatementsingleDay: '經營報表（單日）',
    operatingStatementOneDayxlsx: '經營報表單日.xlsx',
    orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights: '訂單來源間夜：包含免費房、自用房間夜數',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms: '出租率(扣自用房、免費房) = 出租間夜數(扣自用房、免費房) / 客房總數',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms: '總房費收入(包含佣金)：不含免費房、自用房',
    youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission: '您未開通“客源入住明細”報表查看權限',
    averageRoomRate: '平均房價(扣自用房、免費房) = 總房費收入 / 出租間夜數(扣自用房、免費房)',
    revparFormula: 'RevPAR = 總房費收入 / 客房總數',
    totalRevenueFormula: '營業總收入=總房費收入+所有其它收入(包含佣金,不包含會員充值)',
  },
  incomeManageTotal: {
    generalLedger: '總賬',
    totalAverageRoomRateyuan: '總平均房價(元)',
    rentalTotalRoomNightroom: '出租總間夜(間)',
    fullDayRoomNightroom: '全日房間夜(間)',
    longBagRoomNightroom: '長包房間夜(間)',
    hourRoomNightroom: '鐘點房間夜(間)',
    teamRoomNightroom: '團隊房間夜(間)',
    freeRoomNightroom: '免費房間夜(間)',
    privateRoomNightroom: '自用房間夜(間)',
    totalRoomRateyuan: '總房費(元)',
    smallCommoditiesyuan: '小商品(元)',
    mealFeeyuan: '餐費(元)',
    serviceChargeyuan: '服務費(元)',
    membershipFeermb: '會員費(元)',
    otherExpensesyuan: '其他費用(元)',
    totalRevenue: '營業總收入(元)',
    totalRevenueWithTax: '營業總收入（含稅）',
    roomNightsroom: '間夜數(間)',
    averageRoomRateyuan: '平均房價(元)',
    totalRoomRateyuan2: '房費合計(元)',
    operatingStatementcumulative: '經營報表（累計）',
    theQueryTimeRangeCannotBeLongerThanOneYear: '查詢時間範圍不能大於一年',
    totalOccupancyRate: '總出租率(%)',
    fullDayOccupancyRate: '全日房出租率(%)',
    hourlyOccupancyRate: '鐘點房出租率(%)',
    lettingRate: '出租率(%)',
    internightRatio: '間夜佔比(%)',
    totalRevpar: '總REVPAR(元)',
    cumulativeOperatingStatementxls: '經營報表累計.xls',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms: '出租率(扣自用房、免費房) = 出租間夜數(扣自用房、免費房) / 客房總數',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms: '總房費收入(包含佣金)：不含免費房、自用房',
    averageRoomRate: '平均房價(扣自用房、免費房) = 總房費收入 / 出租間夜數(扣自用房、免費房)',
    totalRevenueFormula: '營業總收入=總房費收入+所有其它收入(包含佣金,不包含會員充值)',
  },
  incomeOperatingIncome: {
    yesterdaysBalance: '昨日餘額',
    todaysBalance: '今日餘額',
    statisticalStatementOfBusinessIncome: '營業收入統計報表',
    totalconsumptionTotalPaymentTotal: '總計=消費合計-付款合計',
    yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal: '昨日餘額=酒店之前營業日累計的消費合計-付款合計',
    todaysBalancetotalyesterdaysBalance: '今日餘額=總計+昨日餘額',
  },
  incomeBusinessIncomeDetail: {
    reportTitle: '營業收入明細報表',
    consumeTotal: '消費合計',
    settleTotal: '收款合計',
    roomFee: '房費',
    mealFee: '餐費',
    goodsFee: '小商品',
    serviceFee: '服務費',
    memberFee: '會員費',
    otherConsume: '其他消費',
    dailyBalance: '當日餘額',
    orderNo: '訂單號',
    roomOrderNo: '房單號',
    roomNo: '房號',
    guestName: '姓名',
    noData: '暫無數據',
  },
  incomeOverduty: {
    category: '類別',
    firstLevelSubject: '一級科目',
    description: '描述',
    shiftStatisticsReport: '交班統計報表',
  },
  incomePayExpense: {
    cashPaymentStatement3: '現付賬消費明細報表',
    abstract: '摘要',
  },
  incomePayment: {
    paymentAccountStatisticsReport: '付款科目統計報表',
    submitted: '已提交',
    earlyMorningWatch: '凌晨班',
    roomNumberName: '房間號-姓名',
    dateRangeCannotExceedThreeMonths: '查詢日期跨度不能超過3個月',
  },
  incomeRoomTypeReport: {
    totalRoomRate: '總房費',
    numberOfOutages: '停用數',
    numberOfNightsForRent: '出租間夜數',
    roomTypeReport: '房型報表',
    theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime: '營業日結束時間不可以超過當前時間',
    theSelectionPeriodCannotBeLongerThan31Days: '選擇時間不能大於31天',
  },
  incomeSellercount: {
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics: '間夜數據是根據查詢的營業日統計',
    calculationMode: '計算方式',
    salesPerformanceStatement: '銷售業績報表',
    roomFee3: '房費',
  },
  incomeSmallwaredetail: {
    detailedSalesReportOfSmallGoods: '小商品銷售明細報表',
  },
  incomeSmallwaresummary: {
    summaryReportOfSmallCommoditySales: '小商品銷售匯總報表',
    averageUnitPrice: '平均單價',
  },
  kanbanIndex: {
    yesterday: '昨日',
    last7Days: '近7日',
    lastWeek: '上週',
    last30Days: '近30日',
    lastMonth: '上月',
    managementProfile: '經營概況',
    flowConversion: '流量轉化',
    serviceIndicator: '服務指標',
    competitiveCircleAnalysis: '競爭圈分析',
    writeAReport: '撰写报告',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest: '時間維度和篩選的日期一致，預訂金額按照客人實際支付金額統計',
    operationPersonnelManagementOverviewSuggestions2: '運營人員經營概況建議',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu: '時間維度與篩選的日期一致，包含美團、攜程、飛豬旗下所有平台的數據匯總',
    operationPersonnelFlowConversionSuggestions2: '運營人員流量轉化建議',
    theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu: '時間維度為當前選擇日期的結束日期與開始日期的前一天，包含美團、攜程、飛豬旗下所有平台的數據匯總',
    operationPersonnelServiceIndicatorsSuggestions2: '運營人員服務指標建議',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip: '時間維度與篩選的日期一致，包含美團、攜程旗下所有平台的數據匯總',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2: '運營人員競爭圈分析建議',
    smallProgram8: '小程序',
    amountOfExposure: '曝光量',
    pageView: '瀏覽量',
    orderQuantity: '下單量',
    myExposureCount: '我的曝光人數',
    numberOfPeopleExposedInThePreviousIssue: '上期曝光人數',
    myExposureConversionRate2: '我的曝光轉化率',
    previousExposureConversionRate2: '上期曝光轉化率',
    myNumberOfViewers: '我的瀏覽人數',
    numberOfVisitorsInTheLastIssue: '上期瀏覽人數',
    myConversionRate2: '我的成交轉化率',
    conversionRateOfLastPeriodTransaction2: '上期成交轉化率',
    paymentOrderNumber: '支付訂單數',
    myPaymentOrderNumber: '我的支付订单数',
    previousPaymentOrderNumber: '上期支付訂單數',
  },
  kanbanReportManage: {
    reportTitle: '報告標題',
    reportWriter: '報告撰寫人',
    reportDate: '報告日期',
    reportNumber: '報告編號',
    draft: '草稿',
    haveReleased: '已發布',
    reportTime: '报告时间',
    exportDaily: '导出日报',
  },
  kanbanSeeKanban: {
    dataBoard: '數據看板',
    managementProfile: '經營概況',
    operationPersonnelManagementOverviewSuggestions2: '運營人員經營概況建議',
    flowConversion: '流量轉化',
    operationPersonnelFlowConversionSuggestions2: '運營人員流量轉化建議',
    serviceIndicator: '服務指標',
    operationPersonnelServiceIndicatorsSuggestions2: '運營人員服務指標建議',
    competitiveCircleAnalysis: '競爭圈分析',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2: '運營人員競爭圈分析建議',
    theProportionOfSalesAmount: '銷售金額佔比',
    salesRoomNightProportion: '銷售間夜佔比',
    noProposal: '暫無建議',
    smallProgram8: '小程序',
  },
  componentsDataReport: {
    compose: '撰寫',
    dataReport: '數據報告',
    reportType: '報告類型',
    pleaseSelectAReportType: '請選擇報告類型',
    dailyOperationReport: '運營日報',
    weeklyOperationsReport: '運營週報',
    monthlyOperatingReport: '運營月報',
    runCustomReports: '运营自定义报告',
    reportTitle: '報告標題',
    analysisDate: '分析日期',
    businessDataAnalysisDimension: '經營數據分析維度',
    businessAnalysisAndSuggestion: '經營分析建議',
    trafficAnalysisSuggestion: '流量分析建議',
    serviceIndicatorSuggestion: '服務指標建議',
    competitiveCircleAnalysisSuggestion: '競爭圈分析建議',
    previewReport: '預覽報告',
    saveReport: '保存報告',
    saveReleaseReport: '保存發布報告',
    pleaseEnterTheTitleOfTheReport: '請輸入報告標題',
    pleaseEnterBusinessAnalysisSuggestions: '請輸入經營分析建議',
    pleaseEnterTrafficAnalysisSuggestions: '請輸入流量分析建議',
    pleaseEnterTheServiceIndicatorSuggestion: '請輸入服務指標建議',
    pleaseEnterTheCompetitionCircleAnalysisSuggestion: '請輸入競爭圈分析建議',
  },
  componentsFlowLine: {
    myExposureConversionRate2: '我的曝光轉化率',
    previousExposureConversionRate2: '上期曝光轉化率',
    myConversionRate2: '我的成交轉化率',
    conversionRateOfLastPeriodTransaction2: '上期成交轉化率',
    exposureToViewConversionRate: '曝光到瀏覽的轉化率',
    browseToTheConversionRateOfTheTransaction: '瀏覽到成交的轉化率',
  },
  componentsRatioPieChart: {
    directConnection3: '直連',
  },
  competeCChannelData: {
    lostOrders: '流失訂單數',
    single: '單',
    numberOfLostNights: '流失間夜數',
    lossAmount: '流失金額',
    distanceFromMe: '離我距離',
    mark: '評分',
    startingPrice: '起價',
    theProportionOfLostOrders: '流失訂單佔比',
    drainType: '流失房型',
    orderConversionRate: '下單轉化率',
    viewTheProportionOfUsers: '瀏覽用戶佔比',
    finalPurchaseRatio: '最終購買比例',
  },
  flowFChart: {
    browseToTheConversionRateOfTheTransaction: '瀏覽到成交的轉化率',
    exposureToViewConversionRate: '曝光到瀏覽的轉化率',
  },
  flowFTable: {
    myHotel: '我的酒店',
    monthOnMonth: '環比同期',
    onlinePaymentSingular: '線上支付單數',
    single: '單',
  },
  flowFlowTable: {
    payForOrderQuantity: '支付訂單量',
    exposureConversionRate: '曝光转化率',
    transactionConversionRate: '成交轉化率',
  },
  reportManageLog: {
    dataReportOperationLogs: '數據報告操作日誌',
    logNumber: '日誌編號',
    operationName: '操作名稱',
  },
  serveindexServeAnnularChart: {
    scoreDistributionGraph: '評分分佈情況圖',
    article: '條',
    numberOfCommentsWithChart: '帶圖點評數',
    newBadReviewsThisPeriod: '條  本期新增差評數：{num}條',
    unrepliedBadReviews: '未回复差評數：{num}條',
  },
  serveindexServeRadarChart: {
    radarMap: '雷達圖',
  },
  serveindexServelist: {
    basicScore: '基礎分',
    awardPoints: '獎勵分',
    penaltyPoint: '懲罰分',
  },
  situationPropose: {
    save4: '保存',
  },
  situationSChannelTable: {
    salesNight: '銷售間夜',
    averageSalesRate: '銷售平均房價',
    consumptionNight: '消費間夜',
    averageHousePriceOfConsumption: '消費平均房價',
    cancelNight: '取消間夜',
    cancellationRate: '取消率',
    noSingleRoomNights: '拒單間夜',
    rejectRate: '拒單率',
    onlinePermeability: '線上滲透率',
    channelOnlineStatus: '渠道在線狀態',
    lightHoldTheDirectConnection: '輕住直連',
  },
  situationSGrid: {
    onAYearOnYearBasis: '同比',
    chainRatio: '環比',
    cancellationRate: '取消率',
    rejectRate: '拒單率',
    theBookingAmountIncludesCancelledAndRejectedOrders: '預訂金額包含取消、拒絕的訂單',
    reservationAmountCancelAndRejectOrders: '預訂金額去掉取消、拒絕的訂單',
    accessSource: '訪問來源',
    onlineChannelConsumptionBedNightstotalAvailableInventory: '線上渠道消費間夜/總可售庫存',
    advanceBookingBedNightstotalSalesBedNights: '提前預訂間夜/總銷售間夜',
    cancelBedNightssalesBedNights: '取消間夜/銷售間夜',
    rejectBedNightssalesBedNights: '拒單間夜/銷售間夜',
  },
  situationSalePieChart: {
    salesRoomNightProportion: '銷售間夜佔比',
    theProportionOfSalesAmount: '銷售金額佔比',
  },
  orderDiscontinuedrooms: {
    operationalDowntime: '操作停用時間',
    disableStartEndTime: '停用開始結束時間',
    releaseTime2: '解除時間',
    inactiveRoomReport: '停用房間報表',
    deactivationOperator: '停用操作人',
    releaseOperator: '解除操作人',
    normalExchange: '正常換房',
    freeUpgrade: '免費升級',
    chargeEscalation: '收費升級',
  },
  orderGuest: {
    reportType2: '報表類型',
    sameDayCheckIn: '當日入住',
    sameDayCheckOut: '當日離店',
    dailyArrivalsAndDepartures: '當日入離',
    contractCompany: '協議公司',
    firstDayRate: '首日房價',
    nation2: '國家',
    roomListRemarks: '房單備註',
    guestStatement: '賓客住店報表',
  },
  orderRoomChange: {
    unterracedHouse: '未排房',
    typeOfExchange: '換房類型',
    normalExchange: '正常換房',
    freeUpgrade: '免費升級',
    chargeEscalation: '收費升級',
    originalRoomNumber: '原房號',
    existingRoomNumber: '現房號',
    currentHouseType: '現房型',
    roomChangeTime: '換房時間',
    changeRoomsAfterCheckIn: '入住後換房',
    originalRoomRate: '原房價',
    spotRate: '現房價',
  },
  checkInIndex: {
    viewListingDetails: '查看房單詳情',
    message: '資訊',
    individualStepIntoSuccess: '散客步入成功',
    automaticallyRedirectsToListingDetails: '自動跳轉至房單詳情',
    successfulCodeScanning: '掃碼成功',
    thereIsNoCorrespondingProductForTheCurrentRoomType: '當前房型暫無對應產品',
    memberBalanceIs: '會員餘額為',
    pleaseSelectAnotherRecipient: '元，請選擇其他收款方',
  },
  checkInNewindex: {
    committedParameter: '提交的參數',
    individualStepIntoSuccess: '散客步入成功',
  },
  checkInRoomerItem: {
    moreInformation: '更多信息',
    number: '號碼',
  },
  componentsBookertypesearch: {
    pleaseEnterTheMemberInformationYouWantToQuery: '請輸要查詢的會員信息',
    enterTheInformationAboutTheProtocolUnitToBeQueried: '请输要查询的协议单位信息',
  },
  componentsDepositsection: {
    selectPaymentMethod: '選擇支付方式',
  },
  componentsOpenpagetemplate: {
    conditionOfTheHouse2: '房態',
  },
  componentsProductsection: {
    noProductAvailableOnBookingDateForThisRoomType: '該房型在預訂日期未查詢到產品',
  },
  componentsRoomerItem: {
    moreInformation: '更多信息',
    genderBirthday: '性別-生日',
    nationalityNationality: '國籍-民族',
    pleaseEnterTheFullAddress2: '請輸入詳細地址',
    validityPeriod: '有效期限',
  },
  utilsLehuimixin: {
    viewListingDetails: '查看房單詳情',
    automaticallyRedirectsToListingDetails: '自動跳轉至房單詳情',
    successfulCodeScanning: '掃碼成功',
    callbackRoute: '回調的路由',
    checkInSuccessful: '入住成功',
    listingDetails: '房單詳情',
    orderDetails: '訂單詳情',
  },
  utilsUtils: {
    noProductAvailableOnBookingDateForThisRoomType: '該房型在預訂日期未查詢到產品',
    thisRoomTypeIsSoldOutWithinTheBookingDate: '该房型在预订日期内已售完',
    noPriceIsSetForThisRoomTypeDuringTheBookingDate: '該房型在預訂日期內未設置價格',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod: '會員餘額不足，請選擇其他付款方式',
  },
  componentsAuthcode: {
    laterOn: '稍後',
    verificationCodeSentSuccessfullyPleaseNoteThatCheck: '驗證碼發送成功，請注意查收',
  },
  componentsBookingcommonmixin: {
    reset: '重置',
  },
  componentsBookingmixin: {
    nineHours: '九小時',
    tenHours: '十小時',
    elevenHours: '十一小時',
    twelveHours: '十二小時',
    hourStore: '小時-門店',
    noRoomTypesAvailable: '暫無可預訂房型',
    houseList: '排房列表',
    totalPrice: '總價格',
  },
  componentsLimitinput: {
    insufficientStock: '庫存不足',
  },
  componentsMembersearch: {
    memberInformationDoesNotExistOrHasBeenDisabled: '會員信息不存在或已被禁用',
    pleaseEnterTheMemberInformationYouWantToQuery3: '請輸入要查詢的會員信息',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod: '會員餘額不足，請選擇其他付款方式',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed: '會員手機號不正確，無法使用儲值支付',
    memberNamephoneNumbermembershipNumber: '會員姓名/手機號/卡號',
  },
  componentsPaytip: {
    memberPaymentFailure: '會員支付失敗',
    pleaseReEnterTheAccount: '請重新入賬',
  },
  futureIndex: {
    roomTypeSummary: '房型匯總',
    roomDetail: '房間明細',
  },
  futureSummary: {
    soldNumberavailableNumberoverSoldNumberdisabledNumber: '已售數 / 可售數(超售數) / 停用數',
    totalNumberOfRoomsPhysicalTotalNumberOfRooms: '總房數：酒物理總房間數',
    availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber: '可售數：總房數-已售數-停用數+全日房超售數',
    disabledNumberNumberOfDisabledRoomsInTheHotel: '停用數：酒店停用房間數',
    soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom: '已售數：預訂當日的房間+當日在住的房間不含今日預離及鐘點房',
  },
  groupbookingIndex: {
    pleaseEnterTeamName: '請填寫團隊名稱',
    memberBalanceNotEnough: '會員餘額為 {balance} 元，請選擇其他收款方式',
    bookingRoomCannotBeZero: '預訂間數不能為 0',
    roomTypeStockNotEnough: ' 房型庫存不足',
    pleaseEnterContractNo: '請輸入合約號',
    remarkPlaceholder: '最多輸入 150 個字',
    discountPricePlaceholder: '請輸入優惠價',
    leftRoomsTip: '還有 {count} 間未排房',
    searchMemberPlaceholder: '姓名 / 手機號 / 會員號',
    groupBooking: '團隊預訂',
    contractNumber: '合同編號',
    teamBookingSuccessful: '團隊預訂成功',
  },
  longbookingIndex: {
    singleRoom: '長包房',
  },
  longbookingProductionlist: {
    houseList: '排房列表',
    inAddition: '還有',
  },
  onlinedataIndex: {
    chainRatio: '環比',
    onAYearOnYearBasis: '同比',
    theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel: '直連渠道未開通，為防止訂單損失，請盡快聯繫輕住運營經理開通直連渠道',
    relevance: '關聯',
    onlineRevenue: '線上營收',
    onlineNight: '線上間夜',
    channelProportion: '渠道佔比',
    channelOnlineStatus: '渠道在線狀態',
    directConnection3: '直連',
    temporarilyWithoutAuthority: '暫無權限',
    totalOnlineRevenue: '線上總營收',
    onlineTotalNight: '線上總間夜',
    online: '線上',
    thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement: 'EB賬號未綁定，請到EB賬號管理綁定EB賬號',
  },
  realTimeIndex: {
    allBuildings: '全部樓棟',
    allFloors: '全部樓層',
    depositSbalanceShort: '餘',
    preAuthShort: '預',
    totalShort: '總',
    depositShort: '押',
    roomRateShort: '價',

    powerOff: '斷',
    powerOn: '通',
    new2: '新',
    al: '聯',
    openChannelsForDirectConnection: '開通渠道直連',
    createRoomType: '創建房型',
    createARoom: '創建房間',
    renewalOrder2: '續住單',
    roomChangeConfirmationForm3: '換房確認單',
    checkInSlip4: '入住登記單',
    whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2: '續住時房間顯示的為續住首日價格，提前時/變更預離時間時，均顯示的是最後一晚的價格',
    friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3: '溫馨提示：請務必核對無誤後簽字確認，換房後記得將原房間的私人物品帶上',
    continuationRoomsShowTheFirstDayPrice2: '續住房間顯示的是首日價格',
    friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3: '溫馨提示：請務必核對無誤後簽字確認，私人物品帶上',
    liveLightlyInTheDirectCamp: '輕住直營',
    whereToConnectDirectly: '去哪兒直連',
    baiduMap: '百度地圖',
    jingdong: '京東',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2: '飛豬信用住訂單不支持聯房',
    flyingPigCreditOrdersCanNotBeSustained2: '飛豬信用住訂單無法支持續住',
    itHasPassedTheCheckOutDateAndCannotBeExtended2: '已超过离店日期，无法续住',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2: '當前時間已超過離店時間，不支持升級房間',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2: '當前時間已超過離店日期六點，不支持升級房間',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2: '當前時間已超過離店時間，不支持更換房間',
    successfulRoomExchange2: '換房成功',
    successfulDisposal: '置臟成功',
    cleanAndSuccessful: '置乾淨成功',
    deactivateSuccessfully: '解除停用成功',
    temporaryPassword: '臨時密碼',
    thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse: '此密碼30分鐘內有效，使用後立即失效',
    quickSearch: '房號快速查詢',
    batchModify: '批量改房態',
    ignore: '忽 略',
    goAndOperate: '去 操 作',
    bookingInfo: '待入住預訂信息',
    orderNo: '訂單號',
    channelName: '渠道名稱',
    bookerName: '預訂人姓名',
    arrivalTime: '預抵時間',
    roomRate: '房價',
  },
  realTimeServicemsg: {
    dateOfService: '服務日期',
    applicationTime2: '申請時間',
    serviceType: '服務類型',
    serviceTime: '服務時間',
    serviceSuccess: '服務成功',
    serviceFailure: '服務失敗',
    serviceCompletion: '服務完成',
    theRoomRequestHasBeenServiced: '客房請求已服務完成',
  },
  componentsCommon: {
    roomBalance: '房間餘額',
    depositWithPreAuth: '押金+預授權',
    madeCardCount: '已製卡數',
    stayOver: '續住',
    checkOut4: '退房',
    temporaryPassword: '臨時密碼',
    sendPassword: '發送密碼',
    muck: '置臟',
    setAside: '置淨',
    checkIn2: '入住',
    deactivate: '解除停用',
    faceEast: '朝東',
    faceWest: '朝西',
    faceSouth: '朝南',
    faceNorth: '朝北',
    decorativeFalseWindow: '裝飾性假窗',
    stayAwayFromElevators: '遠離電梯',
    nearTheStairs: '靠近樓梯',
    closeToTheRoad: '靠近馬路',
    windowWall: '窗外牆體',
    bedTypeDescription: '床型描述',
    guestControl: '客控',
    latestCheckIn: '最近入住',
    noHistoricalCheckInInfo: '該房間沒有歷史入住資訊',
    temporaryMakeCard: '臨時製卡',
  },
  componentsGrouphandle: {
    batchModify: '批量改房態',
    pleaseSelectAnActiveArea: '請選擇活動區域',
    selectStartDate: '選擇開始日期',
    selectEndDate: '選擇結束日期',
    emptyCleanToEmptyDirty: '空淨轉空臟',
    emptyDirtyToEmptyClean: '空臟轉空淨',
    stayCleanAndTurnDirty: '住淨轉住臟',
    stayDirtyAndTurnClean: '住臟轉住淨',
    batchOutage: '批量停用',
    batchDeactivation: '批量解除停用',
    pleaseEnterTheStartTime: '請輸入開始時間',
    pleaseEnterTheEndTime: '请输入结束时间',
    pleaseSelectTheRoomForBatchOperation: '請選擇要批量操作的房間',
    batchOperationSuccessful: '批量操作成功',
    whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms: '是否確定停用，批量停用中包含（已排房）房間?',
  },
  componentsHourcheckinconfirm: {
    checkInTimeConfirmation: '入住時間確認',
    continuousHousing: '繼續排房',
    theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime: '已超過預抵時間，請您確認客人入住時間',
    itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing: '已經被佔用,繼續辦理後請您手工排房',
  },
  componentsOperationlog: {
    operationRecord: '操作記錄',
  },
  componentsStopservice: {
    successfulDeactivation: '停用成功',
    selectStartDate: '選擇開始日期',
    selectEndDate: '選擇結束日期',
    noteAtLeast3Words: '備註最少3個字',
    startMustAfterNow: '開始日期必須大於等於當前日期',
    endMustAfterStart: '結束日期必須大於開始日期',
  },
  serviceHandle: {
    accept: '接受',
    turnDown2: '拒绝',
    serviceProcessing: '服務處理',
    whetherToProcess: '是否處理',
    reasonForRefusal: '拒絕原因',
    pleaseEnterTheReasonForTheRejection: '請輸入拒絕原因',
    accepted: '已接受',
    denialOfService: '服務拒絕',
  },
  sankebookingArrangeroom: {
    noRoomAvailablePleaseConfirmAndTryAgain: '無可排房間，請確認後重試',
    upgradeNumberOfRooms: '升級房間數量',
    pleaseEnterRoomChangeRemarks: '請輸入換房備註',
    conditionOfTheHouse2: '房態',
    pleaseSelectTheRoomYouWantToUpgrade: '請選擇要升級的房間',
    thereAreCurrentlyNoRoomTypesAvailableForUpgrade: '當前沒有可升級的房型',
    theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms: '排房數量不能大於預訂間數',
    thisRoomTypeIsNotOnline: '該房型未上線',
    hourProductPleaseSelectAnotherRoomType: '小時產品，請選擇其他房型',
    thisRoomType: '該房型',
    productsAreSoldOutPleaseChooseAnotherRoomType: '小時產品已售完，請選擇其他房型',
    noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType: '小時產品未設置價格，請選擇其他房型',
    yourUpgradedRoomTypeIsAllThatIsLeft: '您升級的房型僅剩',
    pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades: '間，請更換其他房型或減少房間升級數量',
  },
  sankebookingIndex: {
    channelOrderRoomType: '渠道下單房型',
    operationPrompt: '操作提示',
    furtherBooking: '繼續預定',
    thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat: '該訂單已經辦理了預訂，請不要重複辦理',
    floorPriceModel: '底價模式',
    sellingPriceModel: '賣價模式',
    theNumberOfReservedRoomsCannotBe: '預訂間數不能為',
    reservationNumber: '預訂單數',
    inAddition: '還有',
    useEbInformation: '使用eb信息',
    useEbOrderInformation: '使用EB訂單信息',
    theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking: '預訂間數和渠道訂單間數不一致，是否繼續辦理預訂',
    thisOrderCannotBeBooked: '該訂單不能辦理預訂',
  },
  activityData: {
    dailySpecial: '天天特價',
    keepPricesLow: '保持低價',
    motivateUsersToBuyMore: '刺激用戶多買',
    earlyRush: '提早搶客',
  },
  componentsActivitydetail: {
    discount: '折扣',
    promotionInfo: '活動報名成功提交後即生效，活動進行過程中酒店可修改或退出，但已完成訂單按照既有規則進行。活動參與房型原價不得高於其他渠道價格，否則可能無法展現。',
    offerDetails: '活動參與房型促銷前價格不高於其他渠道，將獲得更多曝光機會。建議商戶中最低價房型參與活動，將獲得更多流量入口曝光機會。',
    backToActivityList: '返回活動列表',
    quantitySold: '售賣數量',
    sellLowEachNight: '每間夜低賣',
    pleaseSelectAnEventProduct: '請選擇參加活動產品',
    noRoomTypeInformationAvailable: '暫無房型信息',
    productsHaveBeenSelectedForTheEvent: '已選參加活動產品',
    selectOffer: '選擇優惠',
    iHaveReadAndAgree: '我已閱讀並同意',
    activityRelatedClause: '活動相關條款',
    selectedOffer: '已選優惠',
    signUpNow: '立即報名',
    activeTime: '活動時間',
    activityProfile: '活動簡介',
    activityRequirement: '活動要求',
    preferentialDetails: '優惠明細',
    specialSpecification: '特殊說明',
    entryAndExitRules: '生效及退出規則',
    costAttribution: '成本歸屬',
    midAutumnFestival: '中秋佳節',
    specialProduct: '特殊產品',
    areYouSureYouWantToCommitYourChanges: '確認要提交修改嗎',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: '請選擇參加活動的房型',
    pleaseSelectDiscount: '請選擇折扣',
    pleaseReadAndAgreeToTheTermsOfTheEvent: '請閱讀並同意活動相關條款',
    successfulRegistration: '报名成功',
  },
  componentsSelfactivitylist: {
    expired: '已过期',
    copyPromotion: '复制促销',
    promotionType: '促销类型',
    marginOfPreference: '优惠幅度',
    eventDate: '活动日期',
    beOffline: '已下线',
    merchantsPushThemselvesOffline: '商家自促下线',
    offlineSuccess: '下线成功',
    areYouSureYouWantToDeleteTheActivity: '确认要将活动删除吗',
  },
  componentsActivitycontent: {
    activityRequirement: '活动要求',
    quantitySold: '售卖数量',
    signUpNow: '立即报名',
    cancelRegistration: '取消报名',
    reEnroll: '再次报名',
    areYouSureYouWantToCancelYourRegistration: '确认要取消报名吗',
  },
  componentsSelfactivitylog: {
    inquire: '查 询',
    back: '返回',
  },
  componentsDialog: {
    rule: '规则',
    new: '新建',
    content: '内容',
    activityRelatedClause: '活动相关条款',
  },
  componentsSelfactivitydetail: {
    discountInfo: '打开自动延期会在促销结束日期前30天自动延期，创建一条新促销。如果促销结束日期距离当前日期不足30天，会自动将促销延长至30天。',
    chooseToParticipateInPromotionalProducts: '选择参与促销产品',
    noRoomTypeInformationAvailable: '暂无房型信息',
    selectedProductsForPromotion: '已选参与促销产品',
    selectTheChannelWhereThePromotionIsEffective: '选择促销生效的渠道',
    allChannels: '全部渠道',
    designatedChannel: '指定渠道',
    noEffectiveChannelInformationIsAvailable: '暂无生效渠道信息',
    youHaveSelectedTheChannelWhereThePromotionTakesEffect: '已选促销生效的渠道',
    activeConfiguration: '活动配置',
    setForAtLeast2Days: '最少设置2天',
    setThisParameterForAtLeast1Day: '最少设置1天',
    discount: '折扣',
    theDiscountValueIsSetToAtLeast95Off: '折扣数值最少设置为95折',
    theMinimumAmountOfImmediateReductionIsSetAt5: '立减金额最少设置为5元',
    immediateReductionPromotionIsNotEffectiveForCtrip: '立减类促销对携程不生效',
    thePromotionIsValidOnlyOnCtrip: '该促销仅在携程生效',
    thePromotionIsOnlyEffectiveOnCtripAndTongcheng: '该促销仅在携程、同程生效',
    link: '连住',
    advanceBooking: '提前预订',
    preferentialMode: '优惠方式',
    firstStayDiscount: '首住折扣',
    automaticExtension: '自动延期',
    saleTime: '甩卖时间',
    theFollowingDay: '次日',
    theIntervalShallNotBeLessThan30Days: '间隔时间不得小于30天',
    areYouSureYouWantToCommitYourChanges: '确认要提交修改吗',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: '请选择参加活动的房型',
    pleaseSelectAnEventCheckInDate: '请选择活动入住日期',
    pleaseFillInTheDiscountAmount: '请填写优惠金额',
    atLeast95OffUpTo30Off: '折扣金额至少95折,至多3折',
    theDiscountAmountIsAtLeast5AndUpTo500: '优惠金额至少5元,至多500元',
    pleaseFillInTheNumberOfConsecutiveDays: '请填写连住天数',
    theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days: '连住天数必须大于等于1天，小于等于10天',
    pleaseFillInTheAdvanceBookingDays: '请填写提前预订天数',
    pleaseFillInTheSaleTime: '请填写甩卖时间',
    congratulationsOnYourPromotionCreation: '恭喜您促销创建成功',
    congratulationsOnYourSuccessfulCopyPromotion: '恭喜您促销复制成功',
    back: '返回',
  },
  componentsSelfactivitytemp: {
    createNow: '立即创建',
  },
  productOversaleSetting: {
    numberSold: '已售数',
    oversold: '可超售',
    date3: '日期',
    oversoldQuantity: '超售数量',
    oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay: '当日超售不可大于当日酒店剩余物理房量',
    oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay: '超售库存在当日房型实际物理库存售罄时启用',
    pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout: '请在更多-系统设置-基础设置-直连接单打开超售时自动接单设置，避免超售订单超时自动拒单',
    timeSelectionIsOutOfRange: '时间选择超过范围',
    configurationSuccessful: '配置成功',
    theSetOverbookingQuantityMustBeGreaterThanOrEqualTo: '设置超售数量必须大于等于',
  },
  productDelayprice: {
    holidayFactorRange: '节假日系数可输入范围：1~5的小数，最多保留一位小数。',
    holidayPricingRule: '设置节假日系数之后，中国大陆法定节假日价格将会变成平日价格的。例如：当系数为2，平日价格为100元时，系统将自动把节假日价格设置为2*100=200元。',
    holidayFactor: '设置节假日系数之后，中国大陆法定节假日价格将会变成平日价格的',
    priceCopy: '复制2个月的价格',
    open: '已开启',
    deferredProduct: '延价产品',
    allDayRoomProducts: '全日房产品',
    deferralOnlyAppliesToProductsWithFullDayOccupancyType: '只针对入住类型为全日房的产品进行延价',
    priceExtensionTime: '延价时长',
    holidayCoefficient: '节假日系数',
    statutoryHolidayPricesAreWeekdays: '法定节假日价格为平日的',
    times: '倍',
    automaticDeferralDescription: '自动延价说明',
    theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem: '系统将最近一周的价格复制给未来没有价格的日期，已经有价格的日期，不会被系统覆盖',
    thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken: '自动延价的价格来源为自动延价日期之前一周的价格，如遇节假日则跳过，取更前一周的价格',
    turnOffAutomaticDeferral: '关闭自动延价',
  },
  productManageSetting: {
    advanceSale: '预售',
    needChannelConnection: '该产品须开通渠道直连后方可创建，是否确认开通渠道直连？',
    confirmChangeProductType: '修改产品类型会将产品发布渠道和全部产品规则清空，是否确认操作？',
    checkInDay: '入住当天',
    beforeCheckIn: '入住前',
    atLatest: '最晚',
    theHourlyIncreaseCannotBeGreaterThanThePrice: '每小时加收不可大于价格',
    physicalRoomType: '物理房型',
    lengthOfStay2: '入住时长',
    earliestCheckInTime: '最早入住时间',
    latestCheckOutTime: '最晚退房时间',
    howLongNoAdditionalRoomChargeminutes: '延长多久不加收房费(分钟)',
    howLongIsTheFullDayRoomChargehours: '满多长时间收全天房费(小时)',
    cancelRule: '取消规则',
    paymentPolicy: '支付政策',
    validForOnlineSalesOnly: '仅对线上售卖生效',
    releaseChannel: '发布渠道',
    productRegulation: '产品规则',
    effectiveChannel: '生效渠道',
    priceyuan: '价格 (元)',
    inputPrice: '输入价格',
    extraChargePerHourrmb: '每超1小时加收 (元)',
    forSaleOnly: '限售 (间)',
    inputSpace: '输入间数',
    enjoyHotelStayLight: '轻住悦享酒店',
    pleaseEnterTheNumberOfRooms: '请输入间数',
    additionalRule: '增加规则',
    found: '创建',
    save4: '保存',
    containing: '含',
    pleaseEnterTheNumberOfRestrictedRooms: '请输入限售间数',
    nonDeletable: '不可删除',
    early: '早',
    withoutBreakfast: '不含早',
    liveLightAndEnjoy: '轻住优享',
    confirmToDeleteThisRule: '确定删除此规则',
    areYouSureToKeepItForSale: '确定保存售卖吗',
    areYouSureToCreateASale: '确定创建售卖吗',
    submitSuccessfully4: '提交成功',
    areYouSureYouWantToLeave: '确定要离开吗',
  },
  productPriceCalendar: {
    confirmDeleteWarning: '请确认当前产品是否有尚未离店的房单，以免对续住产生影响。如确认删除，请点击下方的‘确认删除’按钮',
    totalAvailableRooms: '总可售房间10间/(含超售余量3间)',
    limitZeroFull: '限售数为0时则是满房状态；关房后将不对外网售卖。',
    openRoomAvailable: '开房时有剩余房间外网可售，关房后将不对外网售卖',
    allProducts3: '全部产品',
    onlineProduct2: '在线产品',
    offLineProduct2: '不在线产品',
    theReckoner: '计算器',
    preSaleFullDayRoom: '预售全日房',
    presaleHourRoom: '预售钟点房',
    viewIsNotSupported: '暂不支持查看',
    channelPricesCannotBeSet: '渠道价格不可设置',
    smallProgramChannelPriceCanBeAdjustedToUpdate: '可调整小程序渠道价格进行更新',
    switchRoom: '开关房',
    checkIn3: '开房',
    limitedSalesNumber: '限售数',
    unlimitedSale: '不限售',
    packUpAllProducts: '收起全部产品',
    expandAllProducts: '展开全部产品',
    modifyProductPrice: '修改产品价格',
    extraChargeForMoreThan1Hour: '超过1小时加收',
    pleaseEnterPrice3: '请输入价格',
    enjoyHotelStayLight: '轻住悦享酒店',
    pleaseEnterLimitedNumber: '请输入限售数',
    maintenancePrice: '维护价格',
    priceNotMaintained: '价格未维护',
    amendTheSalesRestrictionRules: '修改限售规则',
    confirmOrNot: '是否确认',
    areYouSureYouWantToContinue: '确定继续修改吗',
    modifiedSuccessfully2: '修改成功',
    theCurrentRateExceedsTheThresholdSetByTheHotel5: '当前价格超过酒店设置阈值',
    definiteModification: '确定修改',
  },
  productPriceCalendarNew: {
    open: '开房',
    EBDeepOperationFailed: 'EB深度運營失敗',
    previousTwoWeeks: '前2周',
    nextTwoWeeks: '后2周',
    syncCurrentPageEBData: '同步当前页面EB数据',
    closeRoomApplied: '该产品剩余合同保留房数量不为0，已提交关房申请，请等待审核。',
    cannotCloseRoom: '该产品剩余合同保留房数量不为0，无法关房，请联系渠道业务经理进行关房。',
    remainingContractReservedRooms: '剩余合同保留房',
    roomsCannotBeLower: '间，保留房量不能低于此数值',
    ebChannel: 'EB渠道',
    ebMeituan: 'EB美团',
    ebCtrip: 'EB携程',
    ebFeizhu: 'EB飞猪',
    ebDeepOperationFailure: 'EB深度运营失败',
    unmatched: '有未匹配',
    cannotBeEmpty: '不能为空',
    confirmModification: '修改完会立即生效，确定继续吗？',
    confirmDeleteWarning: '请确认当前产品是否有尚未离店的房单，以免对续住产生影响。如确认删除，请点击下方的‘确认删除’按钮',
    batchChangeInventory: '批量改库存',
    theReckoner: '计算器',
    product2: '产品',
    preSaleFullDayRoom: '预售全日房',
    presaleHourRoom: '预售钟点房',
    underRevision: '修改中',
    viewIsNotSupported: '暂不支持查看',
    dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute: '数据同步中，请1分钟后重新查询',
    lightLiveDistributionChannelPriceCannotBeSet: '轻住分销渠道价格不可设置',
    smallProgramChannelPriceCanBeAdjustedToUpdate: '可调整小程序渠道价格进行更新',
    switchRoomSetup: '开关房设置',
    notModify: '不修改',
    checkIn3: '开房',
    roomSetting: '房量设置',
    unlimitedSale: '不限售',
    reserveRoomSetup: '保留房设置',
    packItAllUp: '收起全部',
    expandAll: '展开全部',
    date3: '日期',
    extraChargeForMoreThan1Hour: '超过1小时加收',
    theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms: '保留房数量可以增加，最多不能超过当前库存数量，最少不能低于剩余合同保留房数量',
    offLineProduct2: '不在线产品',
    onlineProduct2: '在线产品',
    allProducts3: '全部产品',
    showFloor: '显示底价',
    theReservePriceIsNotDisplayed: '不显示底价',
    directChannel4: '直连渠道',
    smallProgram8: '小程序',
    goWhereTheDirectConnection4: '去哪直连',
    jingdongDirectLink4: '京东直连',
    baiduMapDirectConnection2: '百度地图直连',
    unboundChannel: '未绑定渠道',
    synchronizationFailure: '同步失败',
    theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate: '前两周开始日期不能小于当前日期',
    pleaseSelectTheCurrentStartEndDate: '请选择当前开始结束日期',
    pleaseEnterPrice3: '請輸入價格',
    pleaseEnterTheNumberOfReservedRooms: '請輸入保留房數',
    pleaseEnterLimitedNumber: '請輸入限售數',
    maintenancePrice: '維護價格',
    priceNotMaintained: '價格未維護',
    modifyProductPrice: '修改產品價格',
    modifyProductInventory: '修改產品庫存',
    confirmOrNot: '是否確認',
    modifiedSuccessfully2: '修改成功',
    theCurrentRateExceedsTheThresholdSetByTheHotel5: '当前价格超过酒店设置阈值',
    areYouSureYouWantToContinue: '確定繼續修改嗎',
    definiteModification: '確定修改',
  },
  productPriceAudit: {
    product2: '產品',
    allRejectedSuccessfully: '全部駁回成功',
    pass: '通過',
    turnDown: '駁回',
    revisedPrice: '改後價格',
    rangeOfVariation: '變價範圍',
    priceChanger: '改價人',
    auditor: '審核人',
    auditTime: '審核時間',
    toBeReviewed: '待審核',
    passTheExamination: '審核通過',
    expired: '過期',
    successfulAudit: '審核成功',
  },
  pcncomponentDataexplain: {
    totalAvailableRooms: '總可售房間10間/(含超售餘量3間)',
    ebPriceSoldRemaining: '房價(EB賣價)/已售房量/剩餘房量',
    ebPriceSoldCloseStatus: '房價(EB賣價)/已售房量/關房狀態',
    ebBasePriceReservedUnlimited: 'EB底價/剩餘保留房數量(包含合同保留房和臨時保留房)/無限售賣',
    hourRoomProductsShowHourRoomIdentification: '鐘點房產品顯示鐘點房標識',
    whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective: '產品改價或是改房態後，沒有立即生效在審核中時，顯示審核中標識，審核通過修改生效後審核中標識隱藏',
    underRevision: '修改中',
    thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure: '房價或庫存有正在修改的數據，還未獲取到修改結果時顯示標識，只有成功或失敗後才會隱藏標識',
    ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus: '產品改價或是改房態失敗後顯示失敗標識，只有在下次操作改價或改房態成功後才會隱藏標識',
    theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged: '產品獲取失敗，需要聯繫運營經理確認該產品是否發生變更',
    statusDeclaration: '狀態說明',
    whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState: '限售數為0時滿房狀態，關房後不可對外售賣，無限量狀態只有關房才會停止售賣',
    ctripEbPrepaidProductsShowThePrepaidLogo: '攜程EB預付產品顯示預付標識',
    ctripEbCashProductsShowTheCashLogo: '攜程EB現付產品顯示現付標識',
  },
  pcncomponentBatchUpdateStock: {
    cannotCloseRoomTip: 'EB產品剩餘保留房不為0時，無法關房',
    roomSettingTip: '房量調整的是限售數，針對房型下所有產品。直連產品和EB產品庫存取限售數和物理庫存的最小值',
    infiniteQuantityTip: '無限量對應EB美團的無限量、飛豬的不限量、攜程的freesale。直連渠道的不限售',
    notModify: '不修改',
    open: '開房',
    roomSetting: '房量設置',
    restrictedSalesIncrease: '限售增加',
    restrictedSalesReduction: '限售減少',
    directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory: '直連產品僅支持修改開關房狀態，不支持修改庫存',
    batchChangeInventory: '批量改庫存',
    productSelection: '產品選擇',
    whetherToDisplayPreSaleProducts: '是否顯示預售產品',
    channelSelection: '渠道選擇',
    paymentType: '支付類型',
    selectionWeek2: '選擇星期',
    switchRoomSetup: '開關房設置',
    save4: '保存',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2: '部分產品修改失敗，以下為失敗產品，請獲取最新價格庫存後再次修改',
    pleaseSelectADateRange2: '請選擇日期區間',
    pleaseSelectADate4: '請選擇日期',
    pleaseSelectAWeek2: '請選擇星期',
    pleaseEnterTheNumberOfRestrictedRooms: '請輸入限售間數',
    pleaseEnterTheNumberOfRestrictedAdditionalRooms: '請輸入限售增加間數',
    pleaseEnterTheNumberOfRestrictedReducedRooms: '請輸入限售減少間數',
  },
  pcncomponentPriceunified: {
    displayNextPage: '顯示下一頁',
    priceCannotBeLessThan20: '售價不能小於等於20',
    lowSellingPriceTip: '以下產品售價過低，請確認是否繼續修改',
    priceExceedsThresholdTip: '本次改價超出預設範圍，請聯絡店長進行改價審核',
    Weekend: '週末',
    officialWebsiteDirect: '官網直營',
    dateCannotRepeat: '日期不能重複',
    selectProduct: '選擇產品',
    noDifference: '不區分',
    distinguish: '區分',
    bulkAdjustment: '批量調整',
    increase: '增加',
    reduce: '減少',
    weekdayWeekend: '平日/週末',
    weekdays: '平日',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2: '部分產品修改失敗，以下為失敗產品，請獲取最新價格庫存後再次修改',
    priceChangeModeTip: '改價模式可以選擇修改賣價+佣金或是底價，賣價+佣金模式下僅攜程產品支持修改佣金且可以向上調整，底價模式僅攜程產品可以修改',
    sellPriceCommission: '賣價+佣金',
    ebChannel: 'EB渠道',
    ebMeituan: 'EB美團',
    ebCtrip: 'EB攜程',
    ebFeizhu: 'EB飛豬',
    splitPricing: '分开改价',
    uniformPriceChange: '統一改價',
    floorPrice2: '底價',
    sellingPrice2: '賣價',
    productSelection: '產品選擇',
    paymentType: '支付類型',
    selectionWeek2: '選擇星期',
    product2: '產品',
    thePreviousStepReselectTheProduct: '上一步 重選產品',
    methodOfRepricing: '改價方式',
    separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches: '分開改價可以設置每個產品的價格，統一改價可以批量進行加減價操作',
    priceModel: '價格模式',
    priceBeforeModification: '修改前價格',
    extraChargeAfterOneHour: '超一小時加收',
    commission: '佣金',
    next3: '下一步',
    save4: '保存',
    pleaseSelectAWeek2: '請選擇星期',
    pleaseSelectADateRange2: '請選擇日期區間',
    pleaseSelectADate4: '請選擇日期',
    directChannel4: '直連渠道',
    smallProgram8: '小程序',
    goWhereTheDirectConnection4: '去哪直連',
    jingdongDirectLink4: '京東直連',
    baiduMapDirectConnection2: '百度地圖直連',
    value: '值',
  },
  pcncomponentTable: {
    product2: '產品',
    passTheVerification: '驗證通過',
    verificationFail: '驗證不通過',
  },
  pcncomponentLog: {
    revisedPrice3: '修改後價格',
    pleaseEnterTheRevisedPrice: '請輸入修改後價格',
    pleaseSelectAStandardProduct: '請選擇標準產品',
    straight: '直',
  },
  giftPro: {
    bindUnbind: '綁定/解綁',
    giftValueInfo: '禮包價值只做展示，不產生實際費用',
    thePackageCanOnlyBeConfiguredWithAllDayRoomProducts: '禮包只可以配置全日房產品',
    eachProductCanBeConfiguredWithOnlyOnePackage: '每個產品只可以配置一種禮包',
    theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts: '禮包只對美團直連產品生效',
    packageDescription: '禮包說明',
    allProducts2: '所有產品',
    modifiedGiftPack: '修改禮包',
    packageName: '禮包名稱',
    giftPackageGiving: '禮包贈送方式',
    packageType: '禮包類型',
    packageStatus: '禮包狀態',
    activeProduct: '生效產品',
    createPackage: '新增',
    packageValue: '礼包价值',
    packageEffectiveDate: '禮包生效日期',
    upperLimit1500: '上限1500',
    upperLimit: '上限',
    packageDetails: '禮包詳情',
    maximum80Characters: '上限80個字',
    wayOfGiving: '贈送方式',
    thePackageValueCannotBeEmpty: '禮包價值不能為空',
    oneDeliveryPerRoom: '每間房送一次',
    complimentaryOnceADayPerRoom: '每間房每日贈送一次',
    pleaseEnterThePackageName: '請輸入禮包名稱',
    pleaseSelectTheGiftMethod: '請選擇贈送方式',
    pleaseSelectAPackageType: '請選擇禮包類型',
    pleaseSelectPackageDetails: '请选择礼包详情',
    pleaseSelectAnEffectiveProduct: '請選擇生效產品',
    pleaseSelectAnEffectiveDate: '請選擇生效日期',
    whetherToDropTheGiftPackage: '是否下線禮包',
    giftBagOffLine: '禮包下線',
    offlineSuccess: '下線成功',
    offlineFailure: '下線失敗',
    methodOfCancellation: '取消的方法',
    createdSuccessfully: '創建成功',
    creationFailure: '創建失敗',
  },
  giftLog: {
    packageOperationLog: '礼包操作日志',
  },
  pullnewMember: {
    memberInformationEntry: '會員信息錄入',
    areRequiredFieldsOtherFieldsAreNotRequired: '為必填項，其他非必填',
    idNumber: '證件號',
    inputResult: '錄入結果',
    recordSuccessfully: '錄入成功',
    entryFailure: '錄入失敗',
    memberSale: '會員特賣',
    pleaseSelectRoomType: '請選擇房型',
    pleaseSelectChannel: '請選擇渠道',
    pleaseSelectCheckInType: '請選擇入住類型',
    notShowPreSaleProduct: '不顯示預售產品',
    showPreSaleProduct: '顯示預售產品',
    notShowEbProduct: '不顯示EB產品',
    showEbProduct: '顯示EB產品',
    allCheckInTypes: '全部入住類型',
    holiday: '節假日',
    enter: '錄入',
    passport: '護照',
    pleaseEnterTheIdNumber: '請輸入證件號',
    theNameFormatIsIncorrect: '姓名格式不正確',
    theMobilePhoneNumberCannotBeEmpty: '手機號碼不允許為空',
    theMobilePhoneNumberFormatIsIncorrect: '手機號碼格式不正確',
    theFormatOfTheIdCardNumberIsIncorrect: '身份證號碼格式不正確',
    memberInformationEnteredSuccessfully: '會員信息錄入成功',
  },
  pullnewNewlist: {
    promoter: '推廣人',
    pullTime: '拉新時間',
    pleaseEnterYourPromoterName: '請輸入推廣人姓名',
    memberNickname: '會員暱稱',
    pulsingType: '拉新類型',
  },
  pullnewQrcode: {
    aboutHalfA4: '約A4紙一半',
    sizeLarge: '大',
    sizeSmall: '小',
    sizeMedium: '中',
    lShapedStand: 'L形台卡',
    paperSize: '紙大小',
    downloadPicture: '下載圖片',
    memberPullNewCodeGenerationPleaseWait: '會員拉新碼生成中，請稍後',
    memberPoster: '會員海報',
    frontDeskStaff: '前台員工',
    foreground: '前台',
    commonArea: '公區',
    corridor: '走廊',
    elevator: '電梯',
    displayStand: '展架',
  },
  tiktokpresalecouponDetail: {
    totalGoodsPrice: '商品總價（劃線價）',
    uploadImageTips: '上傳1-5張，圖片尺寸：5M以內；建議分辨率為375*280px；圖片比例為4:3',
    unavailableCheckInDates: '不可入住日期：',
    otherInStoreOffers: '可享用店內其他優惠(詳詢商家)',
    createACoupon: '創建預售券',
    support: '支持',
    nonsupport: '不支持',
    putUp: '住宿',
    bindAvailableProducts: '綁定可用產品',
    bindAtLeastOneProduct: '至少綁定一個產品',
    meal: '餐食',
    addMeal: '添加餐食',
    courteousReception: '禮遇',
    addItem: '添加項目',
    unlimitedInventory: '不限庫存',
    stockLimit: '限庫存',
    whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate: '開啟自動延期後商品售賣日期到期後會自動延期30天',
    namedDate: '指定日期',
    specifiedDays: '指定天數',
    fromTheDateOfPurchase: '自購買之日起',
    availableWithinDays: '天內可用',
    unavailableWeek: '不可用星期',
    unavailableHolidays: '不可用節假日',
    unavailableDate: '不可用日期',
    subjectToAMarkup: '需加價',
    noMarkup: '無需加價',
    allStores: '全部門店',
    addMarkupRules: '添加加價規則',
    limitOnePurchasePerOrder: '每單限購一張',
    purchaseLimitPerPerson: '每人限購',
    maximumPurchasePerPerson: '每人最多購買',
    zhang: '張',
    noAdvanceReservationRequired: '不需要提前預約',
    advanceReservationRequired: '需要提前預約',
    aheadOfSchedule: '提前',
    dailyReservation: '天預約',
    beforeCheckIn: '入住前',
    cannotBeCombinedWithOtherInStoreOffers: '不可與店內其他優惠同享',
    theMealTypeCannotBeEmpty: '餐食類型不能為空',
    theNameOfTheOfferCannotBeEmpty: '禮遇名稱不能為空',
    ticketName: '預售券名稱',
    pleaseEnterTicketNamemaximum24Words: '請輸入預售券名稱（最多60個字）',
    fractionalAppointment: '分次預約',
    commodityContent: '商品內容',
    lunch: '午餐',
    originalPrice2: '原價',
    automaticExtension: '自動延期',
    availabilityDate: '可入住日期',
    markUpPolicy: '加價政策',
    additionalChargesApply: '需額外付費項目',
    purchaseRestrictionRule: '限購規則',
    reservationRule: '預約規則',
    upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio: '上傳1-10張，圖片尺寸：5M以內；建議分辨率為375*280px；圖片比例為',
  },
  tiktokpresalecouponList: {
    unrestrictedInventory: '不限制庫存',
    theRemovalHasBeenCancelled: '已取消下架',
    productId: '商品ID',
    product2: '商品',
    createACoupon: '創建預售券',
    listing: '上架',
    delist: '下架',
    auditFailure: '審核失敗',
    soldInventory: '已售庫存',
    modifiedPricePool: '修改價庫',
    copy: '複製',
    exportListOfPreSaleTickets: '預售券導出列表',
    itemDeletion: '商品刪除',
    goodsOffTheProductionLine: '商品下線',
    removedSuccessfully: '下架成功',
  },
  assemblyAddpriceruledialog: {
    allStores: '全部門店',
    byDate: '按日期',
    byHoliday: '按節假日',
    addMarkupRules: '添加加價規則',
    markupStore: '加價門店',
    markUpPeriod: '加價時間段',
    pleaseEnterTheAmountOfTheIncrease: '請輸入加價金額',
    theIncreaseMustBeGreaterThan: '加價金額必須大於',
    pleaseSelectTheIncreasePeriod: '請選擇加價時間段',
    pleaseSelectAFestival: '請選擇節日',
    pleaseSelectTheWeekOfIncrease: '請選擇加價星期',
  },
  assemblyAddmeals: {
    cancel2: '取消',
    addMeal: '添加餐食',
    typeOfMeal: '餐食類型',
    pleaseSelectTheTypeOfMeal: '請選擇餐食類型',
    lunch: '午餐',
    dinner: '晚餐',
    copies: '份數',
    pleaseEnterTheNumberOfCopies: '請輸入份數',
    theNumberOfCopiesMustBeGreaterThan: '份數必須大於',
  },
  settingHardware: {
    hardwareManagementToBeDeveloped: '硬件管理,待開發',
  },
  settingMessage: {
    messageManagementToBeDeveloped: '消息管理,待開發',
  },
  baseinfotabBase: {
    orientation: '定位',
    save4: '保存',
    china: '中國',
    province: '省份',
    hotelRating: '酒店星级',
    detailedAddress: '詳細地址',
    city: '城市',
    hotelPrice: '酒店價格',
    hotelReceptionCellPhone: '酒店前台手機',
    hotelFrontDesk: '酒店前台座机',
    areaCode: '區號',
    landlineNumber: '座機號',
    extensionNumber: '分機號',
    serviceStatus: '服務狀態',
    ctripHotelStars: '攜程酒店星級',
    noStarLevel: '無星級',
    starLevel: '{num}星',
    whetherToSellItOnTheInternet: '是否在外網售賣',
    currency: '幣種',
    longitude: '經度',
    latitude: '緯度',
    baiduLatitudeAndLongitude: '百度經緯度',
    pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits: '請輸入正確手機號，且最多11位',
    theLengthIs78Characters: '長度在7-8個字符',
    theLengthIs34Characters: '長度在3-4個字符',
    pleaseEnterAnInteger: '請輸入整數',
    pleaseEnterTheHotelName: '請輸入酒店名稱',
    lengthOf250ChineseCharacters: '長度在2-50個漢字',
    theValueContains34Digits: '長度在3-4位數值',
    theValueContains78Characters: '長度在7-8位數值',
    pleaseEnterTheValue: '請輸入數值',
    pleaseSelectAProvince: '請選擇省份',
    pleaseSelectCity: '請選擇城市',
    pleaseSelectACounty: '請選擇區縣',
    pleaseEnterTheFullAddress2: '請輸入詳細地址',
    theDetailedAddressDoesNotExceed50ChineseCharacters: '詳細地址不超過50個漢字',
    pleaseSelectHotelClass: '請選擇酒店星級',
    pleaseSelectACtripHotelStar: '請選擇攜程酒店星級',
    selectWhetherTheExternalNetworkIsVisible: '請選擇是否外網可見',
    pleaseSelectHotelServiceStatus: '請選擇酒店服務狀態',
    economical: '經濟型',
    quasi1Star: '準1星',
    true1Star: '真1星',
    quasi2Star: '準2星',
    true2Star: '真2星',
    quasi3Star: '準3星',
    true3Star: '真3星',
    quasi4Star: '準4星',
    true4Star: '真4星',
    quasi5Star: '准5星',
    true5Star: '真5星',
    inOperation: '營業中',
    suspendBusiness: '暫停營業',
    tencentMapLatitudeAndLongitudeCanNotBeEmpty: '騰訊地圖經緯度不能為空',
    theNameAndAddressOfTheHotelAreUnderReview: '酒店名稱、地址進入審核中',
    districtcounty: '區/縣',
    tencentamapLatitudeAndLongitude: '騰訊/高德經緯度',
    pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits: '請輸入正確手機號,且最多11位',
  },
  baseinfotabFull: {
    hotelTimezone: '酒店時區',
    fixedRoomNumber: '是否固定房間數',
    save4: '保存',
    businessCircle: '所屬商圈',
    hotelBuildingHeight: '酒店樓高',
    subordinateBusinessCircle: '所屬副商圈',
    totalNumberOfRooms: '客房總數',
    hotelOpeningHours: '酒店開業時間',
    pleaseSelectADate5: '請選擇年月',
    affiliatedGroup: '所屬集團',
    hotelRenovationTime: '酒店裝修時間',
    affiliatedBrand: '所屬品牌',
    hotelTypeupToThree: '酒店類型(最多只能選三個)',
    hotelThemeupToThreeCanBeSelected: '酒店主題(最多只能選三個)',
    settlementMethod: '結算方式',
    hotelProfile: '酒店簡介',
    hotelTransportationLocation: '酒店交通位置',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits: '請輸入大於等於0的數字，不超過3位',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits: '請輸入大於等於0的數字，不超過2位',
    pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters: '請輸入酒店簡介且長度不超過800個字符',
    pleaseEnterTheHotelTransportationLocation: '請輸入酒店交通位置',
    pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters: '請輸入酒店交通位置且長度不超過800個字符',
    pleaseEnterTheTotalNumberOfRooms: '請輸入客房總數',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2: '請輸入大於等於0且不超過3位的數字',
    pleaseSelectYourBrand: '請選擇所屬品牌',
    pleaseEnterTheHotelBuildingHeight: '請輸入酒店樓高',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2: '請輸入大於等於0且不超過2位的數字',
    pleaseEnterHotelRenovationTime: '請輸入酒店裝修時間',
    pleaseEnterHotelOpeningHours: '請輸入酒店開業時間',
    pleaseEnterTheCheckoutSupportCardType: '請輸入結賬支持卡種',
    pleaseSelectHotelType: '請選擇酒店類型',
    pleaseSelectAHotelTheme: '請選擇酒店主題',
    bizumi: '美住',
    theBusinessCircleIsUnderReview: '所屬商圈進入審核中',
    includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages: '包括但不限於：酒店地址,酒店設施,酒店提供的各項服務,酒店特色和優勢',
    includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km: '包括但不限於：酒店附近的交通設施,如：距離公交車站100米，距離高鐵站2.5km',
  },
  baseinfotabInfo: {
    commission2: '稅費',
    bookingInstructions: '預訂須知',
    variousFaults: '各類故障',
    save4: '保存',
    earliestCheckInTime: '最早入住時間',
    latestDepartureTime: '最晚離店時間',
    hourRoomEarliestCheckInTime: '鐘點房最早入住時間',
    hourRoomLatestCheckOutTime: '鐘點房最晚離店時間',
    aMaximumOf30Characters: '最多不超過30個字符',
    taxTitle: '稅費名稱',
    chargingStandard: '收費標準',
    reservationNotes: '預訂須知備註',
    chineseDescription: '中文描述',
    pleaseEnterYourEarliestCheckInTime: '請輸入最早入住時間',
    pleaseEnterTheLatestDepartureTime: '請輸入最晚離店時間',
    pleaseEnterTheEarliestCheckInTimeForTheHourRoom: '請輸入鐘點房最早入住時間',
    pleaseEnterTheLatestCheckOutTimeForTheHourRoom: '請輸入鐘點房最晚離店時間',
    pleaseSelectTheBookingInstructions: '請選擇預訂須知',
    noMoreThan10ChineseCharactersInLength: '長度不超過10個漢字',
    theLengthCannotExceed20Characters: '長度不超過20個字符',
    noMoreThan20ChineseCharactersInLength: '長度不超過20個漢字',
    noMoreThan30ChineseCharactersInLength: '長度不超過30個漢字',
    theLengthCannotExceed60Characters: '長度不超過60個字符',
    cutOffTheWaterSupply: '停水',
    powerFailure: '停電',
    elevatorFailure: '電梯故障',
    cantUseBankCard: '不能刷銀行卡',
    networkFault: '網絡故障',
    pleaseEnterTheStartTimeAndEndTime: '請輸入開始時間和結束時間',
    theStartTimeMustBeYoungerThanTheEndTime: '開始時間必須小於結束時間',
  },
  baseinfotabServer: {
    squareMeter: '平方米',
    save4: '保存',
    parkingLot: '停車場',
    elevator2: '電梯',
    pleaseEnterArea: '請輸入面積',
    internetAccessInPublicAreas: '公共區域上網',
    hotelFacilities: '酒店設施',
    otherFacilities: '其他設施',
    hotelService: '酒店服務',
    otherServices: '其他服務',
    fallow: '休閒',
    otherLeisure: '其他休閒',
    pleaseEnterAMaximumOf10DigitsInEnglish: '請輸入英文中文數字長度不超過10位',
    pleaseSelectParking: '請選擇停車場',
    pleaseSelectTheHall: '請選擇大廳',
    pleaseEnterTheHallArea: '請輸入大廳面積',
    pleaseSelectElevator: '請選擇電梯',
    pleaseSelectPublicAreasToAccessTheInternet: '請選擇公共區域上網',
    pleaseSelectHotelFacilities: '請選擇酒店設施',
    pleaseSelectHotelServices: '請選擇酒店服務',
    pleaseSelectLeisure: '請選擇休閒',
    oneToFiveStars: '準1-5星',
    true15Stars: '真1-5星',
    walkUp: '無電梯',
    thereIsAnElevator: '有電梯',
    lobbyless: '無大廳',
    haveALobby: '有大廳',
    noInternetAccess: '不能上網',
    freeParking: '免費停車',
    noParking: '無停車場',
    parkingLotAvailable: '有停車場',
    paidParking: '收費停車',
    charge: '收費',
  },
  borrowBorrowrecord: {
    loanDate2: '借用日期',
    newBorrowing: '新增',
    return: '歸還',
    cannotBeGreaterThanTheAvailableAmount: '不能大於可用量',
    enterItemNameAndRoomNumber: '輸入物品名稱、房間號',
    unitPriceOfGoods2: '物品單價',
    quantityBorrowed: '借用數量',
    borrowARoom: '借用房間',
    dateOfReturn: '歸還日期',
    returnQuantity: '歸還數量',
    borrowedState: '借用狀態',
    amountOfCompensation: '賠償金額',
    serviceSuccess: '服務成功',
    serviceFailure: '服務失敗',
    reasonForRefusal: '拒絕原因',
    enterAMaximumOf30Characters: '最多輸入30個字',
    returnOrNot: '是否歸還',
    hasItBeenReturned: '是否已歸還',
    onlyNumbersGreaterThan0CanBeEntered: '只能輸入大於0的數字',
    theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed: '歸還數量不能大於或等於借用數量',
    upTo20Characters: '最多20字符',
    pleaseEnterTheReturnQuantity: '請輸入歸還數量',
    onLoan: '借用中',
    theRoomRequestHasBeenServiced: '客房請求已服務完成',
    serviceCompletion: '服務完成',
    returned: '已歸還',
    noReturn: '未歸還',
    enterAMaximumOf9Characters: '最多輸入9字符',
    chooseToBorrowRoom: '選擇借用房間',
  },
  borrowBorrowset: {
    newItem: '新增',
    usable: '可用',
    notAvailable: '不可用',
    alreadyRemoved: '已刪除',
    enterItemName: '物品名稱',
    unitPriceOfGoods2: '物品單價',
    inventory: '庫存',
    amountBorrowed: '已借用量',
    loanableQuantity: '可藉用量',
    theNameCannotExceed9CharactersPleaseEnterANewName: '名稱長度不能超過9個字，請重新輸入',
    priceCannotBeLessThan0PleaseReEnter: '價格不能小於0，請重新輸入',
    priceCannotBeGreaterThan9999PleaseReEnter: '價格不能大於9999，請重新輸入',
    theInventoryCannotBeLessThan0PleaseReEnter: '庫存量不能小於0，請重新輸入',
    inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter: '庫存量不能小於借用量，請重新輸入',
    areYouSureYouWantToDeleteThisItem: '確定要刪除該物品嗎',
    areYouSureYouWantToDisableThisItem: '確認要禁用該物品嗎',
    thisItemHasNotBeenReturnedConfirmToDelete: '該物品尚有無歸還，確認刪除嗎？',
  },
  businessCardIndex: {
    pleaseUploadPictures: '请上传图片',
    pleaseEnterPrice3: '請輸入價格',
    pleaseEnterRoomType: '請輸入房型',
    uploadBackground: '上傳背景',
    saveOperation: '保存操作',
    uploadProfilePicture: '上傳頭像',
    pleaseEnterAValidNumber: '請輸入有效的數字',
    businessCardType: '名片類型',
    currentPriceOfRoomType: '房型現價',
    roomTypeOriginalPrice: '房型原價',
    backgroundImage: '背景圖',
    avatar: '頭像',
    save4: '保存',
    hotelRecommendation: '酒店推薦',
    roomTypeRecommendation: '房型推薦',
    theNameCannotBeBlank2: '姓名不能為空',
    thePhoneNumberCannotBeEmpty: '手機號不能為空',
    pleaseEnterAValidPhoneNumber: '請輸入有效的手機號',
    roomTypeNameCannotBeEmpty: '房型名稱不能為空',
    theCurrentPriceOfTheRoomTypeCannotBeEmpty: '房型現價不能為空',
    roomTypeOriginalPriceCannotBeEmpty: '房型原價不能為空',
    pleaseUploadTheBackgroundImage: '請上傳背景圖',
    pleaseUploadPhoto: '請上傳頭像',
    areYouSureYouWantToLeaveTheCurrentPage: '確定要離開當前頁面嗎',
    pleaseSelectImageUpload: '請選擇圖片上傳',
    theCurrentPriceOfTheRoomTypeShallNotBeLessThan: '房型現價不得小於',
    roomTypeOriginalPriceMustNotBeLessThan: '房型原價不得小於',
  },
  businessCardUploadavatar: {
    selectPicture: '選擇圖片',
    uploadProfilePicture: '上傳頭像',
    pleaseSelectImageUpload: '請選擇圖片上傳',
    onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m: '僅支持JPG，PNG格式圖片，圖片大小不超過',
  },
  ctnhotelHotelserver: {
    applicationTime2: '申請時間',
    toDealWith: '去辦理',
    pleaseRenewYourStayOnTheDayOfDeparture: '請在離店日辦理續住',
    applicant: '申請人',
    originalExpectedArrivalDate: '原預抵日期',
    originalDepartureDate: '原預離日期',
    applicationType: '申請類型',
    renewTheNewOrderNumber: '续住新单号',
    renewalDate: '續住日期',
  },
  ebaccountLogin: {
    accountLogin: '賬號登錄',
    gotTheMessage: '收到消息了',
  },
  ebaccountSetting: {
    accountBinding: '賬號綁定',
    goToMaintain: '去維護',
    priceModel: '價格模式',
    automaticOrder: '自動搬單',
    comingSoon: '即將開通',
    hourlyRoomOrder: '鐘點房接單',
    orderCancellation: '訂單取消',
    bound: '已綁定',
    roomTypeSetting: '房型設置',
    goToSettings: '去設置',
    lastStep: '上一步',
    correlationState: '關聯狀態',
    bindAccount: '綁定賬號',
    synchronizationTime: '同步時間',
    onSale: '在售',
    associated: '已關聯',
    uncorrelated: '未關聯',
    bind: '綁定',
    noDataIsQueried: '未查詢到數據',
    whetherToUnbindTheAccount: '是否需解綁賬號',
    pleaseEnterTheCommissionRate: '請輸入佣金率',
    channelSetting: '渠道設置',
    floorPriceModel: '底價模式',
    sellingPriceModel: '賣價模式',
    viewSettings: '查看設置',
    orderSetup: '訂單設置',
    pleaseSelectAPriceModel: '請選擇價格模式',
    pleaseSelectHourRoomPickUp: '請選擇鐘點房接單',
    dataSynchronization: '數據同步',
    ctripRoomType: '攜程房型',
    usGroupRoomType: '美團房型',
    lightWinTreasureRoomTypeName: '輕贏寶房型名稱',
    commissionRate: '佣金率',
    pleaseEnterTheSmsVerificationCode: '請輸入短信驗證碼',
    pleaseEnterTheContentInThePicture: '請輸入圖片中的內容',
    groggery: '飯店',
    ctripProductName: '攜程產品名稱',
    meituanProductName: '美團產品名稱',
    ctripProducts: '攜程產品',
    meituanProducts: '美團產品',
    lightWinTreasureProductName: '輕贏寶產品名稱',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: '佣金率大於等於0小於100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces: '佣金率為數字，並保留兩位小數',
    pleaseSelectTheHourlyOrderSetting: '請選擇鐘點房搬單設置',
    automaticCancellation: '自動取消',
    manualCancellation: '人工取消',
    automaticConfirmation: '自動確認',
    manualValidation: '人工確認',
    meituancom: '美團網',
    ctrip: '攜程旅行',
    pleaseEnterTheImageVerificationCode: '請輸入圖片驗證碼',
    pleaseSelectHotel: '請選擇酒店',
    theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater: '數據同步成功，請十分鐘後重新查詢數據',
    product2: '產品',
    unbind: '去綁定',
    whetherToUnbindTheProduct: '是否解綁該產品的綁定關係',
    pleaseSelectTheProductName: '請選擇輕贏寶產品名稱',
    unbindSuccessfully: '解綁成功',
    whetherToUnbindTheBindingRelationshipOfTheHouseType: '是否解綁該房型的綁定關係',
    pleaseSelectLightWinTreasureRoomTypeName: '請選擇輕贏寶房型名稱',
    feizhu: '飛豬網',
    notYetUnlocked: '未開啟',
    pleaseBindTheAccountFirst: '請先進行賬號綁定',
    areYouSureYouWantToUnbindTheAccount: '確定要解綁賬號嗎',
    notYetBound: '未綁定',
    pleaseConfirmTheHotelYouWantToBindTo: '請確認要綁定的酒店',
    ctripEbAccount: '攜程EB賬號',
    meituanEbAccount: '美團EB賬號',
    pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid: '請聯繫您的酒店運營經理設置攜程HotelID',
    useEbOrderInformation: '使用EB訂單信息',
    pleaseSelectEbOrderCancellation: '請選擇EB訂單取消',
    meituanEbRoomType: '美團EB房型',
    lightWinTreasureRoomTypeId: '輕贏寶房型ID',
    lightWinTreasureProductId: '輕贏寶產品ID',
    pleaseSelectTheEbOrderCancellationSettings: '請選擇EB訂單取消設置',
    whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually: '自動搬單時，如您未進行房型設置則轉為手工搬單',
    whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder: '手動搬單時，將為您優先匹配設置的房型，節省搬單時間',
    thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible: 'EB訂單設置完成，請盡快進行',
    reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager: '溫馨提示：如您需要設置或新增房型，請聯繫您的運營經理',
    orderSetupCompletedPleaseProceedAsSoonAsPossible: '訂單設置完成，請盡快進行',
    yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo: '您的“攜程旅行”EBK賬號“未綁定”，將無法進行',
    associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible: '關聯。為避免影響EB搬單，請盡快綁定',
    yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo: '您的“攜程旅行”EBK賬號“已失效”，將無法進行',
    associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe: '關聯。為避免影響EB搬單，請“解綁”後重新綁定',
    yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo: '您的“美團網”EBK賬號“未綁定”，將無法進行',
    automaticallyCreditedToArAccount: '自動入AR賬號',
    noticeOfMovingOrderEb: '搬單成功後EB自動接单',
    checkInSuccessNoticeEb: '入住通知',
    meituanMovingOrderDeductsPublicGoods: '美團搬單扣减公益金',
    meituanMovingOrderServiceRate: '美團運營服務費率 %',
    yourctripTravelEbkAccounthasExpired: '您的“攜程旅行”EBK賬號“已失效”，將無法進行',
    yourmeituanEbkAccounthasExpired: '您的“美團網”EBK賬號“已失效”，將無法進行',
  },
  ebmanagementIndex: {
    accountBinding: '賬號綁定',
    commissionRate: '佣金率',
    theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously: '賬號綁定成功，並同步開啟深度運營',
    whetherToUnbindTheAccount: '是否需解綁賬號',
    pleaseEnterTheCommissionRate: '請輸入佣金率',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest: '時間維度和篩選的日期一致，預訂金額按照客人實際支付金額統計',
    pleaseEnterTheSmsVerificationCode: '请输入短信验证码',
    pleaseEnterTheContentInThePicture: '請輸入圖片中的內容',
    groggery: '飯店',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: '佣金率大於等於0小於100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces: '佣金率为数字，并保留两位小数',
    pleaseSelectHotel: '请选择酒店',
    pleaseEnterTheImageVerificationCode: '請輸入圖片驗證碼',
    accountUntying: '賬號解綁',
    unbindSuccessfully: '解綁成功',
    pleaseConfirmTheHotelYouWantToBindTo: '請確認要綁定的酒店',
    noEbAccountHasBeenBound: '暫無綁定任何EB賬號',
    ebAccountLogin: 'EB 帳號登入',
  },
  hardwareBluetoothlock: {
    smartDoorLock: '智能門鎖',
    configurationFailure: '配置失败',
    thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience: '此功能专指密码、蓝牙等智能门锁对接，可通过小程序及APP使用密码、蓝牙等方式开门，提升客户入住体验',
  },
  hardwareChoseroom: {
    selectARoom2: '選擇房間',
  },
  hardwareCreatepassworddialog: {
    createPassword: '創建密碼',
    selectType: '選擇類型',
    pleaseEnterAgain: '請再次輸入',
    validUntil: '有效期至',
    pleaseEnterA6DigitPassword: '請輸入6位數字密碼',
    passwordIsDifferentPleaseReEnter: '密碼不一致，請重新輸入',
    pleaseSelectADate4: '請選擇日期',
    oneTimePassword: '一次性密码',
    timePeriodCipher: '时间段密码',
    offlinePassword: '离线密码',
    longAgingOfflinePassword: '长时效离线密码',
  },
  hardwareEditpassworddialog: {
    oneTimePassword: '一次性密码',
    timePeriodCipher: '时间段密码',
    offlinePasswordForALongTime: '长时间离线密码',
    offlinePassword: '离线密码',
    recover2: '恢复',
    currentPassword: '当前密码',
    pleaseEnterAgain: '请再次输入',
    validUntil: '有效期至',
    pleaseEnterA6DigitPassword: '请输入6位数字密码',
    passwordIsDifferentPleaseReEnter: '密码不一致，请重新输入',
    pleaseSelectADate4: '请选择日期',
    longAgingOfflinePassword: '长时效离线密码',
  },
  hardwareHousepricecard: {
    memberRightsShowStoreActivitiesShow: '会员权益展示，门店活动展示',
    openThePriceBoard: '打开房价牌',
    downloadRateBoard: '下载房价牌',
    failedToConfigureElectronicPriceBoard: '配置电子房价牌失败',
  },
  hardwareIdcard: {
    whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox: '当证件类型为身份证时，可通过身份证读卡器读取客人证件信息自动填充到文本框内',
    idCardReader: '身份证读卡器',
    failedToConfigureTheIdCardReader: '配置身份证读卡器失败',
  },
  hardwareLock: {
    doorLockType: '门锁类型',
    selectiveLock: '选择门锁',
    areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom: '确认要删除该房间门锁配置吗',
    pleaseEnterRoomNumberAndEquipmentModel: '请输入房间号、设备型号',
    doorLockCardPrintingRecord: '门锁制卡记录',
    roomDoorLockConfiguration2: '房间门锁配置',
    passwordSetting2: '密码设置',
    deviceType: '设备类型',
    equipmentBrand: '设备品牌',
    equipmentType: '设备型号',
    versionNumber: '版本号',
    roomLockNumber: '房间锁号',
    doorLock: '门锁',
    doorLockPower: '门锁电量',
    editDoorLockConfiguration: '编辑门锁配置',
    selectDevice: '选择设备',
    setTheDoorLock: '设置门锁',
    setTheRoomLockNumber: '设置房间锁号',
    pleaseEnterDoorLock: '请输入门锁',
    settingNmsParameters: '设置网管参数',
    pleaseEnterNetworkManagementParameters: '请输入网管参数',
    traditionalDoorLock: '传统门锁',
    smartDoorLock: '智能门锁',
    pleaseEnterTheLockId: '请输入门锁ID',
    pleaseEnterLockmac: '请输入lockMac',
    batchDelete: '批量刪除',
    confirmBatchDeleteText: '確認要批量刪除選中的房間門鎖配置嗎？',
    pleaseSelectRecordsToDelete: '請先選擇要刪除的記錄',
    batchDeleteSuccess: '批量刪除成功',
    batchDeleteFail: '批量刪除失敗',
  },
  hardwareLockpassword: {
    createPassword: '創建密碼',
    comeIntoForce: '生效',
    activationCode: '激活码',
    applicableRoom: '适用房间',
    expirationDate3: '有效截止日期',
    theDoorLockThatSupportsThePasswordIsNotEnabled: '未开通支持密码相关的门锁',
    passwordSetting: '密碼設置',
    invalidate: '置失效',
    restore: '恢復',
    confirmInvalidatePassword: '確認要將當前密碼置失效嗎？',
  },
  hardwareLockroom: {
    importDialogTitle: '門鎖批量導入',
    importTemplateFileName: '門鎖導入模版.xlsx',
    downloadSuccess: '門鎖導入模版下載成功',
    downloadFail: '門鎖導入模版下載失敗',
    roomDoorLockConfiguration: '房间门锁配置',
    customRule: '自定義規則',
    rule: '規則',
    deviceType: '設備類型',
    selectDevice: '選擇設備',
    empty: '空',
    selectLock: '選擇門鎖',
    deviceBrand: '設備品牌',
    deviceModel: '設備型號',
    version: '版本號',
    configurationInfo: '配置信息',
    selectRoom: '選擇房間',
    lockDeviceId: '門鎖設備ID',
    remainingPower: '剩餘電量',
    remoteOpenDoorType: '遠程開門方式',
    gatewayOpen: '網關開門',
    bluetoothOpen: '藍牙開門',
    rule1: '鎖號 = 房間號',
    rule2Prefix: '鎖號 =',
    rule3Prefix: '鎖號 =',
    trimRoomNumber: '去掉首位的房間號',
    import: '導入',
    clickUpload: '點擊上傳',
    imported: '已導入',
    rulePrefix: '規則：',
    generateLockId: '生成鎖號',
    lockIdLabel: '門鎖ID',
    roomLockNumberLabel: '房間鎖號',
    enterRoomLockNumber: '請輸入房間鎖號',
    enterLockId: '請輸入門鎖ID',
    gatewayParams: '網關參數',
    enterGatewayParams: '請輸入網關參數',
    enterLockMac: '請輸入 lockMac',
    getFreeGoLock: '獲取 FreeGo 門鎖',
  },
  hardwareNfclock: {
    thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure: '此功能专指碰卡门锁对接，可通过PMS制作宾客的房卡，提升办理入住的效率',
    traditionalDoorLock: '传统门锁',
    doorLockInformationConfiguration2: '门锁信息配置',
    functionCardManagement2: '功能卡管理',
    failedToConfigureATraditionalDoorLock: '配置传统门锁失败',
  },
  hardwarePricecard: {
    full: '满',
    serviceHotline: '服务热线',
    downloadRateBoard: '下载房价牌',
  },
  hardwareSelfdevicedialog: {
    selfServiceMachinePaymentConfiguration: '自助机支付配置',
    depositAllocationCollection: '押金配置收取',
    orderRetentionTimeConfiguration: '订单保留时间配置',
    whetherTheUnpaidOrderIsCancelledImmediately: '未支付订单是否立即取消',
    minutes: '分钟',
    checkOutArrangement: '离店配置',
    checkOutAccountingConfiguration: '退房账务配置',
    temporaryCheckOut: '临时挂账退房',
    checkOut2: '结账退房',
    autoAddRoomFeeConfig: '自動加收房費配置',
    whetherToEnableAutoAddRoomFee: '是否啟用自動加收房費',
    occupancyConfiguration: '入住配置',
    whetherToSupportHourRoomWithoutReservation: '是否支持钟点房无预订入住',
    supportForTimePeriodsWithoutReservation: '支持钟点房无预订入住的时间段',
    theSelfServiceMachineIsSuccessfullyConfigured: '自助机配置成功',
    selfServiceMachineConfiguration2: '自助机配置',
    pleaseFillInTheDepositConfiguration: '请填写押金配置',
    pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked: '请选择钟点房无预订入住的时间段',
  },
  hardwareSelfservice: {
    selfServiceMachine: '自助机',
    selfServiceMachineConfiguration2: '自助机配置',
    failedToConfigureTheSelfServiceMachine: '配置自助机失败',
    thereIsNoSelfServiceMachineInTheHotel: '酒店暂未配置自助机',
    thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch: '此开关为开通自助机与PMS系统的接口开关，若酒店需对接自助入住机，需打开开关',
  },
  hardwareSetWitness: {
    "title": "人证刷脸设备",
    "desc": "人证刷脸，自助入住",
    "setting": "设置",
    "configSuccess": "开启人证配置成功",
    "configClose": "关闭人证配置成功",
    "configFailed": "配置失败"
  },
  hardwareWitness: {
    "deviceSnSetting": "设备编码设置",
    "deviceSn": "设备SN",
    "addSn": "新增SN",
    "enterSn": "请输入SN",
    "addSnBtn": "+ 新增SN",
    "saveSuccess": "保存成功",
    "deleteSuccess": "删除成功",
    "snRepeatError": "SN不能重复",
    "deleteConfirmMsg": "确认删除该设备SN吗？",
    "deleteConfirmTitle": "提示",
  },
  hardwareSethouserpricecard: {
    transversePlate: '横板',
    verticalVersion: '竖版',
    addPictureUpload: '添加图片上传',
    show: '展示',
    doNotShow: '不展示',
    format: '版式',
    storePicture: '门店图片',
    pleaseEnterADescription: '请输入描述',
    hourRoomRates: '钟点房价格',
    pleaseEnterPrice3: '请输入价格',
    pleaseSelectTheNumberOfHours: '请选择小时数',
    whetherToDisplayMemberPrices: '是否展示会员价格',
    roomReservationPhone: '订房电话',
    pleaseEnterTheReservationNumber: '请输入订房电话',
    bookingGuide: '预订引导文案',
    pleaseEnterThePreOrderGuideCopy: '请输入预定引导文案',
    hotelAnnouncement: '酒店公告',
    pleaseEnterTheHotelBulletin: '请输入酒店公告',
    uploadedPictures: '已上传图片',
    storePicturesMustBeUploaded: '门店图片必传',
    onlyJpgjepgpngFormatIsSupported: '仅支持jpg jepg png格式!',
  },
  functionalcardAuthorizationcard: {
    authorizationCardBeforeReportingTheLoss: '挂失之前的授权卡',
    authorizationCard: '授权卡',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess: "一般情况下，只需要在锁上刷授权卡，门锁发出'滴滴'两声表示授权成功",
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock: '当门锁的房号或时间信息丢失，可用房号设置卡或时钟设置卡来设置门锁；或者连续刷3次授权卡，再用此房间客人卡开门即可',
  },
  functionalcardExtendssetting: {
    after: '后',
    inMinutes: '分钟内',
    findRoomNumber: '查找房号',
    timeDeviation: '时间偏差',
    roomNumberRequired: '房号必填',
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock: '当门锁的房号或时间信息丢失，可用房号设置卡或时钟设置卡来设置门锁；或者连续刷3次授权卡，再用此房间客人卡开门即可',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess: "一般情况下，只需要在锁上刷授权卡，门锁发出'滴滴'两声表示授权成功",
  },
  functionalcardIndex: {
    selectiveClassification: '选择分类',
    functionCardManagement2: '功能卡管理',
    authorizationCard: '授权卡',
    extendedSettingsClass: '扩展设置类',
    openCategory: '开门类',
    specificFunctionClass: '特定功能类',
    businessCardFailure: '制卡失败',
  },
  functionalcardOpendoor: {
    beforeTheLossWasReported: '挂失之前的',
    publicDoorsCanBeOpened: '可以开启公共门',
    canOpenTheLock: '可以开反锁',
    availablePeriod: '可用时段',
    startTimeRequired: '开始时间必填',
    theEndTimeIsRequired: '结束时间必填',
    floorFill: '楼层必填',
    theFloorMustConsistOf4PureDigits: '楼层必须为4位纯数字组成',
    layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding: '层控卡：用于开启某个楼栋中的某一层的所有门锁',
    totalCardCanOpenAllLocksInThisSystem: '总卡：可以开启本系统的所有门锁',
  },
  functionalcardParticularfeature: {
    checkOutCardBeforeTheLossWasReported: '挂失之前的退房卡',
    theMissingCardNumber: '遗失的卡号',
    pleaseEnterTheCardNumberToFind: '请输入卡号查找',
    theLostCardNumberIsRequired: '遗失的卡号必填',
    lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard: '挂失卡：如果某张卡遗失了，可以挂失此卡，输入选择遗失的卡号，制一张挂失卡，到遗失卡能开门的门锁上刷一遍',
    checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard: '退房卡：给服务员用的，一般来说，服务员有两张卡，一张是层控卡，用于开门，另一张是退房卡，在客人通知退房，服务员查完房后，在门锁上刷一下退房卡，此前的客人卡就不能开门了，不影响新发的客人卡',
  },
  sdkinitIndex: {
    theLockInformationIsInitializedSuccessfullyProcedure: '门锁信息初始化成功',
    afterEnteringTheCardManagement: '后进入卡管理',
    performTheInitialConfigurationOfDoorLockInformationFirst: '请先进行门锁信息初始化配置',
    hardwareDeviceType: '硬件设备类型',
    hardwareBrand: '硬件品牌',
    configurationInformation: '配置信息',
    thisParameterIsMandatory: '配置信息必填',
    initialConfiguration: '初始化配置',
    doorLockInformationConfiguration2: '门锁信息配置',
    theDoorLockInformationIsConfiguredSuccessfully: '门锁信息配置成功',
    configurationFailure: '配置失败',
  },
  hotelBaseInfo: {
    basicInformation3: '基本信息',
    detailedInformation: '详细信息',
    hotelFacilitiesAndServices: '酒店设施及服务',
    hotelPoliciesAndNotices: '酒店政策与通知',
  },
  hotelFloor: {
    floorInformationToBeDeveloped: '楼层信息,待开发',
  },
  hotelPicture: {
    acquiesce: '默认',
    theLatestTime: '时间最近',
    theFarthestTime: '时间最远',
    batchDeletion: '批量删除',
    undelete: '取消删除',
    cover: '封面',
    firstMap: '首图',
    setAsHotelCover: '设为酒店封面',
    noPictureInformationIsAvailable: '暂无图片信息',
    submit2: '提 交',
    photoEditor: '图片编辑',
    setAsTheFirstPictureOfTheRoomType: '设为房型首图',
    recentRevision: '最近修改',
    appearance: '外观',
    guestRoom: '客房',
    publicFacilities: '公共设施',
    catering: '餐饮',
    surroundingEnvironment: '周边环境',
    theCoverImageAndFirstImageCannotBeDeletedDirectly: '封面图、首图不可直接删除',
    areYouSureToDeleteThePicture: '确定删除图片吗',
    operate: '營運',
    pleaseSelectAtLeastOnePicture: '請至少選擇一張圖片',
    pleaseSelectCategory: '請選擇分類',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting: '請上傳圖片成功後再提交',
    submitSuccessfully4: '提交成功',
    imagesCannotBeUploadedInBatchEditingMode: '批量編輯狀態下不可上傳圖片',
    logoOnlyOne: 'Logo 只能上傳一張圖片',
    logoSizeLimit: 'Logo 圖片大小不能超過 500KB',
    logoRatioError: 'Logo 必須為 1:1 的正方形圖片，當前尺寸為 {width}×{height}',
  },
  assemblyModifyinventoryprice: {
    unlimitedInventory: '不限庫存',
    stockLimit: '限庫存',
    modifiedPricePool: '修改價庫',
    soldInventory: '已售庫存',
  },
  hotelPreview: {
    viewPicture: '查看圖片',
  },
  hotelRoomType: {
    batchImportRoomType: '房型批量導入',
    importTemplateFileName: '房型導入模版.xlsx',
    downloadSuccess: '房型導入模版下載成功',
    downloadFail: '房型導入模版下載失敗',

    newHousingType: '新建房型',
    partialWindow: '部分窗',
    skylight: '天窗',
    closedWindow: '封閉窗',
    bayWindow: '飄窗',
    hotelCode: '酒店編碼',
    roomTypeCode: '房型編碼',
    externalRoomTypeCode2: '外部房型編碼',
    whetherToSellOnline: '是否在線售賣',
    bedType2: '床型',
  },
  hotelRoom: {
    newRoom: '新建房間',
    save4: '保存',
    pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate: '請按照模版中的要求整理房間信息',
    downloadTemplate: '下載模板',
    downloadFailureData: '下載失敗數據',
    batchImport: '批量导入',
    floor2: '所在楼层',
    building: '所在楼栋',
    housingType: '所属房型',
    faceEast: '朝东',
    faceWest: '朝西',
    faceSouth: '朝南',
    faceNorth: '朝北',
    stayAwayFromElevators: '远离电梯',
    nearTheStairs: '靠近楼梯',
    closeToTheRoad: '靠近马路',
    windowWall: '窗外墙体',
    decorativeFalseWindow: '装饰性假窗',
    theRoomNumberCannotBeEmpty: '房间号不能为空',
    theFloorOnWhichTheRoomIsLocatedCannotBeEmpty: '房间所在楼层不能为空',
    theRoomTypeCannotBeEmpty: '房间所属房型不能为空',
    editSuccessfully: '编辑成功',
    newSuccess: '新增成功',
    theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty: '所属房型及名称不能为空所在楼层不能为空',
    currentLimitSelect1FilePleaseRemoveAndAdd: '当前限制选择 1 个文件,请移除再添加',
    definitiveRemoval: '确定移除',
    abnormalDataInformationTemplate: '异常数据信息模板',
    xlsFormatOnly: '仅支持XLS格式文件',
    dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt: '删除房间后数据无法恢复，是否确定删除',
  },
  hotelTypedetail: {
    newHousingType: '新建房型',
    editRoomType: '编辑房型',
    viewRoomType: '查看房型',
    basicInformation3: '基本信息',
    squareMeter: '平方米',
    bedSize: '床型尺寸',
    extraBedCondition: '加床情況',
    internetAccess: '上網情況',
    roomTypeFacilities: '房型設施',
    roomTypeStatus: '房型狀態',
    saveAndSubmit: '保存並提交',
    roomTypeNameAMaximumOf50Characters: '房型名稱最多輸入50個字符',
    floorArea: '建築面積',
    roomTypeEnglishName: '房型英文名稱',
    floorType: '所在樓層類型',
    floor2: '所在樓層',
    pleaseEnter1511: '請輸入-1,5,11',
    chineseRemarks: '中文備註',
    capacity: '可容納人數',
    englishRemarks: '英文備註',
    externalRoomTypeCode2: '外部房型編碼',
    extraBed: '加床',
    internetAccess2: '能否上網',
    roomInternetInformation: '房間上網信息',
    broadbandTariff: '寬帶資費',
    disposableToiletries: '一次性洗漱用品',
    bathroomType: '衛生間類型',
    numberOfToilets: '衛生間數量',
    computer: '電腦',
    showerRoom: '洗浴間',
    smokeFreeInformation: '無菸信息',
    bathroom: '衛浴',
    pleaseEnterAnIntegerWithNoMoreThanTwoDigits: '請輸入不超過兩位的整數',
    pleaseEnterAnIntegerGreaterThan0: '請輸入大於0的整數',
    dataDuplicationPleaseConfirm: '數據重複請確認',
    pleaseEnterAValueOfAThreeDigitIntegerUpTo500: '請輸入三位整數且不超過500的值',
    enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters: '最多輸入兩位小數，不超過6個字符長度',
    pleaseEnterBuildingArea: '請輸入建築面積',
    pleaseEnterTheCapacity: '請輸入可容納人數',
    pleaseEnterAnIntegerOfUpToTwoDigits: '請輸入不超過兩位整數',
    roomTypeNameCannotBeEmpty: '房型名稱不能為空',
    roomTypeNameCannotExceed50Characters: '房型名稱長度不能超過50個字符',
    theLengthCannotExceed30Characters: '長度不超過30個字符',
    theTotalNumberOfRoomsCannotBeEmpty: '房間總數不能為空',
    theLengthCannotExceed60Characters: '長度不超過60個字符',
    pleaseSelectBedSize: '請選擇床型尺寸',
    pleaseSelectWindowType: '請選擇窗型',
    pleaseSelectRoomTypeStatus: '請選擇房型狀態',
    pleaseSelectExtraBedCondition: '請選擇加床情況',
    pleaseSelectWhetherYouCanAccessTheInternet: '請選擇能否上網',
    pleaseSelectAPhone: '請選擇電話',
    pleaseSelectDisposableToiletries: '請選擇一次性洗漱用品',
    pleaseSelectABathroomType: '請選擇衛生間類型',
    pleaseSelectTheNumberOfBathrooms: '請選擇衛生間數量',
    pleaseSelectComputer: '請選擇電腦',
    pleaseSelectABathRoom: '請選擇洗浴間',
    pleaseSelectSmokeFreeInformation: '請選擇無菸信息',
    pleaseSelectOther: '請選擇其他',
    pleaseSelectBathroom: '請選擇衛浴',
    commonFloor: '普通樓層',
    executiveFloor: '行政樓層',
    businessFloor: '商務樓層',
    noExtraBed: '不可加床',
    freeExtraBed: '免費加床',
    payExtraBed: '付費加床',
    haveInternetAccess: '可以上網',
    someInternetAccess: '部分可以上網',
    noInternetAccess: '不能上網',
    freeWireless: '免費無線',
    tollWireless: '收費無線',
    freeWire: '免費有線',
    tollWire: '收費有線',
    nationalTollCall: '國內長途電話',
    internationalCall: '國際長途電話',
    freeDomesticLongDistanceCalls: '免費國內長途電話',
    disposableToiletriesAreNotProvided: '不提供一次性洗漱用品',
    disposableToiletriesAreProvidedForFree: '免費提供一次性洗漱用品',
    disposableToiletriesAreProvidedForAFee: '收費提供一次性洗漱用品',
    indoor: '室內',
    commonality: '公共',
    aroom: '一間',
    twoRooms: '兩間',
    moreThanTwoRooms: '兩間以上',
    allRoomsChargeComputers: '全部房间收费电脑',
    freeComputersInAllRooms: '全部房間免費電腦',
    freeComputersInSomeRooms: '部分房間免費電腦',
    nonSmokingRoomsAreNotAvailable: '不可提供無菸房',
    nonSmokingRoomsAvailable: '可提供無菸房',
    noSmoking: '不可吸煙',
    partialWindow: '部分窗',
    skylight: '天窗',
    closedWindow: '封閉窗',
    bayWindow: '飄窗',
    roomTypeNameAndBedSizeAreUnderReview: '房型名稱、床型尺寸進入審核中',
    roomTypeAddedSuccessfully: '房型添加成功',
    containsAMaximumOf7CharactersOnlyDigitsCanBeEntered: '長度不超過7個字符,只允許輸入數字.-',
    pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters: '請輸入整數，並保證合法性：如3平方米-5平方米',
    personbed: '人/間',
  },
  managementAccountList: {
    searchAccountAndEmployeeName: '賬號、員工姓名',
    staffPosition: '员工岗位',
    createAnAccount: '新建賬號',
    employeeName: '員工姓名',
    employeeRole: '員工角色',
    confirmTo: '確認要',
    user: '用戶',
    areYouSureYouWantToDeleteThisUser: '確認要刪除該用戶嗎',
    isThisMaterial: '該物品嗎',
  },
  managementRoleList: {
    enterARoleName: '輸入角色名稱',
    newRole: '新增',
    roleName: '角色名稱',
    roleDescription: '角色描述',
    editorRole: '編輯角色',
    modifyPermission: '修改權限',
    deletingARole: '刪除角色',
    areYouSureYouWantToDeleteThisRole: '確認要刪除該角色嗎',
  },
  componentsCreateaneditingrole: {
    roleName: '角色名稱',
    roleDescription: '角色描述',
    standardPostBased: '基於標準崗位',
    limitsOfAuthority: '權限',
    pleaseEnterARoleName: '請輸入角色名稱',
    modifyRole: '修改角色',
    newRole: '新增',
    succeededInModifyingTheRole: '修改角色成功',
    creatingTheRoleSucceeded: '創建角色成功',
  },
  componentsPopupeditingpermission: {
    modifiedSuccessfully2: '修改成功',
    editPermission: '編輯權限',
  },
  componentsUpdatematerial: {
    staffPosition: '员工岗位',
    employeeRole: '員工角色',
    thePhoneNumberCannotBeEmpty: '手機號不能為空',
    pleaseEnterYourConfirmationPassword: '請輸入確認密碼',
    pleaseEnterEmployeeName: '請輸入員工姓名',
    pleaseSelectEmployeeStatus: '請選擇員工狀態',
    pleaseSelectAnEmployeePosition: '請選擇員工崗位',
    modifyAccount: '修改賬號',
    viewInformation: '查看信息',
    addAnAccount: '新增賬號',
    theTwoPasswordEntriesAreDifferent: '兩次密碼輸入不相同',
    modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation: '修改物品信息會影響已入庫的商品信息，請謹慎操作',
    materialUnit: '規格單位',
    pleaseSelectTheMaterialType: '請選擇物品類型',
    pleaseFillInTheMaterialName: '請填寫物品名稱',
    pleaseSelectMaterialUnit: '請選擇物品規格',
    modifyMaterial: '修改物品',
    newMaterial2: '新增物品',
    materialModificationSucceeded: '修改物品成功',
    newMaterialSuccessfully: '新建物品成功',
    pleaseEnterTheCorrectPhoneNumber3: '請輸入正確賬號',
  },
  smallwareMaterial: {
    newMaterial: '新增',
    thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse: '當前物品下有庫存，不支持刪除物品，請出庫後再刪除',
    areYouSureYouWantToDeleteThisMaterial: '確認要刪除該物品嗎',
    confirmTo: '確認要',
    isThisMaterial: '該物品嗎',
  },
  smallwareRealtimestock: {
    saleStatus: '售卖状态',
    exportedInventory: '導出庫存',
    resumptionOfSale: '恢復售賣',
    banOnSale: '禁售',
    averagePurchasePriceyuan: '進貨均價(元)',
    sellingPriceyuan: '售賣單價(元)',
    unmarketable: '不可銷售',
    vendibility: '可销售',
    areYouSureYouWantToStopSellingThisMaterial: '確認要停售該物品嗎',
    successfulClosure: '停售成功',
    successfulResumptionOfSale: '恢復售賣成功',
    exportFileName: '實時庫存列表',
  },
  smallwareStockshift: {
    undoSuccessfully: '撤銷成功',
    outboundTime: '出庫時間',
    newDelivery2: '新增出庫',
    outboundMode: '出庫方式',
    theNumberOfTheWarehouseReceipt: '出庫單編碼',
    deliveryFromStorage: '出庫',
    cancel: '撤銷',
    exportFileList: '出庫文件導出列表',
    doYouConfirmTheCancellation: '確認撤銷嗎',
  },
  smallwareStockunshift: {
    warehousingTime: '入庫時間',
    newStorage: '新增入庫',
    theCodeOfTheEntrySlip: '入庫單編碼',
    purchasePriceyuan: '進貨單價(元)',
    importFileExportList: '入庫文件導出列表',
  },
  componentsAddnewstock: {
    adjustableQuantity: '可沖調數量',
    purchasePrice: '進貨單價',
    whetherToSell: '是否售賣',
    unitSellingPrice: '售賣單價',
    pleaseFillInTheUnitPrice: '請填寫售賣單價',
    pleaseFillInTheQuantityOfStorage: '請填寫入庫數量',
    pleaseSelectTheMaterialType: '請選擇物品類型',
    pleaseSelectAMaterialName: '請選擇物品名稱',
    modifiedEntry: '修改入庫',
    newStorage: '新增入庫',
    modifiedSuccessfully2: '修改成功',
    createdSuccessfully2: '創建成功',
    theStorageQuantityCannotBe: '入庫數量不能為',
    theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity: '修改后的数量不能小于已产生的消耗数量',
  },
  componentsAddoutstock: {
    selected: '已選擇',
    newDelivery2: '新增出庫',
    pleaseSelectOutgoingMaterials: '請選擇出庫物品',
    pleaseSelectTheMaterialToBeShippedOut: '請選擇要出庫的物品',
    successfulDelivery: '出庫成功',
  },
  componentsSellricedialog: {
    modifiedSuccessfully2: '修改成功',
    unitSellingPrice: '售賣單價',
    pleaseFillInThePrice: '請填寫價格',
  },
  systemsetBase: {
    requireIdNumberEnabled: '必須輸入證件號功能已成功開啟',
    requireIdNumberDisabled: '必須輸入證件號功能已成功關閉',
    requireIdNumberForCheckin: '辦理入住是否需要輸入證件號',
    enableAutomaticDepositRefund: '開啟自動退押金',
    refundImmediatelyAfterCheckOut: '客人操作退房後立即退',
    refundAfter: '客人退房後',
    hoursAutoRefund: '小時自動退',
    pleaseEnterDelayRefundHours: '請輸入延遲退押金時間',
    delayRefundHoursRangeError: '延遲退押金時間不能小於1小時，不能大於48小時',
    depositConfigSuccess: '入住押金配置成功',
    tempMakeCardEnabled: '臨時製卡是否開啟',
    tempMakeCardEnabledSuccess: '已開啟臨時製卡',
    tempMakeCardDisabledSuccess: '已關閉臨時製卡',
    hideCheckInRegisterRoomPrice: '入住登記單隱藏房價',
    hideCheckInRegisterRoomPriceEnabledSuccess: '已開啟入住登記單隱藏房價',
    hideCheckInRegisterRoomPriceDisabledSuccess: '已關閉入住登記單隱藏房價',
    weeHours: '凌晨',
    shiftPattern: '交班模式',
    messageVoiceReminder: '消息語音提醒',
    directConnectionSingleSettings: '直連接單設置',
    automaticHouseSetting: '自動排房設置',
    sameDayAdvanceOrders: '當日預抵訂單',
    allOrders: '所有訂單',
    unreservedRoomOrderAutomaticRoomSchedulingPeriod: '未排房訂單自動排房時間段',
    inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted: '該時間段內會自動將未排房訂單執行自動排房',
    inventorySyncSetup: '庫存同步設置',
    orderSynchronizationSettings: '訂單同步設置',
    nightAuditSetup: '夜審設置',
    nightTrialMethod: '夜審方式',
    manualOperation: '手動',
    auto: '自動',
    storeOrdersHaveNotArrived: '門店訂單預抵未到',
    preArrivalDepartureHandle: '預抵預離訂單處理',
    preArrivalDepartureHandleTip: '設定預抵訂單和預離訂單的自動處理方式，夜審時系統將根據配置自動執行相應操作',
    preArrivalHandle: '預抵訂單處理',
    preDepartureHandle: '預離訂單處理',
    noHandle: '不處理',
    autoCheckIn: '自動辦理入住',
    autoNoshow: '自動noshow',
    autoCheckOut: '自動退房',
    autoExtendStay: '自動續住',
    autoSkip: '自動跳過',
    shiftSetting: '班次設置',
    noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay: '班次時間不允許有重疊，總時間區間必須覆蓋全天24小時',
    morningShiftSetting: '凌晨班次設置',
    shiftReportimprestMode: '交班報表（備用金模式)',
    hourRoomCheckOutMessage: '鐘點房退房消息',
    fullDayCheckOutMessage: '全日房退房消息',
    onlineChannelNewOrderAlerts: '線上渠道新訂單提醒',
    onlineChannelOrderCancellationAlerts: '線上渠道訂單取消提醒',
    hourCheckOutReminder: '鐘點房退房提醒',
    fullDayCheckOutReminder: '全日房退房提醒',
    automaticOrderSettingWhenOversold: '超售時自動接單設置',
    hourRoomAutomaticOrderSetting: '鐘點房自動接單設置',
    automaticRowHouseConfiguration: '自動排房房態',
    automaticHouseRules: '自動排房規則',
    supportBillingTypes: '支持開票類型',
    '30MinutesBeforeCheckOut': '退房前30分鐘',
    '15MinutesBeforeCheckOut': '退房前15分鐘',
    atCheckOut: '退房時',
    pleaseEnterTheTime: '請輸入時間',
    automaticCancellation: '自動取消',
    manualCancellation3: '手動取消',
    automaticOverbookingSetReminders: '超售自動接單設置提醒',
    hourRoomAutomaticOrderSettingReminder: '鐘點房自動接單設置提醒',
    autoEnterArAccountText: '直連訂單自動入AR帳',
    pleaseSelectABusinessDay: '請選擇營業日',
    operationSuccessfulPleaseManuallyTriggerTheNightAudit: '操作成功，請手動觸發夜審',
    theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame: '凌晨班開始結束時間不能相同',
    earlyMorningWatch: '凌晨班',
    modifiedSuccessfully2: '修改成功',
    theAutomaticRowHouseIsSetSuccessfully: '自動排房設置成功',
    theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull: '滿房後自動關閉eb房態',
    supportSwitchOrderSynchronization: '支持switch訂單同步',
    inventoryAutomaticSynchronizationSystemInventory: '庫存自動同步系統庫存',
    whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation: '預離訂單續住優先級高於預抵訂單入住，如果系統自動辦理入住沒有空房則自動NoShow，如果系統自動續住沒有空房則自動退房',
    whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing: '預離訂單續住優先級高於預抵訂單入住，如果系統自動辦理入住沒有空房則自動NoShow，如果系統自動續住沒有空房則自動退房',
    whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff: '滿房後自動關閉eb房態開關設置保存',
    inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved: '库存自动同步系统库存开关设置保存',
    atLeastOneMessageReminderSettingMustBeSelected: '消息提醒設置至少選擇一項',
    closeturnOnToAutomaticallySortRoomsAtNight: '關閉 (開啟後新訂單全天自動排房)',
    crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations: '跨營業日班次，可單獨設置凌晨班，方便班次賬務統計。凌晨班不參與正常班次時間計算',
    dailyPredeparture: '當日預離',
    theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving: '酒店支持同步switch訂單渠道設置保存',
    theNightAuditTimeMustBeBetween2100And0800TheNextDay: '夜審時間必須為21:00到次日08:00之間',
    theScheduleNeedsToCover24HoursADayPleaseReset: '班次時間需覆蓋全天24小時，請重新設置',
    showMemberRechargeAmount: '交班報表是否展示會員充值金額',
    splitDeposit: '交接班報表是否拆分押金',
    splitArAccount: '交接班報表是否拆分AR賬',
    allowTimeConflict: '排房允許時間衝突',
    selfCheckInDepositSetting: '自助入住押金設定',
    depositConfig: '收押金設定',
    defaultDepositAmount: '預設押金金額',
    defaultDepositError: '入住押金預設值輸入錯誤，請重新輸入',
    roomDepositError: '房型「{roomName}」設定錯誤，請重新設定',
    additionalRoomFeeSetting: '加收房費設定',
    fulldayAddFeeRule: '全日房加收房費規則',
    fulldayAddFeeType: '全日房加收房費類型',
    memberRechargeSetting: '會員儲值收款設定',
    noVerificationPayment: '免驗證碼支付',
    enforceAdditionalRoomCharge: '後強制加收房費',
    manualAdditionalRoomFee: '手工加收房費',
    halfDayAdditionalRoomFee: '加收半日房費',
    fullDayAdditionalRoomFee: '加收全日房費',
    popUpMethodSetting: '互動方式設定',
    newTab: '新分頁',
    originalTabRedirection: '原分頁跳轉',
    popupNotification: '彈窗',
    sidebar: '右側抽屜',
    breakfastReportCtrl: '早餐報表統計規則',
    repotShowByUserNums: '按實際入住人數統計',
    repotShowByProductNums: '按房間包含早餐數統計',
    breakfastReportCtrlSuccessByUserNums: '早餐報表統計規則已設置為「按實際入住人數統計」',
    breakfastReportCtrlSuccessByProductNums: '早餐報表統計規則已設置為「按房間包含早餐數統計」'
  },
  systemsetConditionConfig: {
    unspaced: '不分行排列',
    arrangeByFloorBranch: '按樓層分行排列',
    lineUpByRoomType: '按房型分行排列',
    theSizeOfTheCell: '房態格大小',
    small: '小',
    inThe: '中',
    big: '大',
    wide: '寬',
    high: '高',
    custom: '自定義',
    roomTypeFont: '房型字體',
    size: '大小',
    colour: '顏色',
    roomNumberFont: '房號字體',
    whetherFullGuestNamesAreDisplayed: '是否顯示完整客人姓名',
    alreadyRowHouseStatusDisplayContent: '已排房房態顯示內容',
    alreadyRowHouseStatusDetailsDisplayContent: '已排房房態詳情顯示內容',
    noRowRoomStatusDetailsDisplayContent: '未排房房態詳情顯示內容',
    arrearsIncludeToday: '欠費是否計算當日待生成房費',
    bedType2: '床型',
    restoreDefault: '恢復默認',
    submitSuccessfully4: '提交成功',
    roomDiagramArrangement: '房態圖排列方式',
    theAppletTakesEffectAtTheSameTime: '小程序同時生效',
    cellColor: '房態格顏色',
    unarrangedRoomStatusContent: '未排房房態顯示內容',
    powerSwitch: '取電器',
    roomBalance: '房間餘額',
    depositAmount: '押金金額',
  },
  systemsetConfiguration: {
    changePriceRangeSettings: '改價範圍設置',
    revaluationRange: '改價範圍',
    modifiedSuccessfully2: '修改成功',
    theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed: '系統會根據每個房型近30天的平均價判斷是否超過改價範圍，超過改價範圍後將會進入改價審核，審核後價格才會生效。1小時內未處理改價申請系統自動駁回改價',
  },
  systemsetLog: {
    operationRecord: '操作記錄',
  },
  systemsetPrint: {
    documentType: '單據類型',
    paperSize: '紙張規格',
    typeSize: '字號',
    printingMode: '打印方式',
    noticeToGuests: '宾客须知',
  },
  systemsetTarget: {
    monthlyGoalSetting: '月目標設定',
    goal: '目標',
    goalAchievementRate: '目標達成率',
    intertargetNight: '目標間夜',
    targetOccupancyRate: '目標出租率',
    recommendedTargetValue: '建議目標值',
    actualAchievement: '實際達成',
    reachedLastMonth: '上月達成',
    theSamePeriodLastYear: '去年同期',
    save4: '保存',
    commitFailure: '提交失敗',
    submitSuccessfully4: '提交成功',
  },
  systemsetWarning: {
    earningsWarning: '收益達成預警',
    dailyWarning: '日常預警',
  },
  systemsetWifi: {
    commonality: '公共',
    batchModification: '批量修改',
    pleaseCompleteTheWiFiAccountPassword: '請填寫完整Wi-Fi賬號密碼',
    pleaseEnterAValidWifiName: '請輸入有效的WiFi名稱',
    noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn: '無密碼或手機驗證的WiFi無需填寫',
    pleaseFillInTheWiFiAccount: '請填寫Wi-Fi賬號',
    roomWifiSettings: '房間WiFi設置',
    wifiName: 'WiFi名稱',
    wifiPassword: 'WiFi密碼',
  },
  assemblyBindavailableproducts: {
    bindAvailableProducts: '綁定可用產品',
    bindAtLeastOneProduct: '至少綁定一個產品',
  },
  componentsWarning: {
    byTheMonth: '每月',
    achievedOnDays: '日 达成',
    below: '以下',
    viewRemainingConditions: '查看剩余条件',
    newEarlyWarningItems: '新增预警项目',
    achieved: '达成',
    additionalCondition: '增加条件',
    internightMoonTargetReachWarning: '间夜月目标达成预警',
    earlyWarningOfMonthlyTargetOfRentalRate: '出租率月目标达成预警',
    surplusRoom: '剩余房量',
    pointScoring: '点评分',
    gmvMonthlyTargetWarning: 'GMV月目标达成率预警',
    revparMonthlyTargetWarning: 'RevPAR月目标达成率预警',
  },
  componentsWarningday: {
    overallHotel: '酒店整體',
  },
  foodLogin: {
    cashierSystem: '餐飲收銀系統',
    shopSystem: '餐飲商戶系統',
    pleaseEnterYourAccount: '請輸入賬號',
    noFoodSystemPermission: '您沒有{system}權限',
    systemConfigurationError: '系統配置錯誤，請聯繫技術支持',
    loginFailed: '登錄失敗，請稍後再試',
  },
  loginIndex: {
    hotelManagementSystem: '酒店管理系統',
    qrCodeExpired: '二維碼過期',
    pleaseClickRefresh: '請點擊刷新',
    openWechatScanTheQrCode: '打開微信，掃描二維碼',
    customerServiceNumber: '客服電話',
    theAccountOrPasswordYouEnteredIsIncorrect: '您輸入的賬號或密碼不正確',
    forgotPassword: '忘記密碼',
    verificationCodeSentToYourMobilePhoneValidFor5Minutes: '驗證碼已發送至您的手機，5分鐘內有效',
    enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes: '輸入8-20位，字母、數字和符號兩種以上的組合',
    submit2: '提 交',
    loginPasswordUpdateSuccessful: '登錄密碼更新成功',
    reLogin: '重新登陸',
    bind: '綁定',
    findPassword: '找回密碼',
    pleaseEnterTheVerificationCode: '請輸入驗證碼',
    mobilePhoneSmsVerificationCode: '手機短信驗證碼',
    pleaseEnterTheMobilePhoneVerificationCode: '請輸入手機驗證碼',
    pleaseVerifyTheNewPassword: '請驗證新密碼',
    bindWechat: '綁定微信',
    pleaseEnterTheLoginPassword: '請輸入登錄密碼',
    theTwoPasswordsEnteredAreInconsistent: '兩次輸入密碼不一致',
    pleaseEnterTheVerificationCode3: '請輸入圖形驗證碼',
    loggingIn: '正在登錄',
    acquire: '獲取',
    resendVerificationCode: '重新發送驗證碼',
    loginNow: '立即登錄',
    currentPhoneNumber: '當前手機號',
    changeSuccessful: '更改成功',
    afterReGetting: '後重新獲取',
    pleaseEnterCorrectAccount: '請輸入正確的帳號',
  },
  viewsHomePageIndex: {
    commonFunctions: '常用功能',
    roomStatusOverview: '房態總覽',
    todayData: '今日數據',
    thisMonthData: '本月數據',
    dataAsOf: '數據截止：',
    todoList: '待辦事項',
    allRead: '全部已讀',
    noTodos: '您已經處理完了所有的待辦事項',
    efficientDay: '真是高效的一天！',
    logUpdates: '日誌更新',
    selectedFunctionsTitle: '已選擇功能',
    selectedFunctionsTip: '點擊拖動調整排序，至少選擇1個功能',
    maxSix: '最多選擇6個功能',
    allReadSuccess: '全部已讀成功',
  },
  viewsReportFinanceOnlinePaymentReconciliation: {
    tradeDate: '交易日期',
    billType: '賬單類型',
    platform: '支付平台',
    qzTradeNo: '支付流水號',
    qzTradeNoPlaceholder: '請輸入支付流水號',
    amountTotal: '金額合計',
    feeTotal: '費用合計',
    reportName: '線上對賬報表',
    pleaseSelectAtLeastOneDateType: '請選擇至少一種查詢日期',
    income: '收款',
    alipay: '支付寶',
    wechat: '微信',
    merchantCode: '商家編號',
    merchantName: '商戶名稱',
    qzTradeNoColumn: '支付流水號',
    externalOrderNo: '外部訂單號',
    orderAmount: '訂單金額',
    merchantRate: '商家費率',
    commission: '手續費',
    billTypeColumn: '賬單類型',
    finishTime: '完成時間',
    oriQzTradeNo: '原收款訂單號',
    platformColumn: '支付平台',
  },
  appShop: {
    label1: '🔥「收款佣金立省25%成本」',
    label2: '💰「商家必看！月省千元佣金秘笈」',
    label3: '⚠「還在為高額提現手續費頭疼？」',
    label4: '⏳「前100名開通領掃碼盒子」',
    label5: '❓「為什麼大品牌都用這個收款？」',
    label6: '🛡「銀行級安全認證｜萬家商戶的選擇」',
    label7: '📞「立即申請｜費率立降25%」',
    label8: '💼「酒店老闆親述：靠它多賺3千元/月」',
  },
  settleDialog: {
    entryRoom: '入賬房間',
    selectEntryRoom: '請選擇入賬房間',
    confirmTotalRoomRate: '確認總房費',
    preAuthorizationSettlement: '預授權結算',
    completeCheckout: '完成結帳',
    additionalChargeAmount: '加收金額',
    inputAdditionalAmount: '請輸入加收金額',
    detail: '明細',
    noAdditionalCharge: '不加收',
    generateRoomFee: '生成房費',
    hangToMaster: '掛帳到主單',
    hangAccountReason: '掛帳原因',
    hangAccountTip: '提示：選擇掛帳到主單後，系統將未結帳帳務轉至主單並退房',
    selectAtLeastOneRoom: '請選擇至少一個房單',
    transferBeforeHangAccount: '請將「待入住」的房間轉出後再進行掛賬操作',
    pleaseAddRoomFee: '請先加收房費',
    noRoomOrderFound: '未取得需結帳的房單號，請重新整理頁面後再試',
    hourlyRoomTip: '鐘點房：請確認實際應收取的房費',
    fullDayRoomTip: '全日房：請輸入需額外加收的房費',
    hangAccount: '掛帳',
    roomNumbername: '房號/姓名',
  },
  notUploadList: {
    searchPlaceholder: '輸入姓名、房號',
    uploadStatus: '上傳狀態',
    notUploaded: '未上傳',
    uploaded: '已上傳',
    loggedOut: '已退出',
    downloadAllGuestInfo: '下載全部客人資訊',
    idAddress: '證件地址',
    uploadStatusColumn: '是否上傳公安',
    downloadInfo: '下載資訊',
    finishUpload: '完成上傳',
  },
  notification: {
    markAllRead: '一鍵已讀',
    expand: '展開 ({count})',
    collapse: '收起 ({count})',
    ignore: '忽略',
  },
  adjustFinance: {
    title: '調整財務',
    adjustAccount: '調帳',
    balanceZeroWarning: '請確保餘額為0後再提交',
    addOneRecordWarning: '請至少新增一條入帳記錄',
  },
  accountIndex: {
    scope: '應用範圍',
    confirmDelete: '是否確定刪除此帳套？',
    onlyDeleteDisabled: '只能刪除禁用狀態的帳套',
    cancelDelete: '已取消刪除',
  },
  roomStatusStatistics: {
    details: '詳細資訊',
  },
  hotelStateDialog: {
    title: '房態統計',
    checkIn: '在住',
    prepareCheckIn: '預抵',
    sold: '已售',
    available: '可售',
    fetchError: '獲取房型資料失敗',
  },
  futureRoomIndex: {
    quickSearch: '快速查詢',
    reEnable: '解除停用',
    confirmChangeRoomTitle: '是否將原房間換至新房間？',
    originalRoom: '原房間',
    newRoom: '新房間',
    dragTargetInvalid: '拖拽失敗：未找到目標格子',
    selectSameRoomTypeSameStayDate: '請選擇同房型入離日期相同的房間',
    differentRoomTypeSwapNotSupported: '不同房型暫不支持與已有房單交換',
    AVL: '餘',
  },
  financePaymentIndex: {
    addPaymentSubject: '新增',
    paymentSubjectName: '付款科目名稱',
    symbol: '符號',
    confirmDelete: '確認要刪除此科目嗎？',
  },
  financeAccountDialog: {
    pleaseEnterSubject: '請輸入{type}科目',
    pleaseSelectCategoryType: '請選擇{type}類目類型',
    addTitle: '添加{type}科目',
    editTitle: '修改{type}科目',
    subjectName: '{type}科目',
    subjectCategory: '{type}科目類別',
    isEnabled: '是否啟用',
  },
  financeConsumerAccount: {
    subjectCategory: '消費科目類別',
    addSubject: '新增',
    subjectName: '消費科目名稱',
    symbol: '符號',
    confirmDelete: '確認要刪除此科目嗎？',
  },
  financeSubjectSorting: {
    consumeSortTitle: '消費科目排序',
    paySortTitle: '付款科目排序',
    consumeSubjectName: '消費科目名稱',
    paySubjectName: '付款科目名稱',
    sortSuccess: '排序成功',
  },
  aiPms: {
    common: {
      noData: '暂无数据',
      aiDriven: 'AI 驱动',
      justNow: '刚刚',
      minutesAgo: '{count}分钟前',
      hoursAgo: '{count}小时前',
    },
    aiConfig: { pageTitle: 'AI Configuration', save: 'Save', hotelSection: 'Hotel Configuration', roomTypeSection: 'Room Type Configuration', priceGuard: 'Price Guardrail', enabled: 'Enabled', disabled: 'Disabled', hotelFloorPrice: 'Hotel Floor Price', hotelCeilingPrice: 'Hotel Ceiling Price', floorPrice: 'Floor Price (CNY)', ceilingPrice: 'Ceiling Price (CNY)', floorPricePlaceholder: 'Enter floor price', ceilingPricePlaceholder: 'Enter ceiling price', yuan: 'CNY', roomTypeName: 'Room Type Name', roomTypeCode: 'Room Type Code', amountNonNegative: ' amount must be greater than or equal to 0', floorGreaterThanCeiling: ' floor price cannot exceed ceiling price', hotelLabel: 'Hotel', roomTypeLabel: 'Room type “{name}”', noChanges: 'No configuration changes detected', saveSuccess: 'Saved successfully', pricingSelloutTimeTitle: '定價目標售罄時間策略', pricingSelloutTimeTip: '用於當天實時提價、慢銷降價和同行引流的時間緊迫度', custom: '自訂策略', legalHoliday: '法定節假日', weekend: '週五、週六', defaultDate: '其他日期（含週日）', selectTime: '請選擇時間', pricingSelloutTimeInvalid: '後端返回的策略資料異常，請明確處理售罄時間策略後再儲存。', pricingSelloutTimeRequired: '定價目標售罄時間策略的三項時間必須為HH:mm格式，且時間必須為14:00至23:59或00:00至06:00' },
    roomPricingReport: { reportTitle: 'Room Type Pricing Report', reportTip: 'AI recommendations, operating basis, and pricing factors', hotelInfo: 'Hotel Information', sellDate: 'Sale Date', metricDate: 'Metric Business Date', hotelOcc: 'Current Hotel OCC', hotelRevpar: 'Current Hotel RevPAR', currentPrice: 'Current Price', aiRecommendedPrice: 'AI Recommended Price', aiCurrentDelta: 'AI vs. Current Price', sameDayOcc: 'Same-day OCC', sameDayRevpar: 'Same-day RevPAR', confidence: 'AI Confidence', inventorySnapshot: '已售 / 可售(超售) / 停用', operatingBasis: 'Room Type Operating Basis', aiDecision: 'AI Decision', tradeoff: 'Multi-factor Trade-off: ', aiFactors: 'AI Pricing Factors', historicalPrice: 'Historical Price', operation: 'Operating Data', market: 'Market Position', timeEvent: 'Time and Events', guardrailRisk: 'Guardrails and Risks', status: 'Status: ', priceImpact: 'Price Impact: ', conclusion: 'Conclusion: ', reason: 'Reason: ', evidence: 'Evidence: ', riskReminder: 'Risk Reminders', noRisk: 'No additional risk reminders', severity: 'Severity: ', suggestion: 'Suggested Action: ', used: 'Used', notUsed: 'Not Used', notAvailable: 'No Data Available', up: 'Supports Increase', hold: 'Hold', down: 'Supports Decrease', limit: 'Guardrail Limit', none: 'No Direct Impact', yes: 'Yes', no: 'No', yuan: 'CNY', priceAdjustment: '產品改價', priceAdjustmentDialogTitle: '智能定價一鍵改價', noAdjustableProducts: '目前房型暫無可改產品', roomTypeName: '房型名稱：', roomTypeCode: '房型編碼：', roomTypeCurrentPrice: '房型當前價', algorithmRecommendedPrice: '演算法建議價', aiAdjustmentDelta: 'AI 漲跌', currencySymbol: '¥', snapshotPriceNote: 'AI 建議基於本次智能定價通知的價格快照', product: '產品：', channel: '渠道', channelId: '渠道 ID：{id}', channelCurrentPrice: '渠道當前售價', aiAdjustedPrice: 'AI 調整後售價', operationLabel: '操作', oneClickAdjustment: '一鍵改價', confirmGroupAdjustment: '確認對該產品下 {count} 個渠道執行改價？', confirmChannelAdjustment: '確認對該渠道產品執行改價？', confirmAdjustmentTitle: '確認改價', confirm: '確定', cancel: '取消', adjustmentSuccess: '改價成功', bookingHourPreference: '近7日分時段預訂偏好', bookingHourNoData: '暫無分時段預訂資料', bookingHourDateRange: '{start} 至 {end}', bookingHourTooltip: '{hour}:00<br/>訂單佔比：{value}%' },
    roomPricingFeedback: { button: '採納', dialogTitle: '提交回饋', accept: '採納', reject: '不採納', rejectReasonPlaceholder: '請填寫不採納原因', actionRequired: '請選擇回饋結果', rejectReasonRequired: '請填寫不採納原因', rejectReasonTooLong: '不採納原因不能超過100字', acceptSuccess: '採納成功', rejectSuccess: '已提交不採納回饋' },
    roomPricing: {
      empty: '暂无可展示的定价结果',
      roomTypeFallback: '房型{index}',
      decisionTitle: '决策说明',
      riskLabel: '风险提示：',
      modeLabel: '模式：',
      floorPriceLabel: '价格护栏：',
      confidenceLabel: '可信度：',
      directionFlat: '平价建议',
      directionUp: '涨价建议',
      directionDown: '降价建议',
      priorityLow: '低优先级',
      priorityMedium: '中优先级',
      priorityHigh: '高优先级',
    },
    roomPricingCard: { pricingTime: '定價時間：', expand: '展開', collapse: '收起' },
    noticeCenter: {
      unreadCount: '未读 {count} 条',
      readAll: '全部已读',
      defaultTitle: 'AI 通知',
      browserNotificationTitle: 'AI 通知提醒',
      browserNotificationBody: '您收到一條新的 AI 通知',
      browserPermissionGuide: '開啟後，新的 AI 通知會在瀏覽器背景顯示提醒。',
      enableBrowserNotification: '開啟瀏覽器通知',
      skipBrowserNotification: '暫不開啟',
      statusRead: '已读',
      statusUnread: '未读',
      emptySummary: '暂无通知摘要',
      like: '赞',
      dislike: '踩',
      viewDetail: '查看详情',
      markRead: '點我已讀',
      emptyList: '暂无通知',
      dislikeDialogTitle: '提交点踩原因',
      dislikePlaceholder: '请留下您的建议',
      categoryAll: '全部',
      readAllSuccess: '全部已读成功',
      markReadSuccess: '已讀成功',
      likeSuccess: '点赞成功',
      dislikeReasonRequired: '请填写点踩原因',
      dislikeSuccess: '提交成功',
      uncategorized: '未分类',
    },
    noticeDetail: {
      back: '返回消息通知',
      sendTime: '生成时间：',
      businessType: '一级分类：',
      businessSubType: '二级分类：',
      sideLabel: '消息详情',
      contentTitle: '通知正文',
      contentTip: '按 markdown 风格展示通知原文',
      badReviewTitle: '差评明细',
      badReviewTip: '展示差评正文与 AI 建议回复',
      badReviewContent: '差评正文',
      badReviewReply: '建议回复',
      structuredTitle: '结构化结果',
      structuredTip: '按 AI 报告内容分块展示结构化数据和分析文本',
      structuredEmptyTip: '当前内容暂未解析出可展示数据',
      missingNoticeNo: '缺少 noticeNo',
    },
    smartPricing: {
      pageTitle: '智能定价',
      empty: '暂无最新智能定价通知',
      peerHotelMonitor: {
        title: '競對引流價格監控',
        refresh: '刷新',
        meituan: '美團',
        empty: '暫無競對引流價資料',
        unnamedHotel: '未命名競對酒店',
        crawlSubmitted: '請稍後刷新頁面查看',
      },
    },
    futurePricing: { realtimeTab: '實時定價報告', futureTab: '遠期定價報告', reportTitle: '房型遠期定價報告', reportTip: '展示未來 14 天的凍結定價建議與分析', empty: '暫無房型遠期定價報告', hotelOverview: '酒店遠期定價概覽', priceSource: '價格來源', pricingBusinessDate: '定價營業日', forecastDateRange: '預測日期範圍', to: '至', confidence: '14 天綜合置信度', dailyEmpty: '暫無每日定價結果', analysis: '分析', aiDecision: 'AI 決策', decisionSummary: '決策摘要', pricingFactors: '定價因子', noFactor: '暫無因子說明', status: '狀態', priceImpact: '價格影響', reason: '原因', conclusion: '結論', tradeoff: '權衡說明', riskReminder: '風險提示', noRisk: '暫無風險提示', severity: '嚴重程度', suggestion: '建議', sellDate: '售賣日', algorithmReferencePrice: '演算法參考價', aiRecommendedPrice: 'AI 建議價', historicalExpectedOcc: '歷史預期 OCC', historicalExpectedRevpar: '歷史預期 RevPAR', holidayEvent: '節假日 / 活動', systemRisk: '系統風險', yes: '是', no: '否', legalHoliday: '法定節假日', weekendPeak: '週末高峰', normalDate: '普通日期', reportGeneratedAt: '報告生成時間', listEmpty: '暫無已完成的遠期定價報告', selectDate: '選擇日期', dailyAverageOrders: '近 7 日平均每日訂單', viewAllReports: '查看全部報告', backToAllReports: '返回報告列表', realtimeListEmpty: '暫無已完成的房型定價報告' },
    futurePricingCalendar: { calendarTitle: '房型遠期定價日曆', roomType: '房型', expectedOcc: '預期 OCC', expectedRevpar: '預期 RevPAR', pricingBasis: '定價依據', dataIntegrityRisk: '資料完整性提醒 / 風險提示', highRisk: '高風險', calendarEmpty: '暫無遠期定價日曆資料', priceUp: '上調', priceDown: '下調', priceHold: '持平', overallPricingBasis: '整體定價依據', roomOverallRisk: '房型整體風險提示', dailyRiskReminder: '每日風險提示' },
    storeManagerReport: {
      pageTitle: '店长报告',
      pageDesc: '按日报、周报、月报查看最新综合报告结果。',
      dailyButton: '日报',
      weeklyButton: '周报',
      monthlyButton: '月报',
      datePlaceholder: '请选择时间',
      empty: '当前时段暂无最新店长报告',
      contentTitle: '报告正文',
      contentTip: '按最新综合报告原文展示',
      analysisTitle: '结构化分析',
      analysisTip: '按结构化节点展示综合分析内容',
      monthLabel: '{year}年{month}月',
      weekLabel: '{start} 至 {end}',
      dailyTitle: '店长日报',
      weeklyTitle: '店长周报',
      monthlyTitle: '店长月报',
      periodLabel: '查询时段：{range}',
    },
    storeDiagnosis: {
      pageTitle: '門店診斷',
      pageDesc: '每日一份門店診斷報告，基於靜態信息與近 31 天評論自動生成。每天限生成 1 次，頁面展示最近一次結果。',
      refresh: '刷新',
      generate: '生成診斷報告',
      hotelInfoIncomplete: '當前酒店信息不完整，請確認已登入並選擇酒店',
      emptyTitle: '尚未生成診斷報告',
      emptyDesc: '酒店檔案、房型、圖片等數據齊全後，自動發起 AI 診斷。生成後不可重複操作。',
      emptyMeta: '酒店編碼 {hotelCode}　批次 {batchNo}',
      taskInfo: '任務信息',
      batch: '批次',
      todayTask: '今日任務',
      preparingData: '數據準備中',
      generating: '診斷生成中',
      failedNoRetry: '已失敗，不可再生成',
      generated: '已生成',
      notGenerated: '未生成，可手動生成',
      noReport: '暫無報告',
      latestDone: '最近一次已完成',
      latestFailed: '最近一次失敗',
      done: '已完成',
      failed: '生成失敗',
      statusWait: '1 / 待校驗',
      statusDiagnosing: '2 / 診斷中',
      statusDone: '3 / 完成',
      statusFailed: '4 / 失敗',
      metaStatus: '狀態',
      failSummary: '失敗摘要',
      currentStage: '當前階段',
      crawlRetry: '數據整合重試',
      diagnoseDone: '診斷完成',
      diagnosingStage: '診斷生成中',
      generateFailedShort: '生成失敗',
      failTitle: '診斷未完成',
      failMessageToday: '診斷數據整合或 AI 生成失敗，當日不可再次生成。',
      failMessageLatest: '最近一次診斷失敗。今日尚未生成，可手動生成今日報告。',
      failHintToday: '當日不可再次生成。可次日重試，或聯繫運營排查。',
      failHintLatest: '以上為最近一次失敗記錄。今日尚未生成，需手動點擊「生成診斷報告」。',
      stepCrawl: '① 觸發數據整合',
      stepSuccess: '② 數據整合成功',
      stepSync: '③ 同步數據',
      stepAdp: '④ 發起診斷',
      progressDiagnosing: '數據整合與同步已完成，正在生成診斷報告。',
      progressWait: '正在拉取美團/攜程檔案、房型、圖片，數據齊後自動診斷。',
      reportPending: '報告尚未產出，數據齊後將自動診斷，可離開頁面稍後回來查看。',
      reportGenerating: '正在生成診斷報告，請稍候…',
      reportBody: '診斷報告正文',
      reportEmpty: '報告正文為空',
      generateSuccess: '已創建診斷任務，正在準備數據',
      retryCount: '{count} / {max}',
    },
    structured: {
      channelAnalysis: '渠道分析',
      roomTypeAnalysis: '房型分析',
      commentAnalysis: '评论分析',
      marketAnalysis: '市场/商圈热度',
      momLabel: '环比：',
      yoyLabel: '同比：',
      dayMomLabel: '環比：',
      dayYoyLabel: '週同比：',
      weekMomLabel: '環比：',
      weekYoyLabel: '月同比：',
      monthMomLabel: '環比：',
      monthYoyLabel: '同比：',
      channel: '渠道',
      revenue: '营收',
      roomNight: '间夜',
      channelShare: '渠道占比',
      roomTypeName: '房型名称',
      totalRooms: '总房数',
      soldRoomNights: '出租间夜数',
      totalRoomRevenue: '总房费',
      occupancyRate: '出租率',
      averageRoomRate: '平均房价',
      disabledRooms: '停用数',
      commentType: '评价类型',
      count: '数量',
      share: '占比',
      goodMediumBad: '好/中/差',
      goodRate: '好评占比',
      eventName: '事件名称',
      eventFallback: '事件',
      summaryAnalysis: '综合分析',
      goodComment: '好评',
      mediumComment: '中评',
      badComment: '差评',
      channelRevenueChart: '渠道营收',
      roomTypeRevenueChart: '房型营收',
    },
    revenueManager: {
      pageTitle: '收益管家',
      adviceTitle: 'AI经营建议',
      pendingCount: '{count}条待处理',
      trafficTitle: '流量监控',
      trafficSubtitle: 'AI预测 · 实时更新',
      selectDate: '选择日期',
      todayShortcut: '今天',
      allDay: '全天',
      timeLabel: '时间',
      storeTrafficLabel: '本店流量',
      orderLabel: '订单',
      orderCount: '{count}单',
      summaryNote: '{channel}渠道 · 更新于 {time}',
      forecastLabel: '全天预测（AI模型）',
      meituanForecast: '美团预测流量',
      ctripForecast: '携程预测流量',
      allDayVisit: '全天访问量',
      occLabel: '出租率',
      roomNightLabel: '间夜',
      revenueLabel: '营业额',
      analysisTag: 'AI 分析',
      defaultStrategyTag: '定价策略',
      collapse: '收起',
      expandMore: '展开更多',
      badReviewLoading: '正在加载差评回复内容...',
      badReviewReply: '差评回复',
      badReviewEmpty: '暂无可展示的差评回复内容',
      realtimeTitle: '实时经营概览',
      revenueForecastTitle: '收益预测（{range}）',
      occForecastTitle: '出租率预测（{range}）',
      aiForecastBadge: 'AI预测',
      todayForecast: '今日预测{value}',
      peakLabel: '峰值',
      channelMeituan: '美团',
      channelCtrip: '携程',
      hours1: '近1小时',
      hours3: '近3小时',
      hours5: '近5小时',
      hours12: '近12小时',
      yesterdayValue: '昨日 {value}',
      futureSevenDays: '未来7天',
      dailyAdviceTitle: '{date} 当日AI建议',
      allDayAdviceTitle: '全天AI建议',
      hoursAdviceTitle: '近{hours}小时AI建议',
      adrForecastLabel: 'ADR预测',
      defaultAdviceDetail: '建议根据当前需求情况动态调整房价与投放策略。',
      displayDate: '{year}年{month}月{day}日',
      roomNightValue: '{count}间',
      revenueInsightCollapse: '收起 AI 收益推導說明',
      revenueInsightExpand: '展開 AI 收益推導說明',
      forecastForDate: '{date}預測{value}',
      revenueInsightTitle: 'AI 收益推導說明',
      revenueInsightJudgment: '收益判斷',
      revenueInsightKeySteps: '關鍵推導',
      revenueInsightRisks: '風險提示',
      revenueInsightRecommendations: '經營建議',
      metricTips: {
        traffic: {
          meituan: { title: '美團流量說明', p1: '美團流量表示所選時間範圍內，美團渠道帶來的本店訪問表現。', p2: '系統結合歷史經營、近期走勢、當天已發生訪問和節假日等因素綜合展示。', p3: '適合判斷分時趨勢與異常波動，不等同於全天最終累計值。' },
          ctrip: { title: '攜程流量說明', p1: '攜程流量表示所選時間範圍內，攜程渠道帶來的本店訪問表現。', p2: '系統參考歷史同類日期、近期渠道表現、當天即時變化和節假日因素綜合展示。', p3: '建議結合訂單變化判斷流量是否有效轉化為預訂。' },
          order: { title: '訂單說明', p1: '訂單表示目前渠道、日期和時間範圍內產生的訂單變化。', p2: '該指標反映即時預訂轉化情況，並結合目前篩選條件展示。', p3: '短時波動較大時，建議結合全天預測和歷史經營表現判斷。' },
        },
        hotelForecast: {
          meituan: { title: '美團預測流量說明', p1: '美團預測流量表示對美團渠道當天整體訪問量的預估。', p2: '系統依據歷史流量、近期渠道變化、當天表現、節假日和經營節奏綜合判斷。', p3: '適合提前判斷客源熱度，輔助價格、房量和營運安排。' },
          ctrip: { title: '攜程預測流量說明', p1: '攜程預測流量表示對攜程渠道當天整體訪問量的預估。', p2: '系統依據歷史同類日期、近期走勢、當天即時表現和節假日因素綜合判斷。', p3: '適合觀察潛在需求強弱，並與美團預測流量進行對比。' },
          occ: { title: '出租率說明', p1: '出租率表示當天客房售出比例的預測。', p2: '系統結合歷史出租率、近期預訂節奏、當天流量訂單和節假日因素綜合判斷。', p3: '適合判斷入住壓力、餘房風險及調價促銷方向。' },
          roomNights: { title: '間夜說明', p1: '間夜表示當天可能售出的房晚數量預測。', p2: '系統參考歷史售賣、近期訂單節奏、當天流量訂單與節假日因素綜合判斷。', p3: '應與出租率結合，用於判斷房量消化速度。' },
          adr: { title: 'ADR說明', p1: 'ADR表示當天已售客房平均房價的預測。', p2: '系統依據歷史價格、近期成交、當天需求與節假日因素綜合判斷。', p3: '應與出租率、營業額一起看，避免只追求入住率。' },
          revenue: { title: '營業額說明', p1: '營業額表示當天客房銷售收入的預測。', p2: '系統綜合預測間夜、預測ADR、歷史經營、近期需求和節假日因素判斷。', p3: '適合判斷經營結果是否達標及收益提升空間。' },
        },
        futureRevenue: { title: '收益預測說明', p1: '收益預測表示未來7天每日客房營業額的預測。', p2: '系統綜合歷史經營、近期預訂、流量訂單、當天表現和節假日因素判斷。', p3: '適合識別高低峰日期並安排價格、房量與營運策略。' },
        occRevenue: { title: '出租率預測說明', p1: '出租率預測表示未來7天每日客房售出比例的預測。', p2: '系統參考歷史出租率、近期預訂、渠道流量、訂單、當天變化和節假日因素判斷。', p3: '適合提前識別滿房或入住不足風險，並制定調價促銷計劃。' },
      },
    },
  },
  route: {
    ai: 'AI',
    aiRevenueManager: '收益管家',
    aiSmartPricing: '智能定价',
    aiNoticeCenter: '消息通知',
    aiStoreManagerReport: '店长报告',
    aiStoreDiagnosis: '門店診斷',
    aiNoticeDetail: '通知詳情',
    aiConfig: 'AI Configuration',
    businessLog: '營業日變更日誌',
    nightAuditLog: '夜審日誌',
    turnoverSubmit: '營業收入上繳',
    channelConfig: '渠道配置',
  },
  systemsetNotice: {
    systemMessageReminder: '系統消息提醒',
    messageReminderSettingsAtLeastOneItem: '消息提醒設定（至少選擇一項）',
    hourlyRoomCheckoutMessage: '鐘點房退房消息',
    fullDayCheckoutMessage: '全日房退房消息',
    messageVoiceReminder: '消息語音提醒',
    onlineChannelNewOrderReminder: '線上渠道新訂單提醒',
    onlineChannelOrderCancellationReminder: '線上渠道訂單取消提醒',
    hourlyRoomCheckoutReminder: '鐘點房退房提醒',
    fullDayCheckoutReminder: '全日房退房提醒',
    operationFailed: '操作失敗',
    thirtyMinutesBeforeCheckout: '退房前30分鐘',
    fifteenMinutesBeforeCheckout: '退房前15分鐘',
    atCheckoutTime: '退房時',
    checkoutTimeUpdated: '退房提醒時間修改成功',
    voiceSettingUpdated: '語音提醒狀態修改成功',
  },
  binding: {
    publicAccountMessageReminder: '公眾號消息提醒',
    scanToBindUser: '掃碼綁定人員',
    cancelEdit: '取消編輯',
    allMembers: '全部成員',
    scanToBindTitle: '掃碼綁定公眾號',
    scanWithWechat: '請使用微信掃碼綁定',
    qrCodeGenerateFail: '二維碼生成失敗，請稍後重試',
    unbindSuccess: '解除綁定成功！',
    unbindFail: '解除綁定失敗，請重試',
    confirmCloseQrDialog: '確定關閉二維碼彈窗？',
    orderCreate: '新訂單',
    orderCancel: '訂單取消',
    orderConfirm: '訂單待確認',
    orderCheckOutTip: '退房前',
    orderCheckOut: '退房',
    orderCreateEbk: 'EBK新訂單',
    orderCancelEbk: 'EBK訂單取消',
    roomCleanDone: '房間打掃完成',
    ebAccountOffline: 'EB賬號掉線',
    computerHardwareOffline: '電腦硬件掉線',
    ebWarnNotice: '爆房预警',
  },
  writeDoorCardIndex: {
    preIssuedDoorCard: '預製門卡',
    effectiveTime: '生效時間',
    expiryTime: '失效時間',
    viewPassword: '查看密碼',
    passwordStatusNotSent: '未發送',
    passwordStatusSending: '發送中',
    passwordStatusSent: '發送成功',
    passwordStatusFailed: '發送失敗',
    generatePasswordOnly: '僅生成密碼',
    generateAndSendPassword: '生成並發送密碼',
    getLockInfoFailed: '獲取房間門鎖資訊失敗',
    makeCardFailedPrefix: '製卡失敗：',
    deactivateFailedPrefix: '註銷卡失敗：',
    pleaseEnterValidPhoneNumber: '請輸入正確的手機號',
    passwordSendSuccess: '密碼發送成功',
    roomPasswordGeneratedAndSent: '房間密碼已生成並發送給客人，請提醒客人留意簡訊獲取開門密碼',
    roomPasswordGenerated: '房間密碼已生成',
    invalidTimeString: '無效的時間字串',
    temporaryMakeCard: '臨時製卡',
    validDoorCard: '當前有效門卡',
    makeCardLogTitle: '製卡記錄',
    makeType: '製卡類型',
    operationResult: '操作結果',
    createTime: '創建時間',
  },
  operating: {
    total: '總計',
    index: '序號',
    businessDay: '營業日',
    totalAccount: '總帳',
    totalOcc: '總出租率(%)',
    fullDayOcc: '全日房出租率(%)',
    hourDayOcc: '鐘點房出租率(%)',
    avgPrice: '平均房價(元)',
    revPar: '總REVPAR(元)',
    totalRoomNight: '出租總間夜(間)',
    fullDayRoomNight: '全日房間夜(間)',
    busLongRoomNight: '長包房間夜(間)',
    hourRoomNight: '鐘點房間夜(間)',
    teamRoomNight: '團隊房間夜(間)',
    freeRoomNight: '免費房間夜(間)',
    privateRoomNight: '自用房間夜(間)',
    houseRent: '總房費(元)',
    smallGoods: '小商品(元)',
    meals: '餐費(元)',
    serviceFee: '服務費(元)',
    memberFee: '會員費(元)',
    otherFee: '其他費用(元)',
    generalIncome: '營業總收入(元)',
    roomNight: '間夜數(間)',
    avgRoomPrice: '平均房價(元)',
    totalHouseRent: '房費合計(元)',
    rentalRate: '出租率(%)',
    roomNightProportion: '間夜佔比(%)',
    calcFormula: '計算公式',
    known: '知道了',
  },
  incomeIncomesum: {
    pleaseCheckTheStartAndEndTimesOfTheSearch: '請檢查搜尋的起止時間',
    roomRateIncome: '房費收入',
    smallwareIncome: '小商品收入',
    mealFeeIncome: '餐費收入',
    reportTitle: '收入匯總表',
    cooperationModel: '合作模式',
    status: '新簽／換簽',
    roomsCount: '物理房間數',
    startBusiness: '開業時間',
  },
  commonImportDialog: {
    tip: '請按照模版中的要求整理資訊',
    downloadTemplate: '下載模版',
    removeFileConfirm: '確定移除',
    limitOneFile: '當前限制選擇 1 個文件，請移除再添加',
    uploadError: '上傳失敗，請重試',
    reupload: '重新上傳',
  },

  orderAntiflyRoom: {
    powerOnTime: '開燈時間',
    powerOffTime: '關燈時間',
    isAntifly: '是否飛房',
    powerDuration: '持續時間',
  },
  roomOccupiedDetail: {
    title: '佔房明細',
    unassigned: '未排房',
    roomOrderNo: '房單號',
    roomType: '房型',
    roomNo: '房間號',
    contact: '聯絡人',
    roomCount: '房間數',
    arrival: '預抵',
    departure: '預離',
    orderAndPayStatus: '訂單狀態（支付狀態）',
    unpaidOrderNotAllowed: '未支付訂單不可操作',
    invalidRoomOrderOperation: '未支付、待入住、未排房的房單不可操作',
  },
  hardware: {
    smartRoomControl: '智能客控',
    smartRoomControlDesc: '支援遠端控制房間內的智能設備',
    smartRoomControlSetting: '智能客控設定',
    appKey: 'appKey',
    appKeyPlaceholder: '請輸入 appKey',
    appSecret: 'appSecret',
    appSecretPlaceholder: '請輸入 appSecret',
    thirdHotel: '第三方酒店',
    thirdHotelPlaceholder: '請輸入第三方酒店',
    thirdGroup: '第三方集團',
    thirdGroupPlaceholder: '請輸入第三方集團',
    enable: '開啟',
    disable: '關閉',
    deviceType: '設備類型',
    fullDayAutoOff: '全日房到預離時間自動断电',
    hourAutoOff: '钟点房到預離時間自動断电',
  },
  lockpwd: {
    makeCardLogTitle: '製作門卡記錄日誌',
    operationType: '操作類型',
    operationTime: '操作時間',
    makeCard: '製卡',
    cancelCard: '註銷卡',
    roomTypeCode: '房型編碼',
    roomTypeName: '房型名稱',
    roomNumber: '房間號',
    lockBrandName: '門鎖品牌名稱',
    lockId: '門鎖ID',
    orderRoomNo: '房單號',
    operator: '操作人',
    makeType: '製卡類型',
    validPeriod: '製卡有效期',
    operationResult: '操作結果',
    errorMessage: '失敗資訊',
  },
  roomType: {
    createBundleRoomType: '新增包棟房型',
    roomTypeName: '房型名稱',
    relatedRoomTypes: '關聯房型',
    relateRoom: '關聯房間',
    selectedRooms: '已選房間',
  },
  turnoverSubmit: {
    summaryLoadFailed: '錢櫃數據加載失敗，當前頁面已禁止操作。',
    reload: '重新加載',
    initBeforeUse: '首次使用前請先初始化當前錢櫃各項餘額。',
    initCashier: '初始化錢櫃',
    submitManage: '上繳管理',
    summaryTipPrefix: '註：這裡統計的消費與結算為',
    to: '至',
    summaryTipSuffix: '的數據',
    consumeSubject: '消費科目',
    paymentSubject: '付款科目',
    serialNumber: '序號',
    subtotal: '小計',
    subject: '科目',
    amount: '金額',
    dataSummary: '數據匯總',
    lastBalanceSummary: '上期錢櫃結存：{total} = 現金({cash}) + 銀行卡({bankCard}) + 其他({other})',
    currentAmountSummary: '當前錢櫃金額：{total} = 現金({cash}) + 銀行卡({bankCard}) + 其他({other})',
    currentCash: '當前錢櫃現金：',
    currentBankCard: '當前錢櫃銀行卡：',
    currentOther: '當前錢櫃其它項：',
    submitCash: '上繳現金',
    submitBankCard: '上繳銀行卡',
    submitOther: '上繳其它項',
    cashBalance: '錢櫃現金餘額：',
    bankCardBalance: '錢櫃銀行卡餘額：',
    otherBalance: '錢櫃其它項餘額：',
    remark: '備註：',
    submit: '上繳',
    submitHistory: '上繳歷史查詢',
    submitTime: '上繳時間',
    startDate: '開始日期',
    endDate: '結束日期',
    operator: '操作員',
    pleaseEnter: '請輸入',
    search: '查詢',
    export: '導出',
    lastCashierBalance: '上期錢櫃餘額',
    cash: '現金',
    bankCard: '銀行卡',
    other: '其他',
    currentCashierAmount: '本期錢櫃金額',
    currentSubmitAmount: '本期上繳金額',
    currentCashierBalance: '本期錢櫃餘額',
    initTipLine1: '請按當前實際錢櫃金額填寫。',
    initTipLine2: '初始化完成後將生成一條備註為【初始化數據】的歷史記錄。',
    currentCashierCash: '當前錢櫃現金',
    currentCashierBankCard: '當前錢櫃銀行卡',
    currentCashierOther: '當前錢櫃其它項',
    skipInit: '暫不初始化',
    confirmInit: '確認初始化',
    pleaseEnterAmount: '請輸入金額',
    invalidAmountFormat: '金額格式不正確，最多保留兩位小數',
    notGreaterThanCurrentCash: '不能大於【當前錢櫃現金】',
    notGreaterThanCurrentBankCard: '不能大於【當前錢櫃銀行卡】',
    notGreaterThanCurrentOther: '不能大於【當前錢櫃其它項】',
    hotelHistoricalTotal: '酒店歷史累計',
    currentTime: '當前時間',
    initBalanceCannotBeNegative: '初始化餘額不能小於0',
    cashierInitSuccess: '錢櫃初始化成功',
    exportFailed: '導出失敗',
    checkSubmitAmount: '請檢查上繳金額是否正確',
    confirmSubmitMessage: '確認提交本次營業收入上繳記錄嗎？',
    tip: '提示',
    submitSuccess: '上繳成功',
    submitFailed: '上繳失敗',
    total: '合計',
    pushPriceLibrary: '推送價庫',
    pushPriceLibrarySuccess: '推送價庫成功',
    pushPriceLibraryFail: '推送價庫失敗',
  },
  channelConfig: {
    noChannelConfigData: '暫無渠道配置數據',
    directConnected: '已直連',
    notDirectConnected: '未直連',
    roomTypeMatch: '房型匹配',
    bindNewAccount: '綁定新賬號',
    openDirectConnection: '開通直連',
    meituanHomestayStore: '美團民宿門店',
    tujiaHomestayAccount: '途家民宿賬號',
    deleteAccount: '刪除賬號',
    noBoundAccount: '暫無綁定賬號',
    breakDirectConnection: '斷開直連',
    directConnectionStatus: '直連狀態',
    channelDiscount: '渠道折扣',
    channelCommission: '渠道佣金',
    qzCommission: '輕住佣金',
    meituanRoomType: '美團房型',
    meituanRoomTypeId: '美團房型ID',
    tujiaHouse: '途家房屋',
    tujiaHouseId: '途家房屋ID',
    meituanHomestay: '美團民宿',
    tujiaHomestay: '途家民宿',
    homestay: '民宿',
    goodsTypeNormal: '標準產品',
    goodsTypeFree: '免費房產品',
    goodsTypeOnlineHour: '線上鐘點房',
    goodsTypePresaleFullDay: '預售全日房',
    goodsTypePresaleHour: '預售鐘點房',
    fetchChannelConfigFail: '獲取渠道配置失敗',
    goodsTypePrefix: '產品類型{type}',
    openDirectSuccess: '開通直連成功',
    openDirectFail: '開通直連失敗',
    channelNotSupportRoomMatch: '該渠道暫不支持房型匹配',
    fetchRoomMatchFail: '獲取房型匹配數據失敗',
    pleaseSelectRoomType: '請選擇輕贏寶房型',
    pleaseSelectProduct: '請選擇輕贏寶產品',
    bindFail: '綁定失敗',
    confirmUnbindRoomType: '確定解綁該房型嗎？',
    unbindFail: '解綁失敗',
    channelNotSupportAccountBind: '該渠道暫不支持賬號綁定',
    bindAccountSuccess: '賬號綁定成功',
    bindAccountFail: '賬號綁定失敗',
    fetchAccountDetailFail: '獲取賬號詳情失敗',
    confirmDeleteAccount: '確定刪除該賬號嗎？',
    confirmBreakDirect: '確定斷開直連嗎？',
    breakDirectSuccess: '斷開直連成功',
    breakDirectFail: '斷開直連失敗',
    pushPriceLibrary: '推送90天價庫',
    pushPriceLibrarySuccess: '推送價庫成功',
    pushPriceLibraryFail: '推送價庫失敗',
    pushPriceLibrarySwitch: '推送價庫開關',
    pushSwitchOnSuccess: '推送開關已開啟',
    pushSwitchOffSuccess: '推送開關已關閉',
    pushSwitchChangeFail: '切換推送開關失敗',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: '價格來源', bookingHourOrderCountTitle: '分時段預訂訂單數', bookingHourOrderCountNoData: '暫無可用分時訂單資料', bookingHourOrderCountDateRange: '近7日 {start} 至 {end} ｜ 當天 {date}', bookingHourOrderCountDateOnly: '當天 {date}', bookingHourOrderCountSevenDay: '近7日累計訂單', bookingHourOrderCountToday: '今天訂單', bookingHourOrderUnit: '單', bookingHourOrderAxis: '訂單數', viewTodayReports: '查看當日報告', backToTodayReports: '返回當日報告', backToLatestReport: '返回最新報告', historyEmpty: '暫無該智能定價報告', todayReportTitle: '{date} 當日報告', pricingTime: '定價時間', reportTitle: '報告標題', pricingChannel: '定價渠道', viewDetail: '詳情', todayReportEmpty: '當日暫無已完成的房型定價報告',
  },
  commonBook: {
    commonBooking: '統一預訂', fitBooking: '散客預訂', longStayBooking: '長包房預訂', teamBooking: '團隊預訂', walkIn: '散客步入', ebkManualMove: 'EBK手工搬單',
    sourceType: '客源類型', externalChannel: '外部渠道', channelOrderNo: '渠道單號', arrivalTime: '入住時間', departureTime: '離店時間', retentionTime: '保留時間', stayDuration: '入住時長', days: '天數', contact: '聯絡人', contactPhone: '聯絡人電話', teamType: '團隊類型', teamName: '團隊名稱', contractNo: '合約編號',
    paymentInfo: '付款資訊', paymentMethod: '支付方式', amount: '金額', storedValueMember: '儲值會員', paymentCode: '支付驗證碼', remark: '備註', totalRooms: '房間數', stayDays: '入住天數', taxAmount: '稅價', roomPrice: '房價', totalPrice: '總價', submitBooking: '辦理預訂',
    addRoom: '增加房間', addRoomType: '新增房型', roomType: '房型', roomStatus: '房態', room: '房間', loading: '載入中', noAvailableRoomType: '暫無可選房型', noAvailableRoom: '無可選房間，請調整房型或房態', noValidRoomType: '暫無有效房型', selectedRoomCount: '已選房間：{count} 間，至少選擇1間', emptyClean: '空淨', emptyDirty: '空髒', selectRoomType: '請選擇房型',
    availableRooms: '可訂數', breakfast: '早餐', roomCount: '間數', bookedRoomCount: '預訂間數', walkInRoomCount: '入住間數', arrangeRoom: '排房', dailyPrice: '每日價格', unassignedRooms: '待排房 {count} 間', assignedRoom: '已排房 {room}', selectedRoom: '已選 {room}', delete: '刪除', to: '至', addGuest: '新增同住', channelRoomType: '渠道下單房型', currencyUnit: '元', tax: '稅',
    pleaseSelect: '請選擇', pleaseEnter: '請輸入', enterChannelName: '請輸入渠道名稱', cancel: '取消', confirm: '確定', close: '關閉', roomDetail: '房單詳情',
    selectSourceType: '請選擇客源類型', selectMemberInfo: '請選擇會員資訊', selectCompany: '請選擇協議單位', selectStayType: '請選擇入住類型', selectArrivalTime: '請選擇預抵時間', selectDepartureTime: '請選擇預離時間', enterContact: '請填寫聯絡人', selectTeamType: '請選擇團隊類型', enterTeamName: '請填寫團隊名稱',
    basePriceMode: '底價模式', sellingPriceMode: '賣價模式', useEbkOrderInfo: '使用EB訂單資訊', initializationFailed: '統一預訂初始化失敗，請關閉後重試', dictionaryLoadFailed: '預訂字典載入失敗', companyNotFound: '未查詢到相關協議單位資訊',
    minimumStayDays: '目前場景最少入住{count}天', maximumStayDays: '目前場景最多入住{count}天', retentionBeforeArrival: '保留時間不能早於入住時間', retentionTooLate: '保留時間不能晚於目前場景允許的最晚時間', retentionOutOfRange: '保留時間不在目前場景允許範圍內',
    invalidBreakfast: '{roomType}早餐數必須為0至999的整數且不能為空', invalidRoomCount: '{roomType}間數必須為非負整數且不能為空', enterExternalChannel: '請填寫外部渠道名稱', invalidHourDuration: '入住時長必須為1至12的整數小時', invalidStayDays: '目前場景入住天數必須為{min}至{max}的整數天', incompleteStay: '{roomType}存在不完整住期', arrivalBeforeBusinessDate: '{roomType}預抵日期不能早於目前營業日期', roomTypeStayRange: '{roomType}住期必須為1至{max}天', roomTypeDuplicateStay: '{roomType}不能新增重複住期',
    selectAtLeastOneRoomType: '請至少選擇一個可預訂房型', selectMember: '請選擇會員', missingProductOrPrice: '已選擇房型缺少商品或每日價格', roomCountExceedsAvailability: '已選擇房型的預訂間數超過目前可訂數', walkInRequiresRoom: '散客步入必須完成具體排房', guestRequiredPerRoom: '請為每個房間填寫入住人', completeGuestName: '請完整填寫入住人姓名', selectPaymentForDeposit: '收取押金時請選擇收款方式', selectMemberForStoredValue: '會員儲值支付請選擇會員', insufficientMemberBalance: '會員餘額為{balance}元，請選擇其他收款方式', enterStoredValueCode: '會員儲值支付請填寫支付驗證碼',
    bookingFailed: '預訂失敗，請調整後重試', bookingSuccess: '預訂成功', overOccupancyConfirmation: '入住人數超過房間最大入住人數，是否繼續辦理入住？', overOccupancyPromptTitle: '提示', walkInMissingMasterRoom: '散客步入成功，但未返回主房單號', checkInSuccess: '入住成功', createdWithoutOrderNo: '建立成功但未返回訂單號，請在財務頁面補錄收款', walkInWithoutMasterRoomForPayment: '入住成功但未返回主房單號，請在財務頁面補錄收款', onlinePaymentFailed: '線上收款請求失敗', paymentStatusFailed: '支付狀態查詢失敗',
    sameStayExists: '該房型已存在相同住期', departureAfterArrival: '預離時間必須晚於預抵時間', duplicateStayNotAllowed: '同一房型不能新增重複住期', selectUnaddedRoom: '請選擇未新增的房間', keepOneWalkInRoom: '散客步入至少保留1間房', ebkRoomCountMismatch: '預訂間數和渠道訂單間數不一致，是否繼續辦理預訂？', continueBooking: '繼續預定', modify: '修改',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: '價格來源', bookingHourOrderCountTitle: '分時段預訂訂單數', bookingHourOrderCountNoData: '暫無可用分時訂單資料', bookingHourOrderCountDateRange: '近7日 {start} 至 {end} ｜ 當天 {date}', bookingHourOrderCountDateOnly: '當天 {date}', bookingHourOrderCountSevenDay: '近7日累計訂單', bookingHourOrderCountToday: '今天訂單', bookingHourOrderUnit: '單', bookingHourOrderAxis: '訂單數', viewTodayReports: '查看當日報告', backToTodayReports: '返回當日報告', backToLatestReport: '返回最新報告', historyEmpty: '暫無該智能定價報告', todayReportTitle: '{date} 當日報告', pricingTime: '定價時間', reportTitle: '報告標題', pricingChannel: '定價渠道', viewDetail: '詳情', todayReportEmpty: '當日暫無已完成的房型定價報告',
  },

  inventoryPhase1: {
    itemType: '物品类型',
    itemSpec: '物品规格',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: '物品名稱',
    itemCode: '物品編碼',
    enterItemName: '輸入物品名稱',
    itemUnit: '規格單位',
    itemSort: '物品排序',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: '新建物品',
    modifyItem: '修改物品',
    warningQty: '预警数量',
    warningQtyLabel: '库存预警数量',
    salePoint: '销售点',
    scene: '使用场景',
    guestRoom: '客房',
    fnb: '餐饮',
    meeting: '会议',
    sceneSale: '支持售卖',
    sceneClean: '支持房间打扫添加',
    sceneBorrow: '支持借用',
    selectType: '请选择物品类型',
    selectSpec: '请选择物品规格',
    fillItemName: '请填写物品名称',
    selectSalePoint: '请至少选择一个销售点',
    warningCloseHint: '0表示关闭预警',
    inboundType: '入库方式',
    outboundType: '出库方式',
    manualInbound: '手工入库',
    sale: '商品售卖',
    roomClean: '房间打扫添加',
    roomBorrow: '房间借用',
    manualOutbound: '手工出库',
    newOutbound: '新增出庫',
    selectOutboundType: '請選擇出庫方式',
    createTime: '创建时间',
    catalogSource: '來源',
    groupCatalog: '集團底賬',
    hotelCatalog: '本店',
    groupCatalogCannotEdit: '集團底賬不能修改',
    groupCatalogCannotDelete: '集團底賬不能刪除',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: '可售卖',
    filterRoomClean: '房间打扫可添加',
    filterRoomBorrow: '可借用',
    availableSalePoint: '可用销售点',
    borrowReturn: '借用归还',
    saleVoid: '售卖冲账',
    sortOrder: '排序',
    fillWarningQty: '请填写库存预警数量',
    warningQtyInvalid: '库存预警数量须为不小于0的整数',
  },
  aiPmsCtripPeerSync: {
    ctrip: '攜程',
    account: '帳號',
    mobilePlaceholder: '請輸入手機號碼',
    code: '驗證碼',
    codePlaceholder: '請輸入驗證碼',
    login: '登入',
    resend: '重新發送',
    send: '發送驗證碼',
    collectFailed: '攜程競對價格採集失敗，請稍後重新整理。',
    dataFailed: '資料獲取失敗',
    relogin: '重新登入',
    unbind: '解除綁定',
    updatedAt: '資料更新時間：{time}',
    hotelName: '酒店名稱',
    price: '價格',
    empty: '暫無{channel}競對引流價資料',
    accountRequired: '請輸入攜程帳號',
    codeRequired: '請輸入短訊驗證碼',
    loggingIn: '正在登入，完成後將採集攜程競對價格',
    smsSent: '短訊驗證碼已發送，請輸入驗證碼',
    smsFailed: '短訊驗證碼發送失敗，請重新發送',
    verifyFailed: '短訊驗證碼驗證失敗，請重新輸入後登入',
    loginFailed: '攜程登入驗證失敗，請重新發送驗證碼後登入',
    deviceVerify: '攜程帳號需要完成裝置驗證，完成後可重新發送驗證碼登入',
    loginRequired: '請發送短訊驗證碼，重新登入攜程帳號',
    expired: '攜程帳號已失效，請登入',
    sending: '正在發送短訊驗證碼…',
    collecting: '登入完成，正在採集攜程競對價格…',
    today: '今天 {time}',
    daysAgo: '{days}天前',
    crawlSubmitted: '已提交攜程收藏酒店採集任務',
    smsSubmitted: '短訊驗證碼發送請求已提交',
    unbindConfirm: '確定解除目前攜程帳號的綁定嗎？歷史價格資料將保留。',
    unbindTitle: '解除攜程帳號綁定',
    unbound: '攜程帳號已解除綁定',
  },
};
